const hplcUVVisJcamp2 = `
##TITLE=multi_hplc.2_bagit
##JCAMP-DX=5.0
##DATA TYPE=LINK
##BLOCKS=1


$$ === CHEMSPECTRA SPECTRUM ORIG ===
##TITLE=multi_hplc.2_bagit
##JCAMP-DX=5.00
##DATA TYPE=HPLC UV/VIS SPECTRUM
##DATA CLASS=XYDATA
##$CSCATEGORY=SPECTRUM
##ORIGIN=
##OWNER=
##XUNITS=MINUTES
##YUNITS=TRANSMITTANCE
##XFACTOR=1.0
##YFACTOR=1.0
##FIRSTX=0.0
##LASTX=20.0
##MAXX=20.0
##MAXY=409.809016
##MINX=0.0
##MINY=-3.282643
##NPOINTS=6001
##XYDATA= (XY..XY)
0.0, 0.0
0.003333, -4.7e-05
0.006667, -0.000337
0.01, -0.001167
0.013333, -0.002606
0.016667, -0.004291
0.02, -0.005884
0.023333, -0.007674
0.026667, -0.010137
0.03, -0.013055
0.033333, -0.015608
0.036667, -0.01715
0.04, -0.017719
0.043333, -0.017879
0.046667, -0.01803
0.05, -0.018088
0.053333, -0.017823
0.056667, -0.017177
0.06, -0.016317
0.063333, -0.01545
0.066667, -0.014682
0.07, -0.014011
0.073333, -0.013292
0.076667, -0.012453
0.08, -0.011732
0.083333, -0.011392
0.086667, -0.011424
0.09, -0.011604
0.093333, -0.011664
0.096667, -0.011479
0.1, -0.01122
0.103333, -0.011158
0.106667, -0.011293
0.11, -0.01144
0.113333, -0.011403
0.116667, -0.010901
0.12, -0.009867
0.123333, -0.008805
0.126667, -0.008393
0.13, -0.008823
0.133333, -0.009607
0.136667, -0.010055
0.14, -0.009924
0.143333, -0.009401
0.146667, -0.00873
0.15, -0.00805
0.153333, -0.007429
0.156667, -0.006984
0.16, -0.006911
0.163333, -0.007222
0.166667, -0.007551
0.17, -0.007556
0.173333, -0.007477
0.176667, -0.007877
0.18, -0.008931
0.183333, -0.010221
0.186667, -0.011096
0.19, -0.011153
0.193333, -0.010489
0.196667, -0.009573
0.2, -0.008957
0.203333, -0.008942
0.206667, -0.009358
0.21, -0.009768
0.213333, -0.009954
0.216667, -0.00995
0.22, -0.009772
0.223333, -0.00948
0.226667, -0.009257
0.23, -0.009255
0.233333, -0.009407
0.236667, -0.009437
0.24, -0.009238
0.243333, -0.009097
0.246667, -0.009276
0.25, -0.009693
0.253333, -0.010294
0.256667, -0.011237
0.26, -0.01243
0.263333, -0.013367
0.266667, -0.013602
0.27, -0.013127
0.273333, -0.012242
0.276667, -0.011319
0.28, -0.010635
0.283333, -0.010137
0.286667, -0.009598
0.29, -0.008979
0.293333, -0.00835
0.296667, -0.007821
0.3, -0.007793
0.303333, -0.008756
0.306667, -0.01072
0.31, -0.013129
0.313333, -0.015162
0.316667, -0.016129
0.32, -0.015951
0.323333, -0.015157
0.326667, -0.014459
0.33, -0.014363
0.333333, -0.014846
0.336667, -0.015487
0.34, -0.015964
0.343333, -0.016227
0.346667, -0.016408
0.35, -0.016595
0.353333, -0.016637
0.356667, -0.016417
0.36, -0.016137
0.363333, -0.016101
0.366667, -0.016437
0.37, -0.017055
0.373333, -0.017734
0.376667, -0.018206
0.38, -0.018144
0.383333, -0.01735
0.386667, -0.016136
0.39, -0.015179
0.393333, -0.014852
0.396667, -0.015186
0.4, -0.016217
0.403333, -0.017777
0.406667, -0.019463
0.41, -0.020969
0.413333, -0.021958
0.416667, -0.022053
0.42, -0.021305
0.423333, -0.02013
0.426667, -0.018826
0.43, -0.017709
0.433333, -0.0174
0.436667, -0.018332
0.44, -0.020184
0.443333, -0.022186
0.446667, -0.023634
0.45, -0.024141
0.453333, -0.023792
0.456667, -0.023006
0.46, -0.02222
0.463333, -0.021817
0.466667, -0.022001
0.47, -0.022551
0.473333, -0.022954
0.476667, -0.022793
0.48, -0.021946
0.483333, -0.020709
0.486667, -0.019701
0.49, -0.019308
0.493333, -0.019324
0.496667, -0.019402
0.5, -0.019536
0.503333, -0.019853
0.506667, -0.020275
0.51, -0.020627
0.513333, -0.02093
0.516667, -0.021267
0.52, -0.021498
0.523333, -0.021447
0.526667, -0.021089
0.53, -0.0204
0.533333, -0.019363
0.536667, -0.018142
0.54, -0.016975
0.543333, -0.015917
0.546667, -0.014981
0.55, -0.014507
0.553333, -0.014972
0.556667, -0.016292
0.56, -0.017596
0.563333, -0.017811
0.566667, -0.016497
0.57, -0.014229
0.573333, -0.012099
0.576667, -0.010748
0.58, -0.010075
0.583333, -0.00978
0.586667, -0.009681
0.59, -0.00971
0.593333, -0.009927
0.596667, -0.010391
0.6, -0.011027
0.603333, -0.011587
0.606667, -0.011715
0.61, -0.011265
0.613333, -0.010492
0.616667, -0.00988
0.62, -0.009816
0.623333, -0.010302
0.626667, -0.011047
0.63, -0.011873
0.633333, -0.012763
0.636667, -0.013645
0.64, -0.014415
0.643333, -0.015042
0.646667, -0.015507
0.65, -0.015729
0.653333, -0.015585
0.656667, -0.01508
0.66, -0.014359
0.663333, -0.01333
0.666667, -0.011609
0.67, -0.0092
0.673333, -0.006788
0.676667, -0.005045
0.68, -0.004105
0.683333, -0.003969
0.686667, -0.004731
0.69, -0.006255
0.693333, -0.008079
0.696667, -0.009672
0.7, -0.010688
0.703333, -0.011031
0.706667, -0.010728
0.71, -0.00984
0.713333, -0.00847
0.716667, -0.006849
0.72, -0.005283
0.723333, -0.003825
0.726667, -0.00222
0.73, -0.000458
0.733333, 0.000989
0.736667, 0.001728
0.74, 0.001766
0.743333, 0.001364
0.746667, 0.000969
0.75, 0.00104
0.753333, 0.001716
0.756667, 0.002674
0.76, 0.003489
0.763333, 0.004146
0.766667, 0.004889
0.77, 0.005719
0.773333, 0.006289
0.776667, 0.006256
0.78, 0.005667
0.783333, 0.004868
0.786667, 0.004102
0.79, 0.003411
0.793333, 0.00276
0.796667, 0.00212
0.8, 0.001649
0.803333, 0.001656
0.806667, 0.002188
0.81, 0.002879
0.813333, 0.003334
0.816667, 0.003513
0.82, 0.003649
0.823333, 0.003924
0.826667, 0.004299
0.83, 0.004446
0.833333, 0.003981
0.836667, 0.003051
0.84, 0.002306
0.843333, 0.002201
0.846667, 0.002713
0.85, 0.003461
0.853333, 0.003886
0.856667, 0.00365
0.86, 0.00285
0.863333, 0.001655
0.866667, 0.000112
0.87, -0.001634
0.873333, -0.003279
0.876667, -0.004498
0.88, -0.005082
0.883333, -0.005024
0.886667, -0.004468
0.89, -0.003589
0.893333, -0.002547
0.896667, -0.001547
0.9, -0.000867
0.903333, -0.000729
0.906667, -0.001269
0.91, -0.002585
0.913333, -0.004582
0.916667, -0.006724
0.92, -0.008258
0.923333, -0.008873
0.926667, -0.009006
0.93, -0.009206
0.933333, -0.009453
0.936667, -0.009422
0.94, -0.009028
0.943333, -0.008466
0.946667, -0.008039
0.95, -0.008109
0.953333, -0.009006
0.956667, -0.010743
0.96, -0.01283
0.963333, -0.01456
0.966667, -0.015361
0.97, -0.015047
0.973333, -0.014144
0.976667, -0.01354
0.98, -0.013628
0.983333, -0.014259
0.986667, -0.01526
0.99, -0.016541
0.993333, -0.017978
0.996667, -0.019393
1.0, -0.020635
1.003333, -0.021683
1.006667, -0.022552
1.01, -0.023125
1.013333, -0.023263
1.016667, -0.023005
1.02, -0.022521
1.023333, -0.021932
1.026667, -0.021279
1.03, -0.020621
1.033333, -0.020171
1.036667, -0.020294
1.04, -0.021205
1.043333, -0.02263
1.046667, -0.023921
1.05, -0.024633
1.053333, -0.024794
1.056667, -0.024577
1.06, -0.024165
1.063333, -0.023927
1.066667, -0.024185
1.07, -0.024741
1.073333, -0.024986
1.076667, -0.024542
1.08, -0.023661
1.083333, -0.022889
1.086667, -0.02252
1.09, -0.022509
1.093333, -0.022679
1.096667, -0.022894
1.1, -0.023028
1.103333, -0.02289
1.106667, -0.022489
1.11, -0.022192
1.113333, -0.022298
1.116667, -0.022683
1.12, -0.022942
1.123333, -0.022734
1.126667, -0.022075
1.13, -0.021345
1.133333, -0.020887
1.136667, -0.020625
1.14, -0.020199
1.143333, -0.019246
1.146667, -0.017556
1.15, -0.015306
1.153333, -0.013064
1.156667, -0.01131
1.16, -0.010056
1.163333, -0.009065
1.166667, -0.008305
1.17, -0.007815
1.173333, -0.007336
1.176667, -0.00657
1.18, -0.00557
1.183333, -0.004684
1.186667, -0.00432
1.19, -0.004655
1.193333, -0.005458
1.196667, -0.006296
1.2, -0.006751
1.203333, -0.006484
1.206667, -0.005406
1.21, -0.003877
1.213333, -0.002513
1.216667, -0.001647
1.22, -0.001056
1.223333, -0.000339
1.226667, 0.000545
1.23, 0.001277
1.233333, 0.001579
1.236667, 0.001502
1.24, 0.001434
1.243333, 0.00169
1.246667, 0.002096
1.25, 0.002249
1.253333, 0.001949
1.256667, 0.001253
1.26, 0.000388
1.263333, -0.000461
1.266667, -0.00135
1.27, -0.002417
1.273333, -0.003576
1.276667, -0.004404
1.28, -0.004531
1.283333, -0.004211
1.286667, -0.004173
1.29, -0.004896
1.293333, -0.006415
1.296667, -0.008551
1.3, -0.010927
1.303333, -0.012989
1.306667, -0.014279
1.31, -0.014762
1.313333, -0.014785
1.316667, -0.014671
1.32, -0.014435
1.323333, -0.01385
1.326667, -0.012748
1.33, -0.011344
1.333333, -0.01011
1.336667, -0.009356
1.34, -0.009195
1.343333, -0.009589
1.346667, -0.010231
1.35, -0.010806
1.353333, -0.011392
1.356667, -0.012363
1.36, -0.013853
1.363333, -0.01547
1.366667, -0.016865
1.37, -0.018284
1.373333, -0.020128
1.376667, -0.022405
1.38, -0.024862
1.383333, -0.027265
1.386667, -0.029411
1.39, -0.03108
1.393333, -0.032223
1.396667, -0.03318
1.4, -0.034309
1.403333, -0.035509
1.406667, -0.036515
1.41, -0.037268
1.413333, -0.037758
1.416667, -0.037987
1.42, -0.038088
1.423333, -0.038201
1.426667, -0.038386
1.43, -0.038585
1.433333, -0.038532
1.436667, -0.038068
1.44, -0.037647
1.443333, -0.038019
1.446667, -0.039494
1.45, -0.041768
1.453333, -0.044216
1.456667, -0.046165
1.46, -0.047116
1.463333, -0.046892
1.466667, -0.045665
1.47, -0.043993
1.473333, -0.042675
1.476667, -0.042132
1.48, -0.042154
1.483333, -0.042463
1.486667, -0.042948
1.49, -0.043349
1.493333, -0.043204
1.496667, -0.0423
1.5, -0.041022
1.503333, -0.039969
1.506667, -0.039322
1.51, -0.03887
1.513333, -0.038521
1.516667, -0.038474
1.52, -0.038928
1.523333, -0.039774
1.526667, -0.040574
1.53, -0.040898
1.533333, -0.040678
1.536667, -0.040169
1.54, -0.039729
1.543333, -0.03961
1.546667, -0.039707
1.55, -0.039666
1.553333, -0.039273
1.556667, -0.038478
1.56, -0.037248
1.563333, -0.035749
1.566667, -0.034427
1.57, -0.033607
1.573333, -0.033164
1.576667, -0.03276
1.58, -0.032277
1.583333, -0.031675
1.586667, -0.030718
1.59, -0.029357
1.593333, -0.028061
1.596667, -0.027223
1.6, -0.026537
1.603333, -0.025307
1.606667, -0.023163
1.61, -0.02041
1.613333, -0.017764
1.616667, -0.015861
1.62, -0.015027
1.623333, -0.015154
1.626667, -0.01567
1.63, -0.01595
1.633333, -0.015872
1.636667, -0.015824
1.64, -0.016031
1.643333, -0.016218
1.646667, -0.016236
1.65, -0.016378
1.653333, -0.016752
1.656667, -0.016991
1.66, -0.016752
1.663333, -0.016169
1.666667, -0.0157
1.67, -0.015645
1.673333, -0.015897
1.676667, -0.016077
1.68, -0.015812
1.683333, -0.014988
1.686667, -0.013781
1.69, -0.012514
1.693333, -0.011402
1.696667, -0.010447
1.7, -0.009873
1.703333, -0.010312
1.706667, -0.011954
1.71, -0.014002
1.713333, -0.01551
1.716667, -0.016221
1.72, -0.016432
1.723333, -0.016555
1.726667, -0.016755
1.73, -0.016949
1.733333, -0.017231
1.736667, -0.017777
1.74, -0.018326
1.743333, -0.018439
1.746667, -0.018033
1.75, -0.017226
1.753333, -0.016156
1.756667, -0.015153
1.76, -0.014597
1.763333, -0.014689
1.766667, -0.015529
1.77, -0.017126
1.773333, -0.019307
1.776667, -0.021796
1.78, -0.024267
1.783333, -0.026297
1.786667, -0.027572
1.79, -0.028291
1.793333, -0.029052
1.796667, -0.030161
1.8, -0.031235
1.803333, -0.031567
1.806667, -0.030792
1.81, -0.029261
1.813333, -0.027746
1.816667, -0.02683
1.82, -0.02674
1.823333, -0.027526
1.826667, -0.028902
1.83, -0.030198
1.833333, -0.030861
1.836667, -0.030954
1.84, -0.031141
1.843333, -0.032085
1.846667, -0.033691
1.85, -0.035214
1.853333, -0.036067
1.856667, -0.036192
1.86, -0.035807
1.863333, -0.035136
1.866667, -0.034484
1.87, -0.03434
1.873333, -0.034948
1.876667, -0.035935
1.88, -0.036718
1.883333, -0.037023
1.886667, -0.036934
1.89, -0.036744
1.893333, -0.036733
1.896667, -0.036897
1.9, -0.036947
1.903333, -0.036548
1.906667, -0.035597
1.91, -0.034361
1.913333, -0.033242
1.916667, -0.032545
1.92, -0.032465
1.923333, -0.033021
1.926667, -0.033898
1.93, -0.034499
1.933333, -0.034388
1.936667, -0.033674
1.94, -0.032714
1.943333, -0.03164
1.946667, -0.030313
1.95, -0.028608
1.953333, -0.026764
1.956667, -0.025546
1.96, -0.025862
1.963333, -0.027798
1.966667, -0.030129
1.97, -0.031381
1.973333, -0.031209
1.976667, -0.030457
1.98, -0.03019
1.983333, -0.03082
1.986667, -0.032063
1.99, -0.033452
1.993333, -0.034616
1.996667, -0.035349
2.0, -0.035624
2.003333, -0.035413
2.006667, -0.034684
2.01, -0.03368
2.013333, -0.032949
2.016667, -0.032955
2.02, -0.033586
2.023333, -0.034201
2.026667, -0.034416
2.03, -0.034448
2.033333, -0.03452
2.036667, -0.034576
2.04, -0.034546
2.043333, -0.034487
2.046667, -0.03467
2.05, -0.035518
2.053333, -0.037267
2.056667, -0.039726
2.06, -0.042287
2.063333, -0.044311
2.066667, -0.045613
2.07, -0.046472
2.073333, -0.047277
2.076667, -0.04828
2.08, -0.049583
2.083333, -0.051177
2.086667, -0.052913
2.09, -0.05462
2.093333, -0.056269
2.096667, -0.057795
2.1, -0.058992
2.103333, -0.059837
2.106667, -0.060552
2.11, -0.061288
2.113333, -0.062188
2.116667, -0.063489
2.12, -0.065219
2.123333, -0.067218
2.126667, -0.069464
2.13, -0.071932
2.133333, -0.07434
2.136667, -0.076305
2.14, -0.077712
2.143333, -0.078791
2.146667, -0.079674
2.15, -0.080128
2.153333, -0.07997
2.156667, -0.079382
2.16, -0.078741
2.163333, -0.07851
2.166667, -0.07917
2.17, -0.081049
2.173333, -0.084095
2.176667, -0.087632
2.18, -0.09051
2.183333, -0.091864
2.186667, -0.091708
2.19, -0.090673
2.193333, -0.089415
2.196667, -0.08823
2.2, -0.087068
2.203333, -0.086131
2.206667, -0.086003
2.21, -0.086753
2.213333, -0.087472
2.216667, -0.087077
2.22, -0.085235
2.223333, -0.0824
2.226667, -0.079324
2.23, -0.076642
2.233333, -0.07467
2.236667, -0.073506
2.24, -0.07308
2.243333, -0.072969
2.246667, -0.072543
2.25, -0.071455
2.253333, -0.069828
2.256667, -0.067967
2.26, -0.066057
2.263333, -0.064207
2.266667, -0.062664
2.27, -0.061697
2.273333, -0.061288
2.276667, -0.061118
2.28, -0.06087
2.283333, -0.060452
2.286667, -0.059762
2.29, -0.058528
2.293333, -0.056631
2.296667, -0.054269
2.3, -0.051712
2.303333, -0.049156
2.306667, -0.046844
2.31, -0.045087
2.313333, -0.044039
2.316667, -0.04345
2.32, -0.042701
2.323333, -0.041363
2.326667, -0.039538
2.33, -0.037486
2.333333, -0.035367
2.336667, -0.03341
2.34, -0.032008
2.343333, -0.031364
2.346667, -0.031055
2.35, -0.03036
2.353333, -0.028971
2.356667, -0.027038
2.36, -0.024857
2.363333, -0.022797
2.366667, -0.021219
2.37, -0.020276
2.373333, -0.019815
2.376667, -0.019462
2.38, -0.01886
2.383333, -0.017927
2.386667, -0.016991
2.39, -0.016658
2.393333, -0.017252
2.396667, -0.01836
2.4, -0.019176
2.403333, -0.019407
2.406667, -0.019351
2.41, -0.019109
2.413333, -0.018597
2.416667, -0.018095
2.42, -0.017961
2.423333, -0.018172
2.426667, -0.018427
2.43, -0.018429
2.433333, -0.017955
2.436667, -0.016959
2.44, -0.015824
2.443333, -0.015245
2.446667, -0.015693
2.45, -0.016935
2.453333, -0.018192
2.456667, -0.018964
2.46, -0.019303
2.463333, -0.019156
2.466667, -0.018123
2.47, -0.01605
2.473333, -0.013476
2.476667, -0.011406
2.48, -0.01066
2.483333, -0.011413
2.486667, -0.01325
2.49, -0.015468
2.493333, -0.017303
2.496667, -0.018172
2.5, -0.017923
2.503333, -0.016887
2.506667, -0.015583
2.51, -0.014421
2.513333, -0.013659
2.516667, -0.013424
2.52, -0.013664
2.523333, -0.014097
2.526667, -0.014508
2.53, -0.015165
2.533333, -0.016345
2.536667, -0.01761
2.54, -0.018306
2.543333, -0.018391
2.546667, -0.018315
2.55, -0.018398
2.553333, -0.018404
2.556667, -0.017958
2.56, -0.017282
2.563333, -0.017066
2.566667, -0.017718
2.57, -0.019066
2.573333, -0.020626
2.576667, -0.021913
2.58, -0.022666
2.583333, -0.022983
2.586667, -0.023052
2.59, -0.022744
2.593333, -0.021837
2.596667, -0.020544
2.6, -0.019432
2.603333, -0.018951
2.606667, -0.01916
2.61, -0.019696
2.613333, -0.019986
2.616667, -0.019697
2.62, -0.01902
2.623333, -0.018407
2.626667, -0.01828
2.63, -0.018961
2.633333, -0.020544
2.636667, -0.022917
2.64, -0.02607
2.643333, -0.030191
2.646667, -0.035472
2.65, -0.042025
2.653333, -0.049884
2.656667, -0.058814
2.66, -0.067976
2.663333, -0.075944
2.666667, -0.081376
2.67, -0.083664
2.673333, -0.082855
2.676667, -0.079286
2.68, -0.073494
2.683333, -0.066104
2.686667, -0.05761
2.69, -0.048441
2.693333, -0.039177
2.696667, -0.030488
2.7, -0.022802
2.703333, -0.016197
2.706667, -0.010625
2.71, -0.006004
2.713333, -0.002363
2.716667, -7.2e-05
2.72, 0.000575
2.723333, -0.00023
2.726667, -0.002368
2.73, -0.006138
2.733333, -0.011599
2.736667, -0.018084
2.74, -0.024916
2.743333, -0.032458
2.746667, -0.041972
2.75, -0.054426
2.753333, -0.069602
2.756667, -0.086313
2.76, -0.103288
2.763333, -0.119723
2.766667, -0.135066
2.77, -0.148736
2.773333, -0.160341
2.776667, -0.170276
2.78, -0.180117
2.783333, -0.192616
2.786667, -0.211405
2.79, -0.240496
2.793333, -0.283856
2.796667, -0.345122
2.8, -0.427313
2.803333, -0.532427
2.806667, -0.660896
2.81, -0.811439
2.813333, -0.981464
2.816667, -1.167274
2.82, -1.364133
2.823333, -1.567089
2.826667, -1.77217
2.83, -1.976713
2.833333, -2.178966
2.836667, -2.377869
2.84, -2.573035
2.843333, -2.763904
2.846667, -2.947123
2.85, -3.112237
2.853333, -3.236566
2.856667, -3.282643
2.86, -3.203967
2.863333, -2.961862
2.866667, -2.547328
2.87, -1.993923
2.873333, -1.371125
2.876667, -0.761492
2.88, -0.234692
2.883333, 0.169439
2.886667, 0.44362
2.89, 0.604514
2.893333, 0.68012
2.896667, 0.699208
2.9, 0.685225
2.903333, 0.654505
2.906667, 0.61703
2.91, 0.57787
2.913333, 0.538689
2.916667, 0.499457
2.92, 0.459632
2.923333, 0.418614
2.926667, 0.376198
2.93, 0.332871
2.933333, 0.289538
2.936667, 0.247247
2.94, 0.207087
2.943333, 0.16991
2.946667, 0.136049
2.95, 0.10563
2.953333, 0.079121
2.956667, 0.057213
2.96, 0.040245
2.963333, 0.028012
2.966667, 0.019992
2.97, 0.01547
2.973333, 0.013834
2.976667, 0.015147
2.98, 0.01999
2.983333, 0.028542
2.986667, 0.040205
2.99, 0.054082
2.993333, 0.069385
2.996667, 0.085367
3.0, 0.10112
3.003333, 0.115512
3.006667, 0.127254
3.01, 0.134873
3.013333, 0.136936
3.016667, 0.132693
3.02, 0.122394
3.023333, 0.107195
3.026667, 0.08893
3.03, 0.069601
3.033333, 0.050919
3.036667, 0.03422
3.04, 0.020436
3.043333, 0.009747
3.046667, 0.001445
3.05, -0.005261
3.053333, -0.010507
3.056667, -0.014097
3.06, -0.016118
3.063333, -0.017062
3.066667, -0.017415
3.07, -0.017237
3.073333, -0.016308
3.076667, -0.014548
3.08, -0.012167
3.083333, -0.009578
3.086667, -0.00719
3.09, -0.005123
3.093333, -0.003274
3.096667, -0.001879
3.1, -0.001681
3.103333, -0.003261
3.106667, -0.006512
3.11, -0.010868
3.113333, -0.01576
3.116667, -0.020735
3.12, -0.025294
3.123333, -0.028813
3.126667, -0.030861
3.13, -0.031567
3.133333, -0.031468
3.136667, -0.031097
3.14, -0.030737
3.143333, -0.030362
3.146667, -0.029826
3.15, -0.02924
3.153333, -0.028957
3.156667, -0.02906
3.16, -0.029262
3.163333, -0.029312
3.166667, -0.029118
3.17, -0.028483
3.173333, -0.027083
3.176667, -0.024921
3.18, -0.022398
3.183333, -0.01954
3.186667, -0.015593
3.19, -0.009537
3.193333, -0.00053
3.196667, 0.012101
3.2, 0.028787
3.203333, 0.049385
3.206667, 0.073175
3.21, 0.09955
3.213333, 0.128234
3.216667, 0.158385
3.22, 0.187843
3.223333, 0.213691
3.226667, 0.2335
3.23, 0.245945
3.233333, 0.250556
3.236667, 0.24732
3.24, 0.236705
3.243333, 0.220076
3.246667, 0.199672
3.25, 0.177745
3.253333, 0.155824
3.256667, 0.134718
3.26, 0.114861
3.263333, 0.096536
3.266667, 0.079963
3.27, 0.065362
3.273333, 0.052934
3.276667, 0.042773
3.28, 0.034631
3.283333, 0.027747
3.286667, 0.021397
3.29, 0.015543
3.293333, 0.010514
3.296667, 0.006455
3.3, 0.003358
3.303333, 0.001421
3.306667, 0.001052
3.31, 0.002381
3.313333, 0.005242
3.316667, 0.009539
3.32, 0.015021
3.323333, 0.021216
3.326667, 0.027878
3.33, 0.03499
3.333333, 0.042472
3.336667, 0.050399
3.34, 0.05933
3.343333, 0.070018
3.346667, 0.08283
3.35, 0.097558
3.353333, 0.113536
3.356667, 0.130058
3.36, 0.146703
3.363333, 0.163116
3.366667, 0.178686
3.37, 0.192382
3.373333, 0.202776
3.376667, 0.208649
3.38, 0.209598
3.383333, 0.205887
3.386667, 0.198162
3.39, 0.18736
3.393333, 0.174534
3.396667, 0.160778
3.4, 0.14737
3.403333, 0.135863
3.406667, 0.127926
3.41, 0.12491
3.413333, 0.127372
3.416667, 0.134913
3.42, 0.146307
3.423333, 0.159874
3.426667, 0.173811
3.43, 0.186336
3.433333, 0.196043
3.436667, 0.202159
3.44, 0.204261
3.443333, 0.202043
3.446667, 0.195434
3.45, 0.184793
3.453333, 0.170881
3.456667, 0.154673
3.46, 0.137286
3.463333, 0.119884
3.466667, 0.103493
3.47, 0.088931
3.473333, 0.07681
3.476667, 0.067483
3.48, 0.06098
3.483333, 0.057107
3.486667, 0.055496
3.49, 0.05564
3.493333, 0.0572
3.496667, 0.059958
3.5, 0.063255
3.503333, 0.066035
3.506667, 0.067726
3.51, 0.06867
3.513333, 0.069635
3.516667, 0.071198
3.52, 0.073355
3.523333, 0.075538
3.526667, 0.076985
3.53, 0.077168
3.533333, 0.076265
3.536667, 0.075158
3.54, 0.074632
3.543333, 0.074935
3.546667, 0.076209
3.55, 0.078792
3.553333, 0.083166
3.556667, 0.090073
3.56, 0.100592
3.563333, 0.116073
3.566667, 0.138193
3.57, 0.16905
3.573333, 0.211249
3.576667, 0.268051
3.58, 0.343528
3.583333, 0.442174
3.586667, 0.568063
3.59, 0.724555
3.593333, 0.914434
3.596667, 1.13948
3.6, 1.399745
3.603333, 1.693436
3.606667, 2.017997
3.61, 2.372116
3.613333, 2.757512
3.616667, 3.179733
3.62, 3.648376
3.623333, 4.177021
3.626667, 4.782246
3.63, 5.481228
3.633333, 6.287857
3.636667, 7.208037
3.64, 8.235508
3.643333, 9.348911
3.646667, 10.510082
3.65, 11.66436
3.653333, 12.744077
3.656667, 13.674968
3.66, 14.384122
3.663333, 14.808502
3.666667, 14.903191
3.67, 14.647971
3.673333, 14.050798
3.676667, 13.147105
3.68, 11.995059
3.683333, 10.668258
3.686667, 9.247418
3.69, 7.811807
3.693333, 6.431371
3.696667, 5.161138
3.7, 4.038639
3.703333, 3.083769
3.706667, 2.300449
3.71, 1.679669
3.713333, 1.203397
3.716667, 0.84882
3.72, 0.592112
3.723333, 0.411099
3.726667, 0.286668
3.73, 0.203135
3.733333, 0.148134
3.736667, 0.112345
3.74, 0.088952
3.743333, 0.073192
3.746667, 0.062151
3.75, 0.054193
3.753333, 0.048283
3.756667, 0.043655
3.76, 0.039834
3.763333, 0.036829
3.766667, 0.034794
3.77, 0.033399
3.773333, 0.032086
3.776667, 0.030763
3.78, 0.029774
3.783333, 0.029468
3.786667, 0.03016
3.79, 0.032226
3.793333, 0.035941
3.796667, 0.041459
3.8, 0.049137
3.803333, 0.059861
3.806667, 0.07491
3.81, 0.095237
3.813333, 0.120937
3.816667, 0.151524
3.82, 0.186468
3.823333, 0.225578
3.826667, 0.269078
3.83, 0.316865
3.833333, 0.367658
3.836667, 0.419085
3.84, 0.468163
3.843333, 0.511753
3.846667, 0.547274
3.85, 0.573112
3.853333, 0.588274
3.856667, 0.591912
3.86, 0.583438
3.863333, 0.563112
3.866667, 0.532307
3.87, 0.493234
3.873333, 0.448492
3.876667, 0.400633
3.88, 0.351914
3.883333, 0.304386
3.886667, 0.259975
3.89, 0.220476
3.893333, 0.187407
3.896667, 0.161543
3.9, 0.142522
3.903333, 0.12916
3.906667, 0.12017
3.91, 0.114618
3.913333, 0.111894
3.916667, 0.111346
3.92, 0.111947
3.923333, 0.112596
3.926667, 0.112802
3.93, 0.112795
3.933333, 0.112861
3.936667, 0.112858
3.94, 0.1125
3.943333, 0.111631
3.946667, 0.109977
3.95, 0.107136
3.953333, 0.10303
3.956667, 0.098158
3.96, 0.093295
3.963333, 0.088907
3.966667, 0.084989
3.97, 0.081425
3.973333, 0.078171
3.976667, 0.074941
3.98, 0.071146
3.983333, 0.066511
3.986667, 0.061424
3.99, 0.056421
3.993333, 0.051715
3.996667, 0.047225
4.0, 0.042683
4.003333, 0.037811
4.006667, 0.032499
4.01, 0.026795
4.013333, 0.020975
4.016667, 0.015566
4.02, 0.010941
4.023333, 0.006992
4.026667, 0.003377
4.03, -0.000203
4.033333, -0.003961
4.036667, -0.007816
4.04, -0.011284
4.043333, -0.01377
4.046667, -0.01495
4.05, -0.015039
4.053333, -0.014623
4.056667, -0.01387
4.06, -0.01209
4.063333, -0.0084
4.066667, -0.002727
4.07, 0.004027
4.073333, 0.010775
4.076667, 0.016883
4.08, 0.022123
4.083333, 0.026671
4.086667, 0.031157
4.09, 0.036255
4.093333, 0.042158
4.096667, 0.048467
4.1, 0.054544
4.103333, 0.059963
4.106667, 0.064532
4.11, 0.068069
4.113333, 0.070428
4.116667, 0.071508
4.12, 0.071152
4.123333, 0.069384
4.126667, 0.0665
4.13, 0.062588
4.133333, 0.057439
4.136667, 0.051115
4.14, 0.044283
4.143333, 0.037874
4.146667, 0.032355
4.15, 0.027541
4.153333, 0.023052
4.156667, 0.018576
4.16, 0.013938
4.163333, 0.009249
4.166667, 0.004779
4.17, 0.000682
4.173333, -0.002953
4.176667, -0.005876
4.18, -0.007796
4.183333, -0.008709
4.186667, -0.008937
4.19, -0.009011
4.193333, -0.00933
4.196667, -0.0097
4.2, -0.00951
4.203333, -0.008279
4.206667, -0.005978
4.21, -0.003164
4.213333, -0.000658
4.216667, 0.001177
4.22, 0.002651
4.223333, 0.004325
4.226667, 0.00662
4.23, 0.009607
4.233333, 0.013
4.236667, 0.016344
4.24, 0.019303
4.243333, 0.021929
4.246667, 0.024511
4.25, 0.027172
4.253333, 0.029944
4.256667, 0.03305
4.26, 0.036769
4.263333, 0.041161
4.266667, 0.046129
4.27, 0.051587
4.273333, 0.057402
4.276667, 0.063259
4.28, 0.068631
4.283333, 0.072955
4.286667, 0.076045
4.29, 0.078229
4.293333, 0.079946
4.296667, 0.081421
4.3, 0.082721
4.303333, 0.083854
4.306667, 0.084769
4.31, 0.085159
4.313333, 0.084439
4.316667, 0.082401
4.32, 0.079674
4.323333, 0.077218
4.326667, 0.075671
4.33, 0.075158
4.333333, 0.075225
4.336667, 0.075043
4.34, 0.074002
4.343333, 0.072129
4.346667, 0.069849
4.35, 0.067624
4.353333, 0.06608
4.356667, 0.065947
4.36, 0.067444
4.363333, 0.070009
4.366667, 0.072785
4.37, 0.075178
4.373333, 0.077079
4.376667, 0.078707
4.38, 0.080333
4.383333, 0.082397
4.386667, 0.085637
4.39, 0.09073
4.393333, 0.09827
4.396667, 0.109324
4.4, 0.125652
4.403333, 0.149268
4.406667, 0.181826
4.41, 0.224478
4.413333, 0.278268
4.416667, 0.344539
4.42, 0.424875
4.423333, 0.52055
4.426667, 0.632288
4.43, 0.76067
4.433333, 0.906233
4.436667, 1.068955
4.44, 1.247659
4.443333, 1.439504
4.446667, 1.639714
4.45, 1.842096
4.453333, 2.040274
4.456667, 2.228454
4.46, 2.401081
4.463333, 2.552193
4.466667, 2.675588
4.47, 2.765894
4.473333, 2.819419
4.476667, 2.834219
4.48, 2.809945
4.483333, 2.747848
4.486667, 2.650571
4.49, 2.521699
4.493333, 2.3656
4.496667, 2.187661
4.5, 1.994383
4.503333, 1.792815
4.506667, 1.589656
4.51, 1.390786
4.513333, 1.201027
4.516667, 1.024134
4.52, 0.86304
4.523333, 0.719623
4.526667, 0.594366
4.53, 0.486874
4.533333, 0.396649
4.536667, 0.322963
4.54, 0.264338
4.543333, 0.219047
4.546667, 0.185713
4.55, 0.162699
4.553333, 0.147876
4.556667, 0.139497
4.56, 0.136442
4.563333, 0.137781
4.566667, 0.142502
4.57, 0.149251
4.573333, 0.156385
4.576667, 0.162633
4.58, 0.167671
4.583333, 0.172251
4.586667, 0.178091
4.59, 0.187684
4.593333, 0.20445
4.596667, 0.233418
4.6, 0.281665
4.603333, 0.357259
4.606667, 0.466497
4.61, 0.610335
4.613333, 0.781144
4.616667, 0.961288
4.62, 1.124973
4.623333, 1.243909
4.626667, 1.295166
4.63, 1.267652
4.633333, 1.16477
4.636667, 1.00282
4.64, 0.805893
4.643333, 0.599317
4.646667, 0.404201
4.65, 0.234341
4.653333, 0.0954
4.656667, -0.013538
4.66, -0.096593
4.663333, -0.158441
4.666667, -0.203671
4.67, -0.236525
4.673333, -0.260285
4.676667, -0.277153
4.68, -0.28867
4.683333, -0.296116
4.686667, -0.300586
4.69, -0.302821
4.693333, -0.303144
4.696667, -0.301689
4.7, -0.298669
4.703333, -0.294357
4.706667, -0.288826
4.71, -0.281902
4.713333, -0.273439
4.716667, -0.263486
4.72, -0.252249
4.723333, -0.24015
4.726667, -0.227735
4.73, -0.215351
4.733333, -0.202964
4.736667, -0.190154
4.74, -0.176344
4.743333, -0.161237
4.746667, -0.144998
4.75, -0.12825
4.753333, -0.111981
4.756667, -0.097053
4.76, -0.083665
4.763333, -0.071575
4.766667, -0.060712
4.77, -0.051068
4.773333, -0.042326
4.776667, -0.034329
4.78, -0.027347
4.783333, -0.021341
4.786667, -0.015658
4.79, -0.00977
4.793333, -0.003768
4.796667, 0.002069
4.8, 0.007773
4.803333, 0.013491
4.806667, 0.019034
4.81, 0.023986
4.813333, 0.028208
4.816667, 0.031909
4.82, 0.035288
4.823333, 0.038355
4.826667, 0.041091
4.83, 0.043497
4.833333, 0.045443
4.836667, 0.046764
4.84, 0.047524
4.843333, 0.048116
4.846667, 0.04915
4.85, 0.051121
4.853333, 0.054016
4.856667, 0.05728
4.86, 0.060133
4.863333, 0.061909
4.866667, 0.062359
4.87, 0.061802
4.873333, 0.060996
4.876667, 0.060581
4.88, 0.06033
4.883333, 0.059251
4.886667, 0.056809
4.89, 0.053545
4.893333, 0.050379
4.896667, 0.047974
4.9, 0.046596
4.903333, 0.046139
4.906667, 0.046183
4.91, 0.046036
4.913333, 0.045209
4.916667, 0.043959
4.92, 0.042881
4.923333, 0.042091
4.926667, 0.041291
4.93, 0.040416
4.933333, 0.039717
4.936667, 0.039331
4.94, 0.039214
4.943333, 0.039434
4.946667, 0.040107
4.95, 0.040999
4.953333, 0.041521
4.956667, 0.041209
4.96, 0.040044
4.963333, 0.038463
4.966667, 0.037097
4.97, 0.036132
4.973333, 0.035021
4.976667, 0.033232
4.98, 0.030963
4.983333, 0.028813
4.986667, 0.027302
4.99, 0.026738
4.993333, 0.026843
4.996667, 0.026741
5.0, 0.025788
5.003333, 0.024189
5.006667, 0.022731
5.01, 0.022041
5.013333, 0.021991
5.016667, 0.021896
5.02, 0.02132
5.023333, 0.020387
5.026667, 0.01937
5.03, 0.018359
5.033333, 0.017443
5.036667, 0.016709
5.04, 0.015974
5.043333, 0.014985
5.046667, 0.01366
5.05, 0.011915
5.053333, 0.009797
5.056667, 0.007833
5.06, 0.006724
5.063333, 0.006671
5.066667, 0.007278
5.07, 0.00795
5.073333, 0.008307
5.076667, 0.008387
5.08, 0.008696
5.083333, 0.010012
5.086667, 0.012912
5.09, 0.017426
5.093333, 0.023195
5.096667, 0.029892
5.1, 0.037404
5.103333, 0.045673
5.106667, 0.054658
5.11, 0.064459
5.113333, 0.075289
5.116667, 0.087399
5.12, 0.101047
5.123333, 0.116403
5.126667, 0.133384
5.13, 0.151598
5.133333, 0.170752
5.136667, 0.191035
5.14, 0.212838
5.143333, 0.236393
5.146667, 0.261743
5.15, 0.288573
5.153333, 0.316037
5.156667, 0.343402
5.16, 0.370966
5.163333, 0.400013
5.166667, 0.432047
5.17, 0.468195
5.173333, 0.509129
5.176667, 0.555276
5.18, 0.606955
5.183333, 0.66438
5.186667, 0.727665
5.19, 0.796862
5.193333, 0.872068
5.196667, 0.953491
5.2, 1.041324
5.203333, 1.135581
5.206667, 1.235968
5.21, 1.341685
5.213333, 1.451338
5.216667, 1.562968
5.22, 1.674103
5.223333, 1.782013
5.226667, 1.884158
5.23, 1.97838
5.233333, 2.062759
5.236667, 2.135508
5.24, 2.195133
5.243333, 2.240463
5.246667, 2.270234
5.25, 2.28293
5.253333, 2.277356
5.256667, 2.253298
5.26, 2.211509
5.263333, 2.153217
5.266667, 2.079886
5.27, 1.993348
5.273333, 1.895717
5.276667, 1.789002
5.28, 1.674999
5.283333, 1.555629
5.286667, 1.433146
5.29, 1.309863
5.293333, 1.187821
5.296667, 1.068747
5.3, 0.954245
5.303333, 0.845771
5.306667, 0.744374
5.31, 0.650679
5.313333, 0.565132
5.316667, 0.487883
5.32, 0.418423
5.323333, 0.35587
5.326667, 0.299709
5.33, 0.250075
5.333333, 0.207325
5.336667, 0.171286
5.34, 0.140983
5.343333, 0.115127
5.346667, 0.092746
5.35, 0.073407
5.353333, 0.056933
5.356667, 0.042952
5.36, 0.030917
5.363333, 0.020541
5.366667, 0.011956
5.37, 0.00525
5.373333, 3.7e-05
5.376667, -0.004393
5.38, -0.008779
5.383333, -0.013599
5.386667, -0.018787
5.39, -0.023931
5.393333, -0.028673
5.396667, -0.032609
5.4, -0.035331
5.403333, -0.036982
5.406667, -0.0383
5.41, -0.039998
5.413333, -0.042399
5.416667, -0.045364
5.42, -0.048326
5.423333, -0.050643
5.426667, -0.051979
5.43, -0.052366
5.433333, -0.052056
5.436667, -0.05133
5.44, -0.050437
5.443333, -0.049746
5.446667, -0.049719
5.45, -0.050487
5.453333, -0.051613
5.456667, -0.05251
5.46, -0.052953
5.463333, -0.052969
5.466667, -0.052493
5.47, -0.051367
5.473333, -0.049344
5.476667, -0.04602
5.48, -0.041203
5.483333, -0.035167
5.486667, -0.02836
5.49, -0.021169
5.493333, -0.013903
5.496667, -0.006745
5.5, 0.000248
5.503333, 0.007029
5.506667, 0.0134
5.51, 0.019207
5.513333, 0.024627
5.516667, 0.029912
5.52, 0.035005
5.523333, 0.039715
5.526667, 0.044109
5.53, 0.048223
5.533333, 0.051644
5.536667, 0.053926
5.54, 0.055113
5.543333, 0.055503
5.546667, 0.055292
5.55, 0.054587
5.553333, 0.05363
5.556667, 0.052905
5.56, 0.052731
5.563333, 0.052661
5.566667, 0.051713
5.57, 0.04949
5.573333, 0.046631
5.576667, 0.044054
5.58, 0.042253
5.583333, 0.041217
5.586667, 0.040559
5.59, 0.039875
5.593333, 0.039109
5.596667, 0.038502
5.6, 0.038262
5.603333, 0.03835
5.606667, 0.038509
5.61, 0.038526
5.613333, 0.038445
5.616667, 0.038579
5.62, 0.039355
5.623333, 0.04109
5.626667, 0.043814
5.63, 0.047188
5.633333, 0.050582
5.636667, 0.053356
5.64, 0.055231
5.643333, 0.056417
5.646667, 0.057331
5.65, 0.058245
5.653333, 0.059331
5.656667, 0.060854
5.66, 0.063059
5.663333, 0.065799
5.666667, 0.06846
5.67, 0.070315
5.673333, 0.070974
5.676667, 0.070618
5.68, 0.069708
5.683333, 0.068442
5.686667, 0.066799
5.69, 0.064956
5.693333, 0.063193
5.696667, 0.061572
5.7, 0.059907
5.703333, 0.057991
5.706667, 0.055785
5.71, 0.053313
5.713333, 0.050592
5.716667, 0.047912
5.72, 0.045909
5.723333, 0.045033
5.726667, 0.045121
5.73, 0.045695
5.733333, 0.046456
5.736667, 0.047289
5.74, 0.048207
5.743333, 0.049401
5.746667, 0.051004
5.75, 0.052619
5.753333, 0.053353
5.756667, 0.052629
5.76, 0.050747
5.763333, 0.048395
5.766667, 0.045968
5.77, 0.043541
5.773333, 0.041278
5.776667, 0.039693
5.78, 0.039253
5.783333, 0.039743
5.786667, 0.040388
5.79, 0.040565
5.793333, 0.040304
5.796667, 0.040311
5.8, 0.041572
5.803333, 0.044876
5.806667, 0.050841
5.81, 0.0601
5.813333, 0.073202
5.816667, 0.090756
5.82, 0.113896
5.823333, 0.144449
5.826667, 0.184887
5.83, 0.238465
5.833333, 0.309214
5.836667, 0.401427
5.84, 0.519374
5.843333, 0.667641
5.846667, 0.851339
5.85, 1.076169
5.853333, 1.348583
5.856667, 1.675388
5.86, 2.062783
5.863333, 2.51595
5.866667, 3.039368
5.87, 3.636863
5.873333, 4.311169
5.876667, 5.063531
5.88, 5.893261
5.883333, 6.79713
5.886667, 7.768961
5.89, 8.799784
5.893333, 9.87847
5.896667, 10.991896
5.9, 12.124446
5.903333, 13.258048
5.906667, 14.372711
5.91, 15.446853
5.913333, 16.457994
5.916667, 17.383735
5.92, 18.202298
5.923333, 18.893278
5.926667, 19.438805
5.93, 19.824045
5.933333, 20.037349
5.936667, 20.071082
5.94, 19.922621
5.943333, 19.594503
5.946667, 19.094076
5.95, 18.433397
5.953333, 17.628915
5.956667, 16.700533
5.96, 15.670538
5.963333, 14.562957
5.966667, 13.403004
5.97, 12.216064
5.973333, 11.026578
5.976667, 9.857338
5.98, 8.728811
5.983333, 7.658125
5.986667, 6.658163
5.99, 5.737589
5.993333, 4.901555
5.996667, 4.152299
6.0, 3.489528
6.003333, 2.91079
6.006667, 2.411834
6.01, 1.986902
6.013333, 1.629019
6.016667, 1.330611
6.02, 1.084231
6.023333, 0.882999
6.026667, 0.720688
6.03, 0.59154
6.033333, 0.489995
6.036667, 0.410767
6.04, 0.349312
6.043333, 0.302007
6.046667, 0.265739
6.05, 0.237755
6.053333, 0.216084
6.056667, 0.199619
6.06, 0.18757
6.063333, 0.179052
6.066667, 0.173298
6.07, 0.169841
6.073333, 0.168116
6.076667, 0.167267
6.08, 0.166613
6.083333, 0.166003
6.086667, 0.165651
6.09, 0.165762
6.093333, 0.16636
6.096667, 0.167471
6.1, 0.169264
6.103333, 0.171673
6.106667, 0.174098
6.11, 0.1759
6.113333, 0.176971
6.116667, 0.177485
6.12, 0.177433
6.123333, 0.176596
6.126667, 0.174636
6.13, 0.171274
6.133333, 0.166672
6.136667, 0.161566
6.14, 0.156909
6.143333, 0.153294
6.146667, 0.150506
6.15, 0.147651
6.153333, 0.143802
6.156667, 0.138588
6.16, 0.132405
6.163333, 0.125982
6.166667, 0.119593
6.17, 0.112851
6.173333, 0.105279
6.176667, 0.09692
6.18, 0.088386
6.183333, 0.080493
6.186667, 0.073794
6.19, 0.068346
6.193333, 0.06385
6.196667, 0.059788
6.2, 0.055302
6.203333, 0.04943
6.206667, 0.042127
6.21, 0.034753
6.213333, 0.028987
6.216667, 0.025599
6.22, 0.024186
6.223333, 0.023551
6.226667, 0.022535
6.23, 0.020729
6.233333, 0.018319
6.236667, 0.015554
6.24, 0.012494
6.243333, 0.009171
6.246667, 0.005876
6.25, 0.003185
6.253333, 0.001707
6.256667, 0.001828
6.26, 0.003509
6.263333, 0.006179
6.266667, 0.008962
6.27, 0.011262
6.273333, 0.013027
6.276667, 0.014436
6.28, 0.015668
6.283333, 0.017054
6.286667, 0.019109
6.29, 0.022135
6.293333, 0.025901
6.296667, 0.029839
6.3, 0.033385
6.303333, 0.036103
6.306667, 0.037694
6.31, 0.038129
6.313333, 0.037808
6.316667, 0.03735
6.32, 0.037042
6.323333, 0.03665
6.326667, 0.035877
6.33, 0.034737
6.333333, 0.033329
6.336667, 0.0316
6.34, 0.029514
6.343333, 0.027175
6.346667, 0.024686
6.35, 0.022015
6.353333, 0.018973
6.356667, 0.015354
6.36, 0.011141
6.363333, 0.006496
6.366667, 0.001626
6.37, -0.003252
6.373333, -0.008001
6.376667, -0.012482
6.38, -0.016175
6.383333, -0.018238
6.386667, -0.018285
6.39, -0.016901
6.393333, -0.015357
6.396667, -0.014829
6.4, -0.01567
6.403333, -0.017341
6.406667, -0.01913
6.41, -0.02067
6.413333, -0.021632
6.416667, -0.021568
6.42, -0.020268
6.423333, -0.017922
6.426667, -0.014922
6.43, -0.011571
6.433333, -0.00788
6.436667, -0.003635
6.44, 0.001303
6.443333, 0.006862
6.446667, 0.012898
6.45, 0.019365
6.453333, 0.026389
6.456667, 0.034093
6.46, 0.042357
6.463333, 0.050801
6.466667, 0.059059
6.47, 0.067098
6.473333, 0.075104
6.476667, 0.083068
6.48, 0.090812
6.483333, 0.098269
6.486667, 0.105479
6.49, 0.112491
6.493333, 0.119392
6.496667, 0.126365
6.5, 0.133622
6.503333, 0.141246
6.506667, 0.149066
6.51, 0.156749
6.513333, 0.163961
6.516667, 0.170522
6.52, 0.176515
6.523333, 0.182198
6.526667, 0.187857
6.53, 0.193824
6.533333, 0.200391
6.536667, 0.207637
6.54, 0.215315
6.543333, 0.222805
6.546667, 0.229487
6.55, 0.235232
6.553333, 0.240326
6.556667, 0.245028
6.56, 0.249317
6.563333, 0.253093
6.566667, 0.256468
6.57, 0.259631
6.573333, 0.262627
6.576667, 0.265554
6.58, 0.268843
6.583333, 0.272986
6.586667, 0.277987
6.59, 0.283365
6.593333, 0.288618
6.596667, 0.293385
6.6, 0.297331
6.603333, 0.300304
6.606667, 0.302595
6.61, 0.304696
6.613333, 0.3068
6.616667, 0.308675
6.62, 0.309885
6.623333, 0.310033
6.626667, 0.309007
6.63, 0.307117
6.633333, 0.304853
6.636667, 0.302401
6.64, 0.299323
6.643333, 0.294999
6.646667, 0.289466
6.65, 0.283298
6.653333, 0.276711
6.656667, 0.269429
6.66, 0.26133
6.663333, 0.252692
6.666667, 0.243831
6.67, 0.234999
6.673333, 0.226543
6.676667, 0.218613
6.68, 0.210768
6.683333, 0.202285
6.686667, 0.192681
6.69, 0.181916
6.693333, 0.170432
6.696667, 0.159007
6.7, 0.148461
6.703333, 0.139315
6.706667, 0.1314
6.71, 0.123898
6.713333, 0.116045
6.716667, 0.107624
6.72, 0.098882
6.723333, 0.090283
6.726667, 0.082293
6.73, 0.075161
6.733333, 0.068735
6.736667, 0.062568
6.74, 0.056287
6.743333, 0.049899
6.746667, 0.043753
6.75, 0.038206
6.753333, 0.033439
6.756667, 0.029506
6.76, 0.02643
6.763333, 0.024237
6.766667, 0.022781
6.77, 0.021681
6.773333, 0.020677
6.776667, 0.01983
6.78, 0.019111
6.783333, 0.018042
6.786667, 0.016199
6.79, 0.013801
6.793333, 0.011436
6.796667, 0.009599
6.8, 0.00844
6.803333, 0.007651
6.806667, 0.006643
6.81, 0.005103
6.813333, 0.003553
6.816667, 0.002966
6.82, 0.003672
6.823333, 0.005054
6.826667, 0.006301
6.83, 0.007056
6.833333, 0.00749
6.836667, 0.008124
6.84, 0.009405
6.843333, 0.01134
6.846667, 0.013658
6.85, 0.016037
6.853333, 0.018176
6.856667, 0.019888
6.86, 0.021162
6.863333, 0.0222
6.866667, 0.023273
6.87, 0.02438
6.873333, 0.025436
6.876667, 0.026799
6.88, 0.029027
6.883333, 0.032171
6.886667, 0.035603
6.89, 0.038513
6.893333, 0.040758
6.896667, 0.043178
6.9, 0.046803
6.903333, 0.051862
6.906667, 0.057566
6.91, 0.062724
6.913333, 0.066676
6.916667, 0.069561
6.92, 0.071817
6.923333, 0.073749
6.926667, 0.075558
6.93, 0.077424
6.933333, 0.079475
6.936667, 0.08157
6.94, 0.083335
6.943333, 0.084777
6.946667, 0.086514
6.95, 0.089023
6.953333, 0.092048
6.956667, 0.094869
6.96, 0.096844
6.963333, 0.097761
6.966667, 0.097893
6.97, 0.097726
6.973333, 0.097683
6.976667, 0.098002
6.98, 0.098544
6.983333, 0.098877
6.986667, 0.098767
6.99, 0.098331
6.993333, 0.097565
6.996667, 0.096215
7.0, 0.094209
7.003333, 0.091643
7.006667, 0.08841
7.01, 0.084294
7.013333, 0.079514
7.016667, 0.074959
7.02, 0.071447
7.023333, 0.068985
7.026667, 0.067075
7.03, 0.065271
7.033333, 0.063339
7.036667, 0.061137
7.04, 0.058354
7.043333, 0.054694
7.046667, 0.050517
7.05, 0.046845
7.053333, 0.044454
7.056667, 0.043255
7.06, 0.042719
7.063333, 0.042465
7.066667, 0.042125
7.07, 0.041117
7.073333, 0.03888
7.076667, 0.035348
7.08, 0.03117
7.083333, 0.027227
7.086667, 0.024043
7.09, 0.021816
7.093333, 0.020677
7.096667, 0.020483
7.1, 0.020435
7.103333, 0.019588
7.106667, 0.017926
7.11, 0.016315
7.113333, 0.015426
7.116667, 0.015248
7.12, 0.015425
7.123333, 0.015664
7.126667, 0.015752
7.13, 0.015431
7.133333, 0.014697
7.136667, 0.01413
7.14, 0.014446
7.143333, 0.015764
7.146667, 0.017322
7.15, 0.017974
7.153333, 0.017278
7.156667, 0.016065
7.16, 0.015676
7.163333, 0.016875
7.166667, 0.019612
7.17, 0.023292
7.173333, 0.027169
7.176667, 0.030772
7.18, 0.03386
7.183333, 0.036076
7.186667, 0.037081
7.19, 0.036908
7.193333, 0.035853
7.196667, 0.034215
7.2, 0.032446
7.203333, 0.031394
7.206667, 0.031795
7.21, 0.033449
7.213333, 0.035375
7.216667, 0.036869
7.22, 0.03803
7.223333, 0.039311
7.226667, 0.041008
7.23, 0.043203
7.233333, 0.045771
7.236667, 0.048376
7.24, 0.050768
7.243333, 0.05302
7.246667, 0.055229
7.25, 0.057466
7.253333, 0.060138
7.256667, 0.063783
7.26, 0.068486
7.263333, 0.073834
7.266667, 0.079328
7.27, 0.08479
7.273333, 0.090409
7.276667, 0.09634
7.28, 0.102383
7.283333, 0.108258
7.286667, 0.114157
7.29, 0.120651
7.293333, 0.127991
7.296667, 0.135867
7.3, 0.143905
7.303333, 0.152062
7.306667, 0.160577
7.31, 0.169737
7.313333, 0.179651
7.316667, 0.190148
7.32, 0.200717
7.323333, 0.210643
7.326667, 0.219648
7.33, 0.228359
7.333333, 0.237799
7.336667, 0.248393
7.34, 0.259672
7.343333, 0.270939
7.346667, 0.281726
7.35, 0.291601
7.353333, 0.300063
7.356667, 0.306815
7.36, 0.312166
7.363333, 0.316974
7.366667, 0.321843
7.37, 0.326673
7.373333, 0.331081
7.376667, 0.334636
7.38, 0.336882
7.383333, 0.337872
7.386667, 0.338326
7.39, 0.338942
7.393333, 0.340044
7.396667, 0.342042
7.4, 0.34564
7.403333, 0.351463
7.406667, 0.359934
7.41, 0.371622
7.413333, 0.387411
7.416667, 0.408256
7.42, 0.434892
7.423333, 0.468218
7.426667, 0.510005
7.43, 0.562727
7.433333, 0.62875
7.436667, 0.710296
7.44, 0.80998
7.443333, 0.930783
7.446667, 1.075829
7.45, 1.248683
7.453333, 1.453456
7.456667, 1.694549
7.46, 1.976722
7.463333, 2.305252
7.466667, 2.685727
7.47, 3.123888
7.473333, 3.625815
7.476667, 4.198127
7.48, 4.847805
7.483333, 5.582
7.486667, 6.408251
7.49, 7.334419
7.493333, 8.368077
7.496667, 9.516253
7.5, 10.785554
7.503333, 12.182091
7.506667, 13.711322
7.51, 15.378022
7.513333, 17.186212
7.516667, 19.138725
7.52, 21.236523
7.523333, 23.478477
7.526667, 25.861623
7.53, 28.381171
7.533333, 31.030455
7.536667, 33.801138
7.54, 36.682868
7.543333, 39.662375
7.546667, 42.723388
7.55, 45.847479
7.553333, 49.014741
7.556667, 52.203701
7.56, 55.390829
7.563333, 58.550776
7.566667, 61.657306
7.57, 64.683481
7.573333, 67.601256
7.576667, 70.381803
7.58, 72.996606
7.583333, 75.418732
7.586667, 77.623343
7.59, 79.587124
7.593333, 81.287889
7.596667, 82.705179
7.6, 83.821178
7.603333, 84.621511
7.606667, 85.095917
7.61, 85.238486
7.613333, 85.047433
7.616667, 84.524969
7.62, 83.677326
7.623333, 82.51461
7.626667, 81.050534
7.63, 79.302014
7.633333, 77.288701
7.636667, 75.032922
7.64, 72.559691
7.643333, 69.896042
7.646667, 67.069958
7.65, 64.109744
7.653333, 61.04397
7.656667, 57.9015
7.66, 54.711145
7.663333, 51.500815
7.666667, 48.296769
7.67, 45.123262
7.673333, 42.002172
7.676667, 38.953066
7.68, 35.993863
7.683333, 33.140814
7.686667, 30.40766
7.69, 27.80503
7.693333, 25.340354
7.696667, 23.018468
7.7, 20.842445
7.703333, 18.813797
7.706667, 16.932311
7.71, 15.195985
7.713333, 13.60117
7.716667, 12.143008
7.72, 10.815903
7.723333, 9.613648
7.726667, 8.529232
7.73, 7.554953
7.733333, 6.682848
7.736667, 5.904813
7.74, 5.212566
7.743333, 4.598001
7.746667, 4.053706
7.75, 3.573192
7.753333, 3.150791
7.756667, 2.78122
7.76, 2.459116
7.763333, 2.178998
7.766667, 1.935407
7.77, 1.72315
7.773333, 1.537957
7.776667, 1.376772
7.78, 1.236969
7.783333, 1.115453
7.786667, 1.009067
7.79, 0.915528
7.793333, 0.833314
7.796667, 0.761072
7.8, 0.697609
7.803333, 0.641948
7.806667, 0.593099
7.81, 0.550045
7.813333, 0.511934
7.816667, 0.478143
7.82, 0.448101
7.823333, 0.421196
7.826667, 0.396924
7.83, 0.374924
7.833333, 0.354728
7.836667, 0.33573
7.84, 0.317573
7.843333, 0.300341
7.846667, 0.284283
7.85, 0.269595
7.853333, 0.256351
7.856667, 0.24441
7.86, 0.233494
7.863333, 0.223362
7.866667, 0.213762
7.87, 0.204438
7.873333, 0.195373
7.876667, 0.186794
7.88, 0.178782
7.883333, 0.171129
7.886667, 0.163595
7.89, 0.156148
7.893333, 0.149021
7.896667, 0.142487
7.9, 0.136463
7.903333, 0.130628
7.906667, 0.125058
7.91, 0.120283
7.913333, 0.116606
7.916667, 0.113715
7.92, 0.110918
7.923333, 0.107594
7.926667, 0.103551
7.93, 0.099034
7.933333, 0.094475
7.936667, 0.090273
7.94, 0.086735
7.943333, 0.084052
7.946667, 0.082141
7.95, 0.080659
7.953333, 0.079288
7.956667, 0.077891
7.96, 0.07639
7.963333, 0.074616
7.966667, 0.072336
7.97, 0.069375
7.973333, 0.065734
7.976667, 0.061852
7.98, 0.058545
7.983333, 0.056284
7.986667, 0.054739
7.99, 0.053272
7.993333, 0.051599
7.996667, 0.04993
8.0, 0.048642
8.003333, 0.047916
8.006667, 0.047644
8.01, 0.047487
8.013333, 0.046912
8.016667, 0.045362
8.02, 0.042746
8.023333, 0.039751
8.026667, 0.037269
8.03, 0.035617
8.033333, 0.034664
8.036667, 0.034255
8.04, 0.034302
8.043333, 0.034693
8.046667, 0.035201
8.05, 0.035593
8.053333, 0.035767
8.056667, 0.035677
8.06, 0.035342
8.063333, 0.034911
8.066667, 0.034501
8.07, 0.033991
8.073333, 0.033202
8.076667, 0.032258
8.08, 0.031502
8.083333, 0.031222
8.086667, 0.031484
8.09, 0.032054
8.093333, 0.032612
8.096667, 0.032815
8.1, 0.032216
8.103333, 0.030697
8.106667, 0.02867
8.11, 0.026669
8.113333, 0.025058
8.116667, 0.023912
8.12, 0.022966
8.123333, 0.021703
8.126667, 0.019627
8.13, 0.016738
8.133333, 0.013629
8.136667, 0.010898
8.14, 0.008702
8.143333, 0.006849
8.146667, 0.004942
8.15, 0.002591
8.153333, -8.1e-05
8.156667, -0.00234
8.16, -0.003436
8.163333, -0.003293
8.166667, -0.0026
8.17, -0.002231
8.173333, -0.002694
8.176667, -0.004098
8.18, -0.006255
8.183333, -0.008788
8.186667, -0.011413
8.19, -0.014115
8.193333, -0.016992
8.196667, -0.020001
8.2, -0.02287
8.203333, -0.025223
8.206667, -0.026899
8.21, -0.02805
8.213333, -0.02876
8.216667, -0.028968
8.22, -0.028703
8.223333, -0.028107
8.226667, -0.02745
8.23, -0.027073
8.233333, -0.027148
8.236667, -0.02765
8.24, -0.028474
8.243333, -0.029389
8.246667, -0.029873
8.25, -0.029122
8.253333, -0.026542
8.256667, -0.022355
8.26, -0.017403
8.263333, -0.012274
8.266667, -0.006842
8.27, -0.000606
8.273333, 0.006766
8.276667, 0.015215
8.28, 0.024552
8.283333, 0.035021
8.286667, 0.047452
8.29, 0.062649
8.293333, 0.080889
8.296667, 0.10224
8.3, 0.127025
8.303333, 0.155815
8.306667, 0.189264
8.31, 0.227784
8.313333, 0.271323
8.316667, 0.319862
8.32, 0.374075
8.323333, 0.435225
8.326667, 0.504563
8.33, 0.582863
8.333333, 0.670438
8.336667, 0.767638
8.34, 0.87522
8.343333, 0.994215
8.346667, 1.125702
8.35, 1.270617
8.353333, 1.429649
8.356667, 1.603211
8.36, 1.791429
8.363333, 1.994596
8.366667, 2.213608
8.37, 2.44941
8.373333, 2.702377
8.376667, 2.972605
8.38, 3.260142
8.383333, 3.564624
8.386667, 3.885265
8.39, 4.221358
8.393333, 4.572413
8.396667, 4.937966
8.4, 5.317267
8.403333, 5.708778
8.406667, 6.110357
8.41, 6.520195
8.413333, 6.937127
8.416667, 7.360016
8.42, 7.787225
8.423333, 8.216698
8.426667, 8.646018
8.43, 9.071985
8.433333, 9.490786
8.436667, 9.89897
8.44, 10.293904
8.443333, 10.673298
8.446667, 11.034678
8.45, 11.375486
8.453333, 11.693411
8.456667, 11.986277
8.46, 12.251743
8.463333, 12.487378
8.466667, 12.690907
8.47, 12.8602
8.473333, 12.993426
8.476667, 13.089604
8.48, 13.148705
8.483333, 13.171065
8.486667, 13.156942
8.49, 13.106401
8.493333, 13.019321
8.496667, 12.895669
8.5, 12.735987
8.503333, 12.541707
8.506667, 12.314975
8.51, 12.058131
8.513333, 11.773547
8.516667, 11.463816
8.52, 11.131573
8.523333, 10.779322
8.526667, 10.409676
8.53, 10.025311
8.533333, 9.628761
8.536667, 9.222684
8.54, 8.810191
8.543333, 8.39456
8.546667, 7.978496
8.55, 7.56398
8.553333, 7.152895
8.556667, 6.747329
8.56, 6.34933
8.563333, 5.960666
8.566667, 5.582678
8.57, 5.216424
8.573333, 4.863053
8.576667, 4.523911
8.58, 4.200378
8.583333, 3.893481
8.586667, 3.603479
8.59, 3.329985
8.593333, 3.072514
8.596667, 2.830821
8.6, 2.604741
8.603333, 2.393933
8.606667, 2.198057
8.61, 2.017005
8.613333, 1.850713
8.616667, 1.698723
8.62, 1.560117
8.623333, 1.433895
8.626667, 1.319197
8.63, 1.215421
8.633333, 1.122424
8.636667, 1.040188
8.64, 0.968219
8.643333, 0.90563
8.646667, 0.851594
8.65, 0.805344
8.653333, 0.766056
8.656667, 0.732969
8.66, 0.705444
8.663333, 0.683055
8.666667, 0.665593
8.67, 0.652773
8.673333, 0.644089
8.676667, 0.638892
8.68, 0.636598
8.683333, 0.637006
8.686667, 0.640361
8.69, 0.646937
8.693333, 0.656464
8.696667, 0.668012
8.7, 0.680461
8.703333, 0.692949
8.706667, 0.705052
8.71, 0.716777
8.713333, 0.72835
8.716667, 0.73994
8.72, 0.751643
8.723333, 0.763537
8.726667, 0.775373
8.73, 0.786278
8.733333, 0.795266
8.736667, 0.801871
8.74, 0.806011
8.743333, 0.807742
8.746667, 0.807213
8.75, 0.804477
8.753333, 0.799482
8.756667, 0.79224
8.76, 0.78289
8.763333, 0.771721
8.766667, 0.75918
8.77, 0.745688
8.773333, 0.731097
8.776667, 0.71452
8.78, 0.695099
8.783333, 0.672712
8.786667, 0.647849
8.79, 0.621292
8.793333, 0.594052
8.796667, 0.567206
8.8, 0.541342
8.803333, 0.516171
8.806667, 0.491073
8.81, 0.465856
8.813333, 0.440617
8.816667, 0.41522
8.82, 0.389415
8.823333, 0.363291
8.826667, 0.337285
8.83, 0.311857
8.833333, 0.287344
8.836667, 0.263978
8.84, 0.241892
8.843333, 0.221168
8.846667, 0.201964
8.85, 0.184466
8.853333, 0.168634
8.856667, 0.154239
8.86, 0.141198
8.863333, 0.129451
8.866667, 0.118826
8.87, 0.109369
8.873333, 0.101191
8.876667, 0.093958
8.88, 0.087063
8.883333, 0.080082
8.886667, 0.07279
8.89, 0.065188
8.893333, 0.057843
8.896667, 0.051685
8.9, 0.047177
8.903333, 0.044057
8.906667, 0.041824
8.91, 0.040109
8.913333, 0.038701
8.916667, 0.037412
8.92, 0.036091
8.923333, 0.034743
8.926667, 0.033377
8.93, 0.031762
8.933333, 0.029608
8.936667, 0.027144
8.94, 0.025199
8.943333, 0.024459
8.946667, 0.025001
8.95, 0.026423
8.953333, 0.028022
8.956667, 0.029105
8.96, 0.029496
8.963333, 0.029741
8.966667, 0.030629
8.97, 0.03255
8.973333, 0.035388
8.976667, 0.038753
8.98, 0.042261
8.983333, 0.045785
8.986667, 0.0494
8.99, 0.053295
8.993333, 0.057884
8.996667, 0.063539
9.0, 0.07007
9.003333, 0.076883
9.006667, 0.083656
9.01, 0.090505
9.013333, 0.097654
9.016667, 0.10525
9.02, 0.113279
9.023333, 0.121661
9.026667, 0.130584
9.03, 0.140447
9.033333, 0.151591
9.036667, 0.164169
9.04, 0.177887
9.043333, 0.19201
9.046667, 0.205943
9.05, 0.219598
9.053333, 0.233115
9.056667, 0.246469
9.06, 0.259686
9.063333, 0.273341
9.066667, 0.288214
9.07, 0.304327
9.073333, 0.320659
9.076667, 0.335994
9.08, 0.349866
9.083333, 0.362478
9.086667, 0.37404
9.09, 0.384553
9.093333, 0.39399
9.096667, 0.402492
9.1, 0.410444
9.103333, 0.418184
9.106667, 0.425672
9.11, 0.432605
9.113333, 0.438692
9.116667, 0.443552
9.12, 0.446552
9.123333, 0.447245
9.126667, 0.445861
9.13, 0.443053
9.133333, 0.43924
9.136667, 0.434357
9.14, 0.428273
9.143333, 0.421059
9.146667, 0.41274
9.15, 0.403291
9.153333, 0.392864
9.156667, 0.381665
9.16, 0.369737
9.163333, 0.357033
9.166667, 0.343483
9.17, 0.328882
9.173333, 0.313102
9.176667, 0.296424
9.18, 0.279379
9.183333, 0.262381
9.186667, 0.245632
9.19, 0.229108
9.193333, 0.212701
9.196667, 0.196492
9.2, 0.180746
9.203333, 0.165737
9.206667, 0.151499
9.21, 0.137705
9.213333, 0.12396
9.216667, 0.110175
9.22, 0.096574
9.223333, 0.08349
9.226667, 0.071166
9.23, 0.05975
9.233333, 0.049391
9.236667, 0.040187
9.24, 0.032134
9.243333, 0.025204
9.246667, 0.019273
9.25, 0.01395
9.253333, 0.008756
9.256667, 0.003497
9.26, -0.001787
9.263333, -0.007019
9.266667, -0.012128
9.27, -0.017104
9.273333, -0.021765
9.276667, -0.025434
9.28, -0.027303
9.283333, -0.027313
9.286667, -0.026482
9.29, -0.02614
9.293333, -0.026859
9.296667, -0.028247
9.3, -0.029572
9.303333, -0.030306
9.306667, -0.030151
9.31, -0.029088
9.313333, -0.02755
9.316667, -0.026101
9.32, -0.024967
9.323333, -0.024105
9.326667, -0.023451
9.33, -0.022817
9.333333, -0.021816
9.336667, -0.020168
9.34, -0.017909
9.343333, -0.015226
9.346667, -0.012148
9.35, -0.008584
9.353333, -0.00471
9.356667, -0.000932
9.36, 0.002647
9.363333, 0.006386
9.366667, 0.010732
9.37, 0.015946
9.373333, 0.022231
9.376667, 0.029713
9.38, 0.038175
9.383333, 0.047142
9.386667, 0.056234
9.39, 0.065485
9.393333, 0.075506
9.396667, 0.087082
9.4, 0.100461
9.403333, 0.115379
9.406667, 0.131676
9.41, 0.149621
9.413333, 0.169822
9.416667, 0.192926
9.42, 0.21931
9.423333, 0.2492
9.426667, 0.283265
9.43, 0.322834
9.433333, 0.369307
9.436667, 0.423624
9.44, 0.486562
9.443333, 0.559318
9.446667, 0.643447
9.45, 0.740506
9.453333, 0.852225
9.456667, 0.980917
9.46, 1.12953
9.463333, 1.30155
9.466667, 1.500811
9.47, 1.73122
9.473333, 1.996857
9.476667, 2.302378
9.48, 2.653051
9.483333, 3.054529
9.486667, 3.51305
9.49, 4.035553
9.493333, 4.629324
9.496667, 5.302145
9.5, 6.062999
9.503333, 6.922065
9.506667, 7.890016
9.51, 8.977894
9.513333, 10.197657
9.516667, 11.562224
9.52, 13.085066
9.523333, 14.780116
9.526667, 16.662004
9.53, 18.746301
9.533333, 21.049374
9.536667, 23.587692
9.54, 26.377378
9.543333, 29.434566
9.546667, 32.775877
9.55, 36.418249
9.553333, 40.377963
9.556667, 44.66991
9.56, 49.308151
9.563333, 54.306774
9.566667, 59.679485
9.57, 65.438481
9.573333, 71.593974
9.576667, 78.154299
9.58, 85.12578
9.583333, 92.51235
9.586667, 100.315283
9.59, 108.532883
9.593333, 117.160128
9.596667, 126.188477
9.6, 135.605852
9.603333, 145.396736
9.606667, 155.542295
9.61, 166.020283
9.613333, 176.804601
9.616667, 187.864816
9.62, 199.165965
9.623333, 210.668928
9.626667, 222.330779
9.63, 234.104437
9.633333, 245.938797
9.636667, 257.780223
9.64, 269.573749
9.643333, 281.262808
9.646667, 292.788702
9.65, 304.091489
9.653333, 315.111487
9.656667, 325.789565
9.66, 336.066599
9.663333, 345.88345
9.666667, 355.182021
9.67, 363.90644
9.673333, 372.00338
9.676667, 379.422269
9.68, 386.116108
9.683333, 392.042746
9.686667, 397.165759
9.69, 401.454089
9.693333, 404.881254
9.696667, 407.425544
9.7, 409.071141
9.703333, 409.809016
9.706667, 409.63701
9.71, 408.559524
9.713333, 406.587127
9.716667, 403.736254
9.72, 400.029118
9.723333, 395.493573
9.726667, 390.162484
9.73, 384.072577
9.733333, 377.263853
9.736667, 369.780286
9.74, 361.670408
9.743333, 352.98629
9.746667, 343.781643
9.75, 334.110936
9.753333, 324.029654
9.756667, 313.594315
9.76, 302.862108
9.763333, 291.890447
9.766667, 280.736103
9.77, 269.454362
9.773333, 258.098999
9.776667, 246.722372
9.78, 235.374886
9.783333, 224.10418
9.786667, 212.954141
9.79, 201.964547
9.793333, 191.172035
9.796667, 180.610648
9.8, 170.310953
9.803333, 160.299509
9.806667, 150.599124
9.81, 141.228778
9.813333, 132.203589
9.816667, 123.535343
9.82, 115.232884
9.823333, 107.302311
9.826667, 99.747423
9.83, 92.570223
9.833333, 85.771037
9.836667, 79.348102
9.84, 73.296777
9.843333, 67.609141
9.846667, 62.274877
9.85, 57.282913
9.853333, 52.622273
9.856667, 48.281731
9.86, 44.249269
9.863333, 40.511821
9.866667, 37.055257
9.87, 33.864758
9.873333, 30.925622
9.876667, 28.223817
9.88, 25.745475
9.883333, 23.476053
9.886667, 21.400622
9.89, 19.504994
9.893333, 17.776062
9.896667, 16.201325
9.9, 14.768864
9.903333, 13.467552
9.906667, 12.286909
9.91, 11.217183
9.913333, 10.249488
9.916667, 9.375368
9.92, 8.586423
9.923333, 7.874505
9.926667, 7.231993
9.93, 6.651882
9.933333, 6.127886
9.936667, 5.654501
9.94, 5.226952
9.943333, 4.840953
9.946667, 4.492394
9.95, 4.177368
9.953333, 3.892384
9.956667, 3.634429
9.96, 3.400834
9.963333, 3.189041
9.966667, 2.996615
9.97, 2.821506
9.973333, 2.662119
9.976667, 2.517156
9.98, 2.385181
9.983333, 2.264392
9.986667, 2.153037
9.99, 2.04979
9.993333, 1.953733
9.996667, 1.86424
10.0, 1.780885
10.003333, 1.703447
10.006667, 1.63191
10.01, 1.566128
10.013333, 1.505371
10.016667, 1.448452
10.02, 1.394333
10.023333, 1.342426
10.026667, 1.292525
10.03, 1.244644
10.033333, 1.198942
10.036667, 1.155848
10.04, 1.116072
10.043333, 1.080034
10.046667, 1.047098
10.05, 1.01588
10.053333, 0.985475
10.056667, 0.955915
10.06, 0.927454
10.063333, 0.900029
10.066667, 0.873389
10.07, 0.847402
10.073333, 0.822213
10.076667, 0.798123
10.08, 0.775258
10.083333, 0.753404
10.086667, 0.732134
10.09, 0.711072
10.093333, 0.690193
10.096667, 0.670056
10.1, 0.651475
10.103333, 0.634748
10.106667, 0.619442
10.11, 0.604902
10.113333, 0.590709
10.116667, 0.576649
10.12, 0.562492
10.123333, 0.547996
10.126667, 0.533133
10.13, 0.518312
10.133333, 0.504357
10.136667, 0.492036
10.14, 0.481591
10.143333, 0.472628
10.146667, 0.464167
10.15, 0.45503
10.153333, 0.444522
10.156667, 0.432752
10.16, 0.420562
10.163333, 0.40914
10.166667, 0.399357
10.17, 0.39125
10.173333, 0.384031
10.176667, 0.376681
10.18, 0.368749
10.183333, 0.360568
10.186667, 0.35272
10.19, 0.345502
10.193333, 0.338768
10.196667, 0.332097
10.2, 0.325309
10.203333, 0.318705
10.206667, 0.312655
10.21, 0.307164
10.213333, 0.302002
10.216667, 0.297054
10.22, 0.292403
10.223333, 0.287999
10.226667, 0.283341
10.23, 0.27796
10.233333, 0.272229
10.236667, 0.266945
10.24, 0.262286
10.243333, 0.257851
10.246667, 0.253301
10.25, 0.248592
10.253333, 0.243959
10.256667, 0.23965
10.26, 0.235596
10.263333, 0.231623
10.266667, 0.227841
10.27, 0.224447
10.273333, 0.221301
10.276667, 0.217925
10.28, 0.213998
10.283333, 0.209819
10.286667, 0.206048
10.29, 0.203133
10.293333, 0.201115
10.296667, 0.199708
10.3, 0.198303
10.303333, 0.196074
10.306667, 0.192562
10.31, 0.188155
10.313333, 0.183581
10.316667, 0.179157
10.32, 0.174894
10.323333, 0.170844
10.326667, 0.166984
10.33, 0.16316
10.333333, 0.159422
10.336667, 0.156012
10.34, 0.153016
10.343333, 0.150417
10.346667, 0.148281
10.35, 0.146706
10.353333, 0.14561
10.356667, 0.144518
10.36, 0.142876
10.363333, 0.140712
10.366667, 0.13853
10.37, 0.136474
10.373333, 0.134128
10.376667, 0.131286
10.38, 0.128334
10.383333, 0.125656
10.386667, 0.123155
10.39, 0.120583
10.393333, 0.117985
10.396667, 0.115677
10.4, 0.113901
10.403333, 0.112533
10.406667, 0.111213
10.41, 0.109745
10.413333, 0.10814
10.416667, 0.106434
10.42, 0.104637
10.423333, 0.10259
10.426667, 0.099984
10.43, 0.096799
10.433333, 0.093373
10.436667, 0.08996
10.44, 0.086537
10.443333, 0.08302
10.446667, 0.079461
10.45, 0.076002
10.453333, 0.072781
10.456667, 0.07003
10.46, 0.068035
10.463333, 0.066904
10.466667, 0.066625
10.47, 0.067077
10.473333, 0.067751
10.476667, 0.0679
10.48, 0.067115
10.483333, 0.065412
10.486667, 0.063068
10.49, 0.060731
10.493333, 0.059119
10.496667, 0.058374
10.5, 0.058044
10.503333, 0.057562
10.506667, 0.056578
10.51, 0.055089
10.513333, 0.05341
10.516667, 0.051867
10.52, 0.050448
10.523333, 0.048881
10.526667, 0.046965
10.53, 0.044619
10.533333, 0.041891
10.536667, 0.039167
10.54, 0.037123
10.543333, 0.036115
10.546667, 0.035843
10.55, 0.035846
10.553333, 0.035949
10.556667, 0.036222
10.56, 0.036792
10.563333, 0.037657
10.566667, 0.038602
10.57, 0.039128
10.573333, 0.038707
10.576667, 0.037381
10.58, 0.035844
10.583333, 0.034767
10.586667, 0.034162
10.59, 0.033653
10.593333, 0.033135
10.596667, 0.032614
10.6, 0.031993
10.603333, 0.03137
10.606667, 0.030951
10.61, 0.030757
10.613333, 0.030513
10.616667, 0.029731
10.62, 0.028244
10.623333, 0.026603
10.626667, 0.025594
10.63, 0.02552
10.633333, 0.026022
10.636667, 0.026467
10.64, 0.026451
10.643333, 0.025895
10.646667, 0.024806
10.65, 0.023298
10.653333, 0.021707
10.656667, 0.020313
10.66, 0.019224
10.663333, 0.018703
10.666667, 0.01905
10.67, 0.020111
10.673333, 0.021274
10.676667, 0.021816
10.68, 0.02131
10.683333, 0.020153
10.686667, 0.019396
10.69, 0.019615
10.693333, 0.020299
10.696667, 0.020637
10.7, 0.020428
10.703333, 0.020014
10.706667, 0.019603
10.71, 0.01899
10.713333, 0.017967
10.716667, 0.016683
10.72, 0.015452
10.723333, 0.014627
10.726667, 0.014589
10.73, 0.015357
10.733333, 0.016375
10.736667, 0.016982
10.74, 0.017008
10.743333, 0.016869
10.746667, 0.017068
10.75, 0.017698
10.753333, 0.018474
10.756667, 0.019025
10.76, 0.019128
10.763333, 0.018793
10.766667, 0.018226
10.77, 0.017934
10.773333, 0.018508
10.776667, 0.019872
10.78, 0.021237
10.783333, 0.02189
10.786667, 0.02171
10.79, 0.020967
10.793333, 0.019831
10.796667, 0.018277
10.8, 0.016408
10.803333, 0.01471
10.806667, 0.013899
10.81, 0.014313
10.813333, 0.015609
10.816667, 0.017065
10.82, 0.018079
10.823333, 0.018397
10.826667, 0.017917
10.83, 0.016615
10.833333, 0.014895
10.836667, 0.013564
10.84, 0.013167
10.843333, 0.013538
10.846667, 0.014014
10.85, 0.014011
10.853333, 0.013516
10.856667, 0.012919
10.86, 0.012412
10.863333, 0.011846
10.866667, 0.011216
10.87, 0.010832
10.873333, 0.010763
10.876667, 0.010557
10.88, 0.00978
10.883333, 0.008459
10.886667, 0.006923
10.89, 0.00556
10.893333, 0.004621
10.896667, 0.003954
10.9, 0.003064
10.903333, 0.001494
10.906667, -0.000804
10.91, -0.003284
10.913333, -0.005181
10.916667, -0.006208
10.92, -0.006527
10.923333, -0.006171
10.926667, -0.005012
10.93, -0.003227
10.933333, -0.001512
10.936667, -0.000714
10.94, -0.001139
10.943333, -0.00231
10.946667, -0.003424
10.95, -0.004069
10.953333, -0.004513
10.956667, -0.005287
10.96, -0.006541
10.963333, -0.00803
10.966667, -0.009655
10.97, -0.011553
10.973333, -0.013754
10.976667, -0.016109
10.98, -0.018249
10.983333, -0.019628
10.986667, -0.019956
10.99, -0.01936
10.993333, -0.018232
10.996667, -0.017124
11.0, -0.016411
11.003333, -0.016056
11.006667, -0.01589
11.01, -0.015838
11.013333, -0.015803
11.016667, -0.015619
11.02, -0.015414
11.023333, -0.015793
11.026667, -0.017235
11.03, -0.019486
11.033333, -0.021665
11.036667, -0.022951
11.04, -0.023268
11.043333, -0.023097
11.046667, -0.022821
11.05, -0.022696
11.053333, -0.023087
11.056667, -0.02419
11.06, -0.025644
11.063333, -0.026666
11.066667, -0.026598
11.07, -0.025492
11.073333, -0.024198
11.076667, -0.023641
11.08, -0.024077
11.083333, -0.02505
11.086667, -0.025689
11.09, -0.025237
11.093333, -0.023624
11.096667, -0.021483
11.1, -0.019773
11.103333, -0.019376
11.106667, -0.020575
11.11, -0.022821
11.113333, -0.025174
11.116667, -0.026851
11.12, -0.027468
11.123333, -0.027124
11.126667, -0.026285
11.13, -0.02555
11.133333, -0.025397
11.136667, -0.025915
11.14, -0.026781
11.143333, -0.02747
11.146667, -0.027387
11.15, -0.026114
11.153333, -0.023896
11.156667, -0.021571
11.16, -0.019746
11.163333, -0.01838
11.166667, -0.017185
11.17, -0.016091
11.173333, -0.015319
11.176667, -0.01505
11.18, -0.014987
11.183333, -0.014481
11.186667, -0.013286
11.19, -0.011897
11.193333, -0.010932
11.196667, -0.010533
11.2, -0.010488
11.203333, -0.010469
11.206667, -0.010276
11.21, -0.01005
11.213333, -0.010081
11.216667, -0.010442
11.22, -0.010798
11.223333, -0.010564
11.226667, -0.009462
11.23, -0.007857
11.233333, -0.006311
11.236667, -0.004939
11.24, -0.003581
11.243333, -0.002449
11.246667, -0.002055
11.25, -0.00248
11.253333, -0.003152
11.256667, -0.003403
11.26, -0.002958
11.263333, -0.001963
11.266667, -0.000767
11.27, 0.000301
11.273333, 0.001148
11.276667, 0.001984
11.28, 0.003017
11.283333, 0.004001
11.286667, 0.004299
11.29, 0.003551
11.293333, 0.002163
11.296667, 0.000889
11.3, -7e-06
11.303333, -0.000889
11.306667, -0.002137
11.31, -0.003702
11.313333, -0.005256
11.316667, -0.006573
11.32, -0.007721
11.323333, -0.00888
11.326667, -0.009921
11.33, -0.010427
11.333333, -0.010395
11.336667, -0.010456
11.34, -0.011054
11.343333, -0.012021
11.346667, -0.013002
11.35, -0.013695
11.353333, -0.013837
11.356667, -0.013413
11.36, -0.012811
11.363333, -0.012643
11.366667, -0.013339
11.37, -0.014776
11.373333, -0.016379
11.376667, -0.017544
11.38, -0.0179
11.383333, -0.017425
11.386667, -0.01655
11.39, -0.015933
11.393333, -0.015954
11.396667, -0.016559
11.4, -0.017528
11.403333, -0.018627
11.406667, -0.019613
11.41, -0.020415
11.413333, -0.021483
11.416667, -0.023562
11.42, -0.026751
11.423333, -0.030095
11.426667, -0.032409
11.43, -0.033259
11.433333, -0.032963
11.436667, -0.032065
11.44, -0.031006
11.443333, -0.03003
11.446667, -0.029331
11.45, -0.029005
11.453333, -0.028922
11.456667, -0.028958
11.46, -0.029045
11.463333, -0.029047
11.466667, -0.028933
11.47, -0.028776
11.473333, -0.028614
11.476667, -0.028511
11.48, -0.02861
11.483333, -0.029131
11.486667, -0.030423
11.49, -0.032645
11.493333, -0.035166
11.496667, -0.036898
11.5, -0.037493
11.503333, -0.037624
11.506667, -0.038061
11.51, -0.038957
11.513333, -0.04005
11.516667, -0.041194
11.52, -0.042446
11.523333, -0.04388
11.526667, -0.045467
11.53, -0.04697
11.533333, -0.048029
11.536667, -0.048537
11.54, -0.048769
11.543333, -0.048911
11.546667, -0.048699
11.55, -0.0479
11.553333, -0.046752
11.556667, -0.04568
11.56, -0.044907
11.563333, -0.044336
11.566667, -0.043878
11.57, -0.043799
11.573333, -0.044288
11.576667, -0.044954
11.58, -0.045362
11.583333, -0.045736
11.586667, -0.046653
11.59, -0.048249
11.593333, -0.049996
11.596667, -0.051094
11.6, -0.05121
11.603333, -0.050946
11.606667, -0.051136
11.61, -0.05182
11.613333, -0.052428
11.616667, -0.052505
11.62, -0.051918
11.623333, -0.050829
11.626667, -0.049588
11.63, -0.04839
11.633333, -0.047018
11.636667, -0.04521
11.64, -0.043165
11.643333, -0.041295
11.646667, -0.039846
11.65, -0.039003
11.653333, -0.038859
11.656667, -0.039276
11.66, -0.039895
11.663333, -0.040232
11.666667, -0.040074
11.67, -0.039807
11.673333, -0.039944
11.676667, -0.040473
11.68, -0.040957
11.683333, -0.041149
11.686667, -0.041162
11.69, -0.041143
11.693333, -0.041066
11.696667, -0.040793
11.7, -0.040264
11.703333, -0.039709
11.706667, -0.03951
11.71, -0.039654
11.713333, -0.039462
11.716667, -0.038237
11.72, -0.036031
11.723333, -0.033494
11.726667, -0.031213
11.73, -0.029614
11.733333, -0.029199
11.736667, -0.030139
11.74, -0.031771
11.743333, -0.033002
11.746667, -0.033046
11.75, -0.031609
11.753333, -0.028823
11.756667, -0.025381
11.76, -0.022302
11.763333, -0.020222
11.766667, -0.019164
11.77, -0.019085
11.773333, -0.01996
11.776667, -0.021149
11.78, -0.021508
11.783333, -0.020305
11.786667, -0.017629
11.79, -0.014074
11.793333, -0.010455
11.796667, -0.007639
11.8, -0.006165
11.803333, -0.005989
11.806667, -0.006632
11.81, -0.007499
11.813333, -0.008107
11.816667, -0.008168
11.82, -0.007664
11.823333, -0.006838
11.826667, -0.005956
11.83, -0.005037
11.833333, -0.004007
11.836667, -0.003088
11.84, -0.002658
11.843333, -0.002743
11.846667, -0.002965
11.85, -0.003014
11.853333, -0.002931
11.856667, -0.002852
11.86, -0.00266
11.863333, -0.002145
11.866667, -0.001488
11.87, -0.001203
11.873333, -0.00162
11.876667, -0.002735
11.88, -0.004359
11.883333, -0.006108
11.886667, -0.007532
11.89, -0.008506
11.893333, -0.009359
11.896667, -0.010431
11.9, -0.011789
11.903333, -0.013404
11.906667, -0.015223
11.91, -0.017047
11.913333, -0.018637
11.916667, -0.020063
11.92, -0.021618
11.923333, -0.023251
11.926667, -0.024629
11.93, -0.025708
11.933333, -0.026689
11.936667, -0.027575
11.94, -0.028182
11.943333, -0.028475
11.946667, -0.028677
11.95, -0.02907
11.953333, -0.029839
11.956667, -0.031127
11.96, -0.033127
11.963333, -0.03596
11.966667, -0.039378
11.97, -0.042732
11.973333, -0.045415
11.976667, -0.047278
11.98, -0.048739
11.983333, -0.050463
11.986667, -0.052588
11.99, -0.054429
11.993333, -0.055379
11.996667, -0.055736
12.0, -0.056145
12.003333, -0.05676
12.006667, -0.057432
12.01, -0.058163
12.013333, -0.05905
12.016667, -0.060139
12.02, -0.061392
12.023333, -0.062696
12.026667, -0.063826
12.03, -0.064394
12.033333, -0.064159
12.036667, -0.063541
12.04, -0.063453
12.043333, -0.064381
12.046667, -0.06597
12.05, -0.067565
12.053333, -0.068716
12.056667, -0.069176
12.06, -0.068993
12.063333, -0.068722
12.066667, -0.068916
12.07, -0.069516
12.073333, -0.070244
12.076667, -0.07101
12.08, -0.071702
12.083333, -0.072275
12.086667, -0.073121
12.09, -0.074725
12.093333, -0.076936
12.096667, -0.079066
12.1, -0.08054
12.103333, -0.081173
12.106667, -0.081095
12.11, -0.080734
12.113333, -0.080796
12.116667, -0.081866
12.12, -0.083774
12.123333, -0.085726
12.126667, -0.087127
12.13, -0.087856
12.133333, -0.087884
12.136667, -0.087258
12.14, -0.086343
12.143333, -0.085703
12.146667, -0.085725
12.15, -0.086502
12.153333, -0.087948
12.156667, -0.089819
12.16, -0.09195
12.163333, -0.094514
12.166667, -0.097588
12.17, -0.100816
12.173333, -0.103795
12.176667, -0.106311
12.18, -0.10823
12.183333, -0.109544
12.186667, -0.110433
12.19, -0.111182
12.193333, -0.11201
12.196667, -0.112868
12.2, -0.113524
12.203333, -0.114016
12.206667, -0.114769
12.21, -0.116008
12.213333, -0.117403
12.216667, -0.11845
12.22, -0.118992
12.223333, -0.119385
12.226667, -0.120156
12.23, -0.121554
12.233333, -0.123483
12.236667, -0.125601
12.24, -0.127283
12.243333, -0.127926
12.246667, -0.127629
12.25, -0.127126
12.253333, -0.126907
12.256667, -0.127019
12.26, -0.127401
12.263333, -0.127773
12.266667, -0.127603
12.27, -0.126563
12.273333, -0.124885
12.276667, -0.123185
12.28, -0.121993
12.283333, -0.121529
12.286667, -0.12177
12.29, -0.122485
12.293333, -0.123303
12.296667, -0.123907
12.3, -0.124061
12.303333, -0.123646
12.306667, -0.122812
12.31, -0.121899
12.313333, -0.121199
12.316667, -0.120816
12.32, -0.120552
12.323333, -0.11989
12.326667, -0.118385
12.33, -0.116082
12.333333, -0.113549
12.336667, -0.111647
12.34, -0.111047
12.343333, -0.111634
12.346667, -0.112521
12.35, -0.112753
12.353333, -0.111985
12.356667, -0.110636
12.36, -0.109483
12.363333, -0.109001
12.366667, -0.109137
12.37, -0.109768
12.373333, -0.110911
12.376667, -0.112211
12.38, -0.112755
12.383333, -0.11169
12.386667, -0.108976
12.39, -0.105527
12.393333, -0.102507
12.396667, -0.100649
12.4, -0.100198
12.403333, -0.100934
12.406667, -0.10209
12.41, -0.102669
12.413333, -0.102235
12.416667, -0.101184
12.42, -0.100186
12.423333, -0.09963
12.426667, -0.099498
12.43, -0.099601
12.433333, -0.099808
12.436667, -0.100013
12.44, -0.100203
12.443333, -0.100594
12.446667, -0.101405
12.45, -0.102416
12.453333, -0.102866
12.456667, -0.102088
12.46, -0.100245
12.463333, -0.098022
12.466667, -0.095826
12.47, -0.093814
12.473333, -0.092406
12.476667, -0.092161
12.48, -0.093201
12.483333, -0.094996
12.486667, -0.096678
12.49, -0.097553
12.493333, -0.097502
12.496667, -0.09697
12.5, -0.096441
12.503333, -0.095842
12.506667, -0.094732
12.51, -0.09314
12.513333, -0.091713
12.516667, -0.090921
12.52, -0.090617
12.523333, -0.090371
12.526667, -0.089848
12.53, -0.088943
12.533333, -0.087817
12.536667, -0.086809
12.54, -0.086085
12.543333, -0.085393
12.546667, -0.084447
12.55, -0.083381
12.553333, -0.082504
12.556667, -0.081778
12.56, -0.080985
12.563333, -0.080321
12.566667, -0.080308
12.57, -0.081077
12.573333, -0.082248
12.576667, -0.083272
12.58, -0.083534
12.583333, -0.082637
12.586667, -0.080722
12.59, -0.078192
12.593333, -0.075518
12.596667, -0.073293
12.6, -0.071906
12.603333, -0.071351
12.606667, -0.07145
12.61, -0.071927
12.613333, -0.072363
12.616667, -0.072236
12.62, -0.071175
12.623333, -0.069419
12.626667, -0.067747
12.63, -0.066715
12.633333, -0.066259
12.636667, -0.066158
12.64, -0.066466
12.643333, -0.067174
12.646667, -0.067856
12.65, -0.068085
12.653333, -0.067869
12.656667, -0.067481
12.66, -0.067207
12.663333, -0.067186
12.666667, -0.067163
12.67, -0.066611
12.673333, -0.065296
12.676667, -0.063539
12.68, -0.062004
12.683333, -0.0613
12.686667, -0.061495
12.69, -0.062015
12.693333, -0.062267
12.696667, -0.062264
12.7, -0.062339
12.703333, -0.062551
12.706667, -0.062653
12.71, -0.062334
12.713333, -0.061431
12.716667, -0.060189
12.72, -0.05919
12.723333, -0.058791
12.726667, -0.058799
12.73, -0.058846
12.733333, -0.058688
12.736667, -0.058147
12.74, -0.057265
12.743333, -0.056471
12.746667, -0.05624
12.75, -0.056682
12.753333, -0.05754
12.756667, -0.058509
12.76, -0.059459
12.763333, -0.060379
12.766667, -0.061324
12.77, -0.062392
12.773333, -0.063476
12.776667, -0.064074
12.78, -0.063561
12.783333, -0.061802
12.786667, -0.059484
12.79, -0.057599
12.793333, -0.056463
12.796667, -0.055574
12.8, -0.054459
12.803333, -0.053116
12.806667, -0.051616
12.81, -0.049906
12.813333, -0.047972
12.816667, -0.045892
12.82, -0.043804
12.823333, -0.041887
12.826667, -0.040469
12.83, -0.039982
12.833333, -0.040433
12.836667, -0.041135
12.84, -0.041258
12.843333, -0.040523
12.846667, -0.039365
12.85, -0.038508
12.853333, -0.038234
12.856667, -0.038099
12.86, -0.037454
12.863333, -0.036047
12.866667, -0.034157
12.87, -0.032275
12.873333, -0.030666
12.876667, -0.029237
12.88, -0.02779
12.883333, -0.026362
12.886667, -0.02509
12.89, -0.023936
12.893333, -0.022899
12.896667, -0.022272
12.9, -0.022433
12.903333, -0.023461
12.906667, -0.024984
12.91, -0.026492
12.913333, -0.027675
12.916667, -0.028406
12.92, -0.028647
12.923333, -0.028482
12.926667, -0.028196
12.93, -0.028149
12.933333, -0.028432
12.936667, -0.02883
12.94, -0.029154
12.943333, -0.02935
12.946667, -0.029285
12.95, -0.028702
12.953333, -0.027654
12.956667, -0.026799
12.96, -0.026969
12.963333, -0.028453
12.966667, -0.030792
12.97, -0.033236
12.973333, -0.03515
12.976667, -0.036151
12.98, -0.03635
12.983333, -0.036407
12.986667, -0.037027
12.99, -0.038407
12.993333, -0.040167
12.996667, -0.041741
13.0, -0.042817
13.003333, -0.043505
13.006667, -0.044134
13.01, -0.044975
13.013333, -0.046158
13.016667, -0.04763
13.02, -0.049156
13.023333, -0.050391
13.026667, -0.050948
13.03, -0.050554
13.033333, -0.049319
13.036667, -0.047739
13.04, -0.046372
13.043333, -0.045584
13.046667, -0.045508
13.05, -0.046058
13.053333, -0.046889
13.056667, -0.047476
13.06, -0.047411
13.063333, -0.046641
13.066667, -0.045505
13.07, -0.044485
13.073333, -0.043793
13.076667, -0.043262
13.08, -0.042671
13.083333, -0.042063
13.086667, -0.041601
13.09, -0.041268
13.093333, -0.041045
13.096667, -0.041076
13.1, -0.041362
13.103333, -0.041604
13.106667, -0.041435
13.11, -0.040603
13.113333, -0.0392
13.116667, -0.03794
13.12, -0.037583
13.123333, -0.037974
13.126667, -0.038209
13.13, -0.037472
13.133333, -0.035511
13.136667, -0.032814
13.14, -0.030445
13.143333, -0.029393
13.146667, -0.029715
13.15, -0.030659
13.153333, -0.031809
13.156667, -0.033325
13.16, -0.035168
13.163333, -0.036935
13.166667, -0.038265
13.17, -0.038939
13.173333, -0.038812
13.176667, -0.037882
13.18, -0.03642
13.183333, -0.034978
13.186667, -0.034208
13.19, -0.034441
13.193333, -0.035357
13.196667, -0.036283
13.2, -0.036832
13.203333, -0.037138
13.206667, -0.037455
13.21, -0.03768
13.213333, -0.037566
13.216667, -0.037234
13.22, -0.037107
13.223333, -0.037394
13.226667, -0.037849
13.23, -0.038111
13.233333, -0.038038
13.236667, -0.037755
13.24, -0.037747
13.243333, -0.038605
13.246667, -0.040245
13.25, -0.041705
13.253333, -0.042019
13.256667, -0.041166
13.26, -0.039924
13.263333, -0.039103
13.266667, -0.039143
13.27, -0.04003
13.273333, -0.041533
13.276667, -0.043651
13.28, -0.046387
13.283333, -0.049224
13.286667, -0.051478
13.29, -0.052897
13.293333, -0.053568
13.296667, -0.053746
13.3, -0.0539
13.303333, -0.054393
13.306667, -0.054927
13.31, -0.054656
13.313333, -0.053026
13.316667, -0.050366
13.32, -0.047689
13.323333, -0.046074
13.326667, -0.045954
13.33, -0.046753
13.333333, -0.047359
13.336667, -0.047124
13.34, -0.046477
13.343333, -0.046445
13.346667, -0.04768
13.35, -0.050144
13.353333, -0.053342
13.356667, -0.056412
13.36, -0.058332
13.363333, -0.058512
13.366667, -0.057361
13.37, -0.056166
13.373333, -0.056156
13.376667, -0.057588
13.38, -0.059713
13.383333, -0.061622
13.386667, -0.06304
13.39, -0.064174
13.393333, -0.065056
13.396667, -0.065436
13.4, -0.065287
13.403333, -0.064943
13.406667, -0.064672
13.41, -0.064492
13.413333, -0.064406
13.416667, -0.064513
13.42, -0.064949
13.423333, -0.065796
13.426667, -0.066903
13.43, -0.06796
13.433333, -0.069007
13.436667, -0.070407
13.44, -0.07219
13.443333, -0.074004
13.446667, -0.0757
13.45, -0.07739
13.453333, -0.078959
13.456667, -0.079998
13.46, -0.080333
13.463333, -0.080322
13.466667, -0.080486
13.47, -0.081009
13.473333, -0.081768
13.476667, -0.082826
13.48, -0.084446
13.483333, -0.086564
13.486667, -0.088628
13.49, -0.090052
13.493333, -0.090687
13.496667, -0.090808
13.5, -0.090874
13.503333, -0.091275
13.506667, -0.092085
13.51, -0.093131
13.513333, -0.094132
13.516667, -0.094584
13.52, -0.094026
13.523333, -0.092633
13.526667, -0.091165
13.53, -0.090352
13.533333, -0.090483
13.536667, -0.091356
13.54, -0.092499
13.543333, -0.093396
13.546667, -0.093621
13.55, -0.093119
13.553333, -0.092412
13.556667, -0.092236
13.56, -0.092961
13.563333, -0.094444
13.566667, -0.096299
13.57, -0.09819
13.573333, -0.099905
13.576667, -0.101306
13.58, -0.102265
13.583333, -0.102738
13.586667, -0.102871
13.59, -0.102782
13.593333, -0.102401
13.596667, -0.101879
13.6, -0.101746
13.603333, -0.102266
13.606667, -0.103005
13.61, -0.103396
13.613333, -0.10342
13.616667, -0.103486
13.62, -0.104034
13.623333, -0.105252
13.626667, -0.106894
13.63, -0.108432
13.633333, -0.109469
13.636667, -0.109971
13.64, -0.110057
13.643333, -0.109714
13.646667, -0.108913
13.65, -0.10785
13.653333, -0.106932
13.656667, -0.106541
13.66, -0.106767
13.663333, -0.1073
13.666667, -0.107928
13.67, -0.109015
13.673333, -0.111
13.676667, -0.113627
13.68, -0.11607
13.683333, -0.117649
13.686667, -0.118207
13.69, -0.117992
13.693333, -0.117415
13.696667, -0.116839
13.7, -0.116432
13.703333, -0.116221
13.706667, -0.116231
13.71, -0.116424
13.713333, -0.11664
13.716667, -0.116841
13.72, -0.117248
13.723333, -0.118048
13.726667, -0.119087
13.73, -0.119942
13.733333, -0.120305
13.736667, -0.120228
13.74, -0.12005
13.743333, -0.120174
13.746667, -0.120887
13.75, -0.122268
13.753333, -0.1241
13.756667, -0.12583
13.76, -0.126799
13.763333, -0.126676
13.766667, -0.12561
13.77, -0.124086
13.773333, -0.122621
13.776667, -0.121423
13.78, -0.120381
13.783333, -0.119403
13.786667, -0.118631
13.79, -0.118316
13.793333, -0.118534
13.796667, -0.119081
13.8, -0.119502
13.803333, -0.119196
13.806667, -0.117881
13.81, -0.115988
13.813333, -0.114136
13.816667, -0.112394
13.82, -0.110435
13.823333, -0.108216
13.826667, -0.106135
13.83, -0.104559
13.833333, -0.103559
13.836667, -0.103138
13.84, -0.103375
13.843333, -0.10424
13.846667, -0.105337
13.85, -0.106078
13.853333, -0.106178
13.856667, -0.105711
13.86, -0.104806
13.863333, -0.103482
13.866667, -0.101607
13.87, -0.099051
13.873333, -0.096004
13.876667, -0.092921
13.88, -0.090168
13.883333, -0.088017
13.886667, -0.086714
13.89, -0.086053
13.893333, -0.085269
13.896667, -0.083753
13.9, -0.081502
13.903333, -0.078916
13.906667, -0.076563
13.91, -0.074989
13.913333, -0.074383
13.916667, -0.07434
13.92, -0.074186
13.923333, -0.073576
13.926667, -0.072612
13.93, -0.071554
13.933333, -0.070633
13.936667, -0.069883
13.94, -0.068984
13.943333, -0.067494
13.946667, -0.065311
13.95, -0.062825
13.953333, -0.060475
13.956667, -0.058407
13.96, -0.056691
13.963333, -0.055397
13.966667, -0.054402
13.97, -0.053415
13.973333, -0.052325
13.976667, -0.051511
13.98, -0.051486
13.983333, -0.052123
13.986667, -0.052775
13.99, -0.053095
13.993333, -0.053206
13.996667, -0.053273
14.0, -0.053349
14.003333, -0.053284
14.006667, -0.05268
14.01, -0.051215
14.013333, -0.048958
14.016667, -0.046427
14.02, -0.044448
14.023333, -0.043617
14.026667, -0.04376
14.03, -0.044085
14.033333, -0.043799
14.036667, -0.04273
14.04, -0.041439
14.043333, -0.040565
14.046667, -0.040183
14.05, -0.039894
14.053333, -0.039403
14.056667, -0.038928
14.06, -0.03885
14.063333, -0.039109
14.066667, -0.039416
14.07, -0.039842
14.073333, -0.040682
14.076667, -0.041891
14.08, -0.042935
14.083333, -0.043158
14.086667, -0.042123
14.09, -0.039761
14.093333, -0.036553
14.096667, -0.033298
14.1, -0.030763
14.103333, -0.029646
14.106667, -0.030131
14.11, -0.031401
14.113333, -0.03228
14.116667, -0.032199
14.12, -0.031309
14.123333, -0.030059
14.126667, -0.028825
14.13, -0.027756
14.133333, -0.026772
14.136667, -0.025662
14.14, -0.024348
14.143333, -0.02314
14.146667, -0.022486
14.15, -0.022433
14.153333, -0.022575
14.156667, -0.02241
14.16, -0.021683
14.163333, -0.020513
14.166667, -0.019228
14.17, -0.018019
14.173333, -0.016743
14.176667, -0.01503
14.18, -0.012712
14.183333, -0.010097
14.186667, -0.007678
14.19, -0.005816
14.193333, -0.004814
14.196667, -0.004777
14.2, -0.005345
14.203333, -0.006013
14.206667, -0.006506
14.21, -0.006592
14.213333, -0.005961
14.216667, -0.004491
14.22, -0.002429
14.223333, -0.000171
14.226667, 0.002018
14.23, 0.004017
14.233333, 0.005763
14.236667, 0.007294
14.24, 0.008765
14.243333, 0.010237
14.246667, 0.011588
14.25, 0.012692
14.253333, 0.013413
14.256667, 0.013599
14.26, 0.013494
14.263333, 0.01378
14.266667, 0.014885
14.27, 0.016707
14.273333, 0.019025
14.276667, 0.021638
14.28, 0.024271
14.283333, 0.026713
14.286667, 0.028912
14.29, 0.030775
14.293333, 0.032108
14.296667, 0.032881
14.3, 0.033361
14.303333, 0.033925
14.306667, 0.034742
14.31, 0.035663
14.313333, 0.036507
14.316667, 0.037311
14.32, 0.038209
14.323333, 0.039349
14.326667, 0.041025
14.33, 0.043473
14.333333, 0.046375
14.336667, 0.049006
14.34, 0.05097
14.343333, 0.05235
14.346667, 0.053394
14.35, 0.054523
14.353333, 0.056163
14.356667, 0.058219
14.36, 0.060169
14.363333, 0.061742
14.366667, 0.063107
14.37, 0.064464
14.373333, 0.065844
14.376667, 0.067289
14.38, 0.068801
14.383333, 0.070021
14.386667, 0.070393
14.39, 0.069842
14.393333, 0.068927
14.396667, 0.068374
14.4, 0.068598
14.403333, 0.069439
14.406667, 0.070323
14.41, 0.070769
14.413333, 0.070712
14.416667, 0.070382
14.42, 0.070113
14.423333, 0.070237
14.426667, 0.070827
14.43, 0.071487
14.433333, 0.071558
14.436667, 0.070743
14.44, 0.069528
14.443333, 0.068692
14.446667, 0.068606
14.45, 0.069134
14.453333, 0.069813
14.456667, 0.070004
14.46, 0.069263
14.463333, 0.067739
14.466667, 0.066081
14.47, 0.06481
14.473333, 0.063908
14.476667, 0.063036
14.48, 0.061858
14.483333, 0.060111
14.486667, 0.057724
14.49, 0.05498
14.493333, 0.052227
14.496667, 0.049516
14.5, 0.046832
14.503333, 0.044505
14.506667, 0.043111
14.51, 0.042828
14.513333, 0.042982
14.516667, 0.042591
14.52, 0.041332
14.523333, 0.039549
14.526667, 0.03756
14.53, 0.035479
14.533333, 0.033448
14.536667, 0.031498
14.54, 0.029322
14.543333, 0.026553
14.546667, 0.023155
14.55, 0.019336
14.553333, 0.015317
14.556667, 0.01139
14.56, 0.007889
14.563333, 0.004951
14.566667, 0.00247
14.57, 0.000304
14.573333, -0.001467
14.576667, -0.002462
14.58, -0.002396
14.583333, -0.001527
14.586667, -0.000581
14.59, -0.000368
14.593333, -0.00149
14.596667, -0.004119
14.6, -0.007733
14.603333, -0.011115
14.606667, -0.013207
14.61, -0.014094
14.613333, -0.01486
14.616667, -0.016553
14.62, -0.019341
14.623333, -0.022567
14.626667, -0.025535
14.63, -0.02803
14.633333, -0.030158
14.636667, -0.032058
14.64, -0.033745
14.643333, -0.035102
14.646667, -0.036011
14.65, -0.036482
14.653333, -0.036665
14.656667, -0.03664
14.66, -0.036391
14.663333, -0.036135
14.666667, -0.036239
14.67, -0.036858
14.673333, -0.037951
14.676667, -0.039338
14.68, -0.040821
14.683333, -0.042385
14.686667, -0.043945
14.69, -0.045075
14.693333, -0.045248
14.696667, -0.044246
14.7, -0.042406
14.703333, -0.04046
14.706667, -0.039047
14.71, -0.038471
14.713333, -0.038671
14.716667, -0.039138
14.72, -0.039169
14.723333, -0.038555
14.726667, -0.037673
14.73, -0.036963
14.733333, -0.036771
14.736667, -0.037364
14.74, -0.038663
14.743333, -0.040185
14.746667, -0.041609
14.75, -0.043138
14.753333, -0.045075
14.756667, -0.047394
14.76, -0.049755
14.763333, -0.051698
14.766667, -0.052875
14.77, -0.053199
14.773333, -0.052776
14.776667, -0.051799
14.78, -0.050721
14.783333, -0.050181
14.786667, -0.050276
14.79, -0.050346
14.793333, -0.049753
14.796667, -0.048426
14.8, -0.046787
14.803333, -0.045625
14.806667, -0.045701
14.81, -0.047067
14.813333, -0.048902
14.816667, -0.05035
14.82, -0.051324
14.823333, -0.05217
14.826667, -0.052975
14.83, -0.053552
14.833333, -0.053874
14.836667, -0.054339
14.84, -0.055339
14.843333, -0.056701
14.846667, -0.057887
14.85, -0.058601
14.853333, -0.058989
14.856667, -0.059318
14.86, -0.05968
14.863333, -0.060073
14.866667, -0.060471
14.87, -0.060934
14.873333, -0.061628
14.876667, -0.062502
14.88, -0.063421
14.883333, -0.06467
14.886667, -0.066627
14.89, -0.068934
14.893333, -0.070501
14.896667, -0.070505
14.9, -0.06931
14.903333, -0.068249
14.906667, -0.068346
14.91, -0.06937
14.913333, -0.070296
14.916667, -0.070464
14.92, -0.070216
14.923333, -0.070584
14.926667, -0.072344
14.93, -0.075269
14.933333, -0.07828
14.936667, -0.080308
14.94, -0.08111
14.943333, -0.081214
14.946667, -0.081078
14.95, -0.0806
14.953333, -0.079554
14.956667, -0.078075
14.96, -0.076518
14.963333, -0.075266
14.966667, -0.074526
14.97, -0.074091
14.973333, -0.073626
14.976667, -0.073114
14.98, -0.072717
14.983333, -0.072333
14.986667, -0.071683
14.99, -0.070617
14.993333, -0.069102
14.996667, -0.067266
15.0, -0.065538
15.003333, -0.064366
15.006667, -0.063689
15.01, -0.062944
15.013333, -0.061661
15.016667, -0.059868
15.02, -0.058088
15.023333, -0.057003
15.026667, -0.056774
15.03, -0.056834
15.033333, -0.056509
15.036667, -0.055548
15.04, -0.054094
15.043333, -0.052578
15.046667, -0.051523
15.05, -0.051083
15.053333, -0.051008
15.056667, -0.051086
15.06, -0.051345
15.063333, -0.051867
15.066667, -0.052562
15.07, -0.05314
15.073333, -0.053391
15.076667, -0.053431
15.08, -0.0534
15.083333, -0.053098
15.086667, -0.052214
15.09, -0.050713
15.093333, -0.048744
15.096667, -0.046501
15.1, -0.04433
15.103333, -0.042581
15.106667, -0.041327
15.11, -0.040514
15.113333, -0.040117
15.116667, -0.039945
15.12, -0.039657
15.123333, -0.039025
15.126667, -0.038116
15.13, -0.037383
15.133333, -0.037443
15.136667, -0.038595
15.14, -0.040538
15.143333, -0.042475
15.146667, -0.043718
15.15, -0.044427
15.153333, -0.04539
15.156667, -0.046942
15.16, -0.04852
15.163333, -0.049368
15.166667, -0.049224
15.17, -0.048183
15.173333, -0.046449
15.176667, -0.044466
15.18, -0.042816
15.183333, -0.041682
15.186667, -0.040674
15.19, -0.039339
15.193333, -0.037608
15.196667, -0.035612
15.2, -0.033417
15.203333, -0.031213
15.206667, -0.029643
15.21, -0.029442
15.213333, -0.030585
15.216667, -0.032207
15.22, -0.033367
15.223333, -0.033626
15.226667, -0.033156
15.23, -0.03231
15.233333, -0.03111
15.236667, -0.029515
15.24, -0.027809
15.243333, -0.026297
15.246667, -0.025034
15.25, -0.023941
15.253333, -0.022887
15.256667, -0.021737
15.26, -0.020416
15.263333, -0.018956
15.266667, -0.017646
15.27, -0.017027
15.273333, -0.017419
15.276667, -0.018527
15.28, -0.019663
15.283333, -0.020237
15.286667, -0.019952
15.29, -0.018717
15.293333, -0.016635
15.296667, -0.014207
15.3, -0.012233
15.303333, -0.011166
15.306667, -0.010828
15.31, -0.010791
15.313333, -0.010707
15.316667, -0.01045
15.32, -0.010169
15.323333, -0.010021
15.326667, -0.009929
15.33, -0.009799
15.333333, -0.009707
15.336667, -0.009698
15.34, -0.009596
15.343333, -0.009116
15.346667, -0.00823
15.35, -0.007406
15.353333, -0.007376
15.356667, -0.008676
15.36, -0.011223
15.363333, -0.014195
15.366667, -0.016624
15.37, -0.018141
15.373333, -0.019013
15.376667, -0.019656
15.38, -0.02019
15.383333, -0.020507
15.386667, -0.020762
15.39, -0.021293
15.393333, -0.021957
15.396667, -0.022088
15.4, -0.02124
15.403333, -0.0197
15.406667, -0.018244
15.41, -0.017624
15.413333, -0.018268
15.416667, -0.020067
15.42, -0.022273
15.423333, -0.024019
15.426667, -0.025067
15.43, -0.025922
15.433333, -0.027126
15.436667, -0.02844
15.44, -0.029084
15.443333, -0.028697
15.446667, -0.027717
15.45, -0.027082
15.453333, -0.027434
15.456667, -0.028446
15.46, -0.029318
15.463333, -0.029713
15.466667, -0.02986
15.47, -0.03024
15.473333, -0.031409
15.476667, -0.033555
15.48, -0.036187
15.483333, -0.038797
15.486667, -0.041385
15.49, -0.043898
15.493333, -0.046015
15.496667, -0.047695
15.5, -0.049132
15.503333, -0.050244
15.506667, -0.05086
15.51, -0.051159
15.513333, -0.051446
15.516667, -0.051804
15.52, -0.052312
15.523333, -0.053229
15.526667, -0.054767
15.53, -0.056943
15.533333, -0.059524
15.536667, -0.061823
15.54, -0.062926
15.543333, -0.06247
15.546667, -0.061004
15.55, -0.059505
15.553333, -0.05865
15.556667, -0.058616
15.56, -0.05928
15.563333, -0.060309
15.566667, -0.061232
15.57, -0.061801
15.573333, -0.062079
15.576667, -0.062137
15.58, -0.061995
15.583333, -0.06165
15.586667, -0.061121
15.59, -0.060603
15.593333, -0.060187
15.596667, -0.059574
15.6, -0.058668
15.603333, -0.058113
15.606667, -0.05875
15.61, -0.060765
15.613333, -0.063457
15.616667, -0.065656
15.62, -0.066507
15.623333, -0.066115
15.626667, -0.065358
15.63, -0.065064
15.633333, -0.065506
15.636667, -0.066537
15.64, -0.067706
15.643333, -0.068307
15.646667, -0.06803
15.65, -0.067284
15.653333, -0.066386
15.656667, -0.065259
15.66, -0.063981
15.663333, -0.062703
15.666667, -0.061296
15.67, -0.059673
15.673333, -0.058189
15.676667, -0.057473
15.68, -0.057854
15.683333, -0.059036
15.686667, -0.060394
15.69, -0.061386
15.693333, -0.061617
15.696667, -0.06095
15.7, -0.059646
15.703333, -0.058159
15.706667, -0.05682
15.71, -0.055746
15.713333, -0.054967
15.716667, -0.05465
15.72, -0.055038
15.723333, -0.056099
15.726667, -0.057453
15.73, -0.058588
15.733333, -0.059057
15.736667, -0.05863
15.74, -0.057445
15.743333, -0.05603
15.746667, -0.05506
15.75, -0.055004
15.753333, -0.055896
15.756667, -0.057249
15.76, -0.058099
15.763333, -0.057583
15.766667, -0.055793
15.77, -0.053768
15.773333, -0.052465
15.776667, -0.051887
15.78, -0.05129
15.783333, -0.050072
15.786667, -0.048376
15.79, -0.047023
15.793333, -0.046915
15.796667, -0.048214
15.8, -0.050023
15.803333, -0.051158
15.806667, -0.051224
15.81, -0.050624
15.813333, -0.049908
15.816667, -0.049522
15.82, -0.049703
15.823333, -0.050317
15.826667, -0.051016
15.83, -0.051593
15.833333, -0.051927
15.836667, -0.051739
15.84, -0.050816
15.843333, -0.04935
15.846667, -0.047859
15.85, -0.046768
15.853333, -0.046044
15.856667, -0.04536
15.86, -0.044715
15.863333, -0.044545
15.866667, -0.045106
15.87, -0.046046
15.873333, -0.046848
15.876667, -0.047352
15.88, -0.047511
15.883333, -0.047133
15.886667, -0.04625
15.89, -0.045202
15.893333, -0.044338
15.896667, -0.043953
15.9, -0.044104
15.903333, -0.044529
15.906667, -0.045078
15.91, -0.045881
15.913333, -0.046885
15.916667, -0.047684
15.92, -0.048
15.923333, -0.047956
15.926667, -0.047852
15.93, -0.047898
15.933333, -0.048086
15.936667, -0.048178
15.94, -0.048056
15.943333, -0.047914
15.946667, -0.047754
15.95, -0.047194
15.953333, -0.046025
15.956667, -0.044459
15.96, -0.042697
15.963333, -0.040801
15.966667, -0.039032
15.97, -0.0378
15.973333, -0.037283
15.976667, -0.037575
15.98, -0.038864
15.983333, -0.041152
15.986667, -0.0441
15.99, -0.047142
15.993333, -0.049698
15.996667, -0.051458
16.0, -0.052442
16.003333, -0.052863
16.006667, -0.05303
16.01, -0.053146
16.013333, -0.052955
16.016667, -0.051871
16.02, -0.04982
16.023333, -0.047584
16.026667, -0.046027
16.03, -0.045583
16.033333, -0.046383
16.036667, -0.048302
16.04, -0.050968
16.043333, -0.053719
16.046667, -0.055758
16.05, -0.056679
16.053333, -0.056669
16.056667, -0.056178
16.06, -0.05558
16.063333, -0.055039
16.066667, -0.054529
16.07, -0.054007
16.073333, -0.053593
16.076667, -0.053566
16.08, -0.054233
16.083333, -0.055727
16.086667, -0.057884
16.09, -0.060324
16.093333, -0.062527
16.096667, -0.063872
16.1, -0.063975
16.103333, -0.063195
16.106667, -0.06256
16.11, -0.062935
16.113333, -0.064436
16.116667, -0.066624
16.12, -0.06888
16.123333, -0.070623
16.126667, -0.071535
16.13, -0.071746
16.133333, -0.071728
16.136667, -0.071976
16.14, -0.072711
16.143333, -0.073797
16.146667, -0.075044
16.15, -0.076397
16.153333, -0.077641
16.156667, -0.078299
16.16, -0.078
16.163333, -0.076777
16.166667, -0.075078
16.17, -0.073399
16.173333, -0.071846
16.176667, -0.070396
16.18, -0.069418
16.183333, -0.069384
16.186667, -0.07031
16.19, -0.071726
16.193333, -0.073037
16.196667, -0.073935
16.2, -0.074528
16.203333, -0.075101
16.206667, -0.075898
16.21, -0.077046
16.213333, -0.078433
16.216667, -0.079666
16.22, -0.080418
16.223333, -0.080796
16.226667, -0.080995
16.23, -0.080834
16.233333, -0.080098
16.236667, -0.078988
16.24, -0.077946
16.243333, -0.077319
16.246667, -0.077247
16.25, -0.077624
16.253333, -0.078163
16.256667, -0.078659
16.26, -0.079137
16.263333, -0.079761
16.266667, -0.08063
16.27, -0.081602
16.273333, -0.08242
16.276667, -0.082964
16.28, -0.083288
16.283333, -0.083476
16.286667, -0.083535
16.29, -0.083552
16.293333, -0.083904
16.296667, -0.084988
16.3, -0.08675
16.303333, -0.088655
16.306667, -0.090066
16.31, -0.090697
16.313333, -0.090737
16.316667, -0.090466
16.32, -0.08997
16.323333, -0.089408
16.326667, -0.089133
16.33, -0.089295
16.333333, -0.089693
16.336667, -0.090054
16.34, -0.09018
16.343333, -0.089984
16.346667, -0.089627
16.35, -0.089483
16.353333, -0.089986
16.356667, -0.091389
16.36, -0.093334
16.363333, -0.095013
16.366667, -0.095983
16.37, -0.096426
16.373333, -0.096751
16.376667, -0.097276
16.38, -0.098124
16.383333, -0.099206
16.386667, -0.100228
16.39, -0.100739
16.393333, -0.100544
16.396667, -0.100127
16.4, -0.100275
16.403333, -0.101171
16.406667, -0.10213
16.41, -0.102321
16.413333, -0.101612
16.416667, -0.10056
16.42, -0.099798
16.423333, -0.099528
16.426667, -0.099469
16.43, -0.099367
16.433333, -0.099211
16.436667, -0.098911
16.44, -0.098382
16.443333, -0.097697
16.446667, -0.096808
16.45, -0.09557
16.453333, -0.094144
16.456667, -0.09306
16.46, -0.092921
16.463333, -0.093917
16.466667, -0.095609
16.47, -0.097393
16.473333, -0.098932
16.476667, -0.100051
16.48, -0.100547
16.483333, -0.100227
16.486667, -0.099069
16.49, -0.097318
16.493333, -0.095343
16.496667, -0.093324
16.5, -0.091286
16.503333, -0.089511
16.506667, -0.088475
16.51, -0.088313
16.513333, -0.088777
16.516667, -0.089455
16.52, -0.089729
16.523333, -0.088994
16.526667, -0.087252
16.53, -0.08537
16.533333, -0.084353
16.536667, -0.084335
16.54, -0.084741
16.543333, -0.085016
16.546667, -0.084843
16.55, -0.084122
16.553333, -0.082979
16.556667, -0.081722
16.56, -0.080656
16.563333, -0.079794
16.566667, -0.078917
16.57, -0.077972
16.573333, -0.077074
16.576667, -0.076161
16.58, -0.075009
16.583333, -0.073526
16.586667, -0.071928
16.59, -0.070685
16.593333, -0.070136
16.596667, -0.070236
16.6, -0.070833
16.603333, -0.071785
16.606667, -0.072748
16.61, -0.073223
16.613333, -0.072818
16.616667, -0.071406
16.62, -0.069279
16.623333, -0.067134
16.626667, -0.065634
16.63, -0.064958
16.633333, -0.064853
16.636667, -0.06498
16.64, -0.065182
16.643333, -0.0655
16.646667, -0.065909
16.65, -0.066161
16.653333, -0.06609
16.656667, -0.065995
16.66, -0.066373
16.663333, -0.067172
16.666667, -0.067704
16.67, -0.067547
16.673333, -0.067073
16.676667, -0.066752
16.68, -0.066515
16.683333, -0.066221
16.686667, -0.066047
16.69, -0.066013
16.693333, -0.065852
16.696667, -0.065614
16.7, -0.065755
16.703333, -0.066618
16.706667, -0.06817
16.71, -0.070004
16.713333, -0.071528
16.716667, -0.072346
16.72, -0.072349
16.723333, -0.071707
16.726667, -0.070787
16.73, -0.069886
16.733333, -0.069251
16.736667, -0.069079
16.74, -0.069276
16.743333, -0.069571
16.746667, -0.069835
16.75, -0.070084
16.753333, -0.070464
16.756667, -0.071065
16.76, -0.071443
16.763333, -0.070859
16.766667, -0.069168
16.77, -0.067048
16.773333, -0.065299
16.776667, -0.06423
16.78, -0.063859
16.783333, -0.064351
16.786667, -0.065895
16.79, -0.06832
16.793333, -0.071149
16.796667, -0.073953
16.8, -0.076435
16.803333, -0.078292
16.806667, -0.079266
16.81, -0.079355
16.813333, -0.078758
16.816667, -0.077739
16.82, -0.076731
16.823333, -0.076121
16.826667, -0.075901
16.83, -0.075779
16.833333, -0.075498
16.836667, -0.075074
16.84, -0.074786
16.843333, -0.074852
16.846667, -0.075299
16.85, -0.076258
16.853333, -0.077965
16.856667, -0.080409
16.86, -0.083265
16.863333, -0.085911
16.866667, -0.087613
16.87, -0.088118
16.873333, -0.087866
16.876667, -0.087605
16.88, -0.087889
16.883333, -0.088687
16.886667, -0.089485
16.89, -0.089957
16.893333, -0.09033
16.896667, -0.090925
16.9, -0.091636
16.903333, -0.092279
16.906667, -0.092965
16.91, -0.093696
16.913333, -0.094223
16.916667, -0.094553
16.92, -0.095038
16.923333, -0.095818
16.926667, -0.096524
16.93, -0.096632
16.933333, -0.095924
16.936667, -0.094612
16.94, -0.093284
16.943333, -0.09263
16.946667, -0.092876
16.95, -0.093554
16.953333, -0.094079
16.956667, -0.094423
16.96, -0.094957
16.963333, -0.095914
16.966667, -0.097126
16.97, -0.098253
16.973333, -0.099186
16.976667, -0.100018
16.98, -0.100931
16.983333, -0.102229
16.986667, -0.1039
16.99, -0.105187
16.993333, -0.105199
16.996667, -0.103859
17.0, -0.102001
17.003333, -0.100682
17.006667, -0.100408
17.01, -0.100979
17.013333, -0.101904
17.016667, -0.102701
17.02, -0.103086
17.023333, -0.103314
17.026667, -0.103946
17.03, -0.105127
17.033333, -0.106544
17.036667, -0.10789
17.04, -0.108985
17.043333, -0.109724
17.046667, -0.110092
17.05, -0.110089
17.053333, -0.109586
17.056667, -0.108527
17.06, -0.107392
17.063333, -0.106993
17.066667, -0.107597
17.07, -0.108595
17.073333, -0.10903
17.076667, -0.10844
17.08, -0.107243
17.083333, -0.106183
17.086667, -0.105577
17.09, -0.10525
17.093333, -0.105075
17.096667, -0.105232
17.1, -0.105822
17.103333, -0.10662
17.106667, -0.107318
17.11, -0.107706
17.113333, -0.107651
17.116667, -0.107108
17.12, -0.106175
17.123333, -0.105149
17.126667, -0.104416
17.13, -0.104131
17.133333, -0.104249
17.136667, -0.104833
17.14, -0.105905
17.143333, -0.107086
17.146667, -0.107867
17.15, -0.108077
17.153333, -0.107751
17.156667, -0.10694
17.16, -0.105907
17.163333, -0.105045
17.166667, -0.104598
17.17, -0.104693
17.173333, -0.105118
17.176667, -0.105173
17.18, -0.104293
17.183333, -0.10259
17.186667, -0.100568
17.19, -0.098609
17.193333, -0.096988
17.196667, -0.096028
17.2, -0.095903
17.203333, -0.096488
17.206667, -0.09734
17.21, -0.097865
17.213333, -0.097814
17.216667, -0.097563
17.22, -0.097756
17.223333, -0.098599
17.226667, -0.099554
17.23, -0.099869
17.233333, -0.099364
17.236667, -0.098593
17.24, -0.098278
17.243333, -0.098569
17.246667, -0.098921
17.25, -0.098675
17.253333, -0.097688
17.256667, -0.096417
17.26, -0.09535
17.263333, -0.094574
17.266667, -0.093941
17.27, -0.093254
17.273333, -0.092313
17.276667, -0.091145
17.28, -0.090043
17.283333, -0.089389
17.286667, -0.089651
17.29, -0.091174
17.293333, -0.09389
17.296667, -0.097336
17.3, -0.100696
17.303333, -0.103081
17.306667, -0.104077
17.31, -0.103865
17.313333, -0.102853
17.316667, -0.101413
17.32, -0.099832
17.323333, -0.09837
17.326667, -0.0973
17.33, -0.096686
17.333333, -0.096315
17.336667, -0.096076
17.34, -0.096014
17.343333, -0.095994
17.346667, -0.095705
17.35, -0.095044
17.353333, -0.094268
17.356667, -0.093773
17.36, -0.093718
17.363333, -0.093864
17.366667, -0.093877
17.37, -0.093627
17.373333, -0.093134
17.376667, -0.092551
17.38, -0.092176
17.383333, -0.092133
17.386667, -0.092178
17.39, -0.092022
17.393333, -0.0916
17.396667, -0.090816
17.4, -0.089461
17.403333, -0.087736
17.406667, -0.086443
17.41, -0.08632
17.413333, -0.087328
17.416667, -0.088639
17.42, -0.08919
17.423333, -0.088388
17.426667, -0.086417
17.43, -0.083973
17.433333, -0.081762
17.436667, -0.080312
17.44, -0.080124
17.443333, -0.081565
17.446667, -0.084368
17.45, -0.087604
17.453333, -0.090335
17.456667, -0.092062
17.46, -0.092538
17.463333, -0.091595
17.466667, -0.089663
17.47, -0.087986
17.473333, -0.087538
17.476667, -0.088119
17.48, -0.089054
17.483333, -0.090165
17.486667, -0.091697
17.49, -0.093642
17.493333, -0.095441
17.496667, -0.096519
17.5, -0.096966
17.503333, -0.097272
17.506667, -0.09756
17.51, -0.097481
17.513333, -0.096688
17.516667, -0.095331
17.52, -0.094231
17.523333, -0.094261
17.526667, -0.095371
17.53, -0.096627
17.533333, -0.097247
17.536667, -0.09707
17.54, -0.096116
17.543333, -0.094479
17.546667, -0.092653
17.55, -0.09132
17.553333, -0.090932
17.556667, -0.091613
17.56, -0.093147
17.563333, -0.095058
17.566667, -0.096838
17.57, -0.098141
17.573333, -0.098733
17.576667, -0.098333
17.58, -0.096808
17.583333, -0.094555
17.586667, -0.092302
17.59, -0.09054
17.593333, -0.08943
17.596667, -0.088966
17.6, -0.089005
17.603333, -0.089388
17.606667, -0.090116
17.61, -0.09122
17.613333, -0.092504
17.616667, -0.093547
17.62, -0.093951
17.623333, -0.093733
17.626667, -0.09352
17.63, -0.094051
17.633333, -0.095381
17.636667, -0.096823
17.64, -0.097585
17.643333, -0.097384
17.646667, -0.096578
17.65, -0.095657
17.653333, -0.094824
17.656667, -0.094271
17.66, -0.094487
17.663333, -0.095963
17.666667, -0.098572
17.67, -0.101412
17.673333, -0.10353
17.676667, -0.104711
17.68, -0.105311
17.683333, -0.105564
17.686667, -0.105319
17.69, -0.10424
17.693333, -0.102176
17.696667, -0.099637
17.7, -0.097686
17.703333, -0.097147
17.706667, -0.098055
17.71, -0.099731
17.713333, -0.101276
17.716667, -0.102141
17.72, -0.10234
17.723333, -0.102285
17.726667, -0.102509
17.73, -0.103468
17.733333, -0.105212
17.736667, -0.107251
17.74, -0.10914
17.743333, -0.110788
17.746667, -0.112091
17.75, -0.112884
17.753333, -0.113143
17.756667, -0.112951
17.76, -0.11248
17.763333, -0.111831
17.766667, -0.110828
17.77, -0.109367
17.773333, -0.107919
17.776667, -0.107245
17.78, -0.10769
17.783333, -0.109057
17.786667, -0.110937
17.79, -0.112818
17.793333, -0.11412
17.796667, -0.114451
17.8, -0.113865
17.803333, -0.112776
17.806667, -0.111668
17.81, -0.110873
17.813333, -0.110387
17.816667, -0.10988
17.82, -0.109003
17.823333, -0.107684
17.826667, -0.106246
17.83, -0.105089
17.833333, -0.104324
17.836667, -0.104029
17.84, -0.104485
17.843333, -0.105939
17.846667, -0.108475
17.85, -0.111847
17.853333, -0.115071
17.856667, -0.116641
17.86, -0.115639
17.863333, -0.112632
17.866667, -0.109272
17.87, -0.106934
17.873333, -0.10588
17.876667, -0.105639
17.88, -0.105749
17.883333, -0.105959
17.886667, -0.105982
17.89, -0.105534
17.893333, -0.104643
17.896667, -0.103742
17.9, -0.103463
17.903333, -0.104187
17.906667, -0.105757
17.91, -0.107656
17.913333, -0.109469
17.916667, -0.111281
17.92, -0.113456
17.923333, -0.115796
17.926667, -0.1173
17.93, -0.117037
17.933333, -0.115037
17.936667, -0.112176
17.94, -0.109537
17.943333, -0.107914
17.946667, -0.107437
17.95, -0.107518
17.953333, -0.107388
17.956667, -0.106674
17.96, -0.105441
17.963333, -0.104047
17.966667, -0.102927
17.97, -0.102285
17.973333, -0.102196
17.976667, -0.102845
17.98, -0.104259
17.983333, -0.10607
17.986667, -0.107727
17.99, -0.108759
17.993333, -0.108847
17.996667, -0.108021
18.0, -0.106775
18.003333, -0.105434
18.006667, -0.10365
18.01, -0.101173
18.013333, -0.09864
18.016667, -0.097014
18.02, -0.096607
18.023333, -0.09712
18.026667, -0.0983
18.03, -0.099944
18.033333, -0.101555
18.036667, -0.102544
18.04, -0.102656
18.043333, -0.10223
18.046667, -0.10201
18.05, -0.102474
18.053333, -0.103421
18.056667, -0.10418
18.06, -0.104106
18.063333, -0.102967
18.066667, -0.101039
18.07, -0.09896
18.073333, -0.09751
18.076667, -0.09741
18.08, -0.098955
18.083333, -0.101486
18.086667, -0.103651
18.09, -0.104606
18.093333, -0.104521
18.096667, -0.103979
18.1, -0.103578
18.103333, -0.103854
18.106667, -0.104864
18.11, -0.105934
18.113333, -0.106193
18.116667, -0.105388
18.12, -0.104066
18.123333, -0.102974
18.126667, -0.102462
18.13, -0.102436
18.133333, -0.102546
18.136667, -0.102395
18.14, -0.101783
18.143333, -0.1009
18.146667, -0.100274
18.15, -0.100311
18.153333, -0.100875
18.156667, -0.101464
18.16, -0.101609
18.163333, -0.101241
18.166667, -0.100746
18.17, -0.10038
18.173333, -0.100027
18.176667, -0.099791
18.18, -0.1001
18.183333, -0.101038
18.186667, -0.102135
18.19, -0.102859
18.193333, -0.103013
18.196667, -0.10281
18.2, -0.102661
18.203333, -0.102752
18.206667, -0.103068
18.21, -0.103638
18.213333, -0.104361
18.216667, -0.104966
18.22, -0.10531
18.223333, -0.105328
18.226667, -0.104972
18.23, -0.104459
18.233333, -0.104203
18.236667, -0.104352
18.24, -0.104672
18.243333, -0.104866
18.246667, -0.104763
18.25, -0.104408
18.253333, -0.104119
18.256667, -0.104199
18.26, -0.104569
18.263333, -0.104875
18.266667, -0.104838
18.27, -0.104398
18.273333, -0.103718
18.276667, -0.103158
18.28, -0.103054
18.283333, -0.103541
18.286667, -0.104475
18.29, -0.105396
18.293333, -0.105843
18.296667, -0.105764
18.3, -0.105489
18.303333, -0.105373
18.306667, -0.10559
18.31, -0.106166
18.313333, -0.107079
18.316667, -0.108208
18.32, -0.109197
18.323333, -0.109642
18.326667, -0.109329
18.33, -0.10812
18.333333, -0.105971
18.336667, -0.103186
18.34, -0.100465
18.343333, -0.098611
18.346667, -0.098127
18.35, -0.099016
18.353333, -0.100698
18.356667, -0.102317
18.36, -0.10344
18.363333, -0.104226
18.366667, -0.104929
18.37, -0.105479
18.373333, -0.105536
18.376667, -0.105001
18.38, -0.104365
18.383333, -0.104377
18.386667, -0.105338
18.39, -0.106791
18.393333, -0.107884
18.396667, -0.107952
18.4, -0.10683
18.403333, -0.104764
18.406667, -0.102221
18.41, -0.099912
18.413333, -0.09862
18.416667, -0.098586
18.42, -0.099378
18.423333, -0.100445
18.426667, -0.101396
18.43, -0.102033
18.433333, -0.102514
18.436667, -0.103218
18.44, -0.104273
18.443333, -0.105274
18.446667, -0.105591
18.45, -0.10498
18.453333, -0.103788
18.456667, -0.10265
18.46, -0.101936
18.463333, -0.101553
18.466667, -0.101339
18.47, -0.101235
18.473333, -0.101129
18.476667, -0.101015
18.48, -0.10104
18.483333, -0.101293
18.486667, -0.101799
18.49, -0.102517
18.493333, -0.103219
18.496667, -0.103605
18.5, -0.103554
18.503333, -0.103194
18.506667, -0.102775
18.51, -0.102403
18.513333, -0.101929
18.516667, -0.101107
18.52, -0.09986
18.523333, -0.098433
18.526667, -0.097269
18.53, -0.096711
18.533333, -0.09695
18.536667, -0.09799
18.54, -0.099692
18.543333, -0.102003
18.546667, -0.104648
18.55, -0.106921
18.553333, -0.108311
18.556667, -0.10892
18.56, -0.109168
18.563333, -0.109268
18.566667, -0.109018
18.57, -0.108323
18.573333, -0.107575
18.576667, -0.107216
18.58, -0.107271
18.583333, -0.107342
18.586667, -0.106913
18.59, -0.105767
18.593333, -0.104215
18.596667, -0.102804
18.6, -0.101836
18.603333, -0.101392
18.606667, -0.101553
18.61, -0.102205
18.613333, -0.102853
18.616667, -0.102819
18.62, -0.101744
18.623333, -0.099981
18.626667, -0.09835
18.63, -0.097461
18.633333, -0.097416
18.636667, -0.09808
18.64, -0.099173
18.643333, -0.100145
18.646667, -0.10055
18.65, -0.100426
18.653333, -0.09996
18.656667, -0.099164
18.66, -0.098034
18.663333, -0.096687
18.666667, -0.09529
18.67, -0.094001
18.673333, -0.092876
18.676667, -0.091884
18.68, -0.091133
18.683333, -0.090675
18.686667, -0.090183
18.69, -0.089257
18.693333, -0.087894
18.696667, -0.08646
18.7, -0.085335
18.703333, -0.084748
18.706667, -0.084877
18.71, -0.085776
18.713333, -0.087146
18.716667, -0.088469
18.72, -0.089556
18.723333, -0.090673
18.726667, -0.091938
18.73, -0.092864
18.733333, -0.092816
18.736667, -0.091708
18.74, -0.090033
18.743333, -0.088445
18.746667, -0.087411
18.75, -0.08713
18.753333, -0.087523
18.756667, -0.088077
18.76, -0.088167
18.763333, -0.087657
18.766667, -0.08681
18.77, -0.085908
18.773333, -0.08518
18.776667, -0.084677
18.78, -0.084317
18.783333, -0.084123
18.786667, -0.084202
18.79, -0.084507
18.793333, -0.084828
18.796667, -0.085039
18.8, -0.085129
18.803333, -0.08512
18.806667, -0.085242
18.81, -0.085983
18.813333, -0.087626
18.816667, -0.089783
18.82, -0.091677
18.823333, -0.092917
18.826667, -0.093829
18.83, -0.094825
18.833333, -0.095611
18.836667, -0.095522
18.84, -0.094509
18.843333, -0.0932
18.846667, -0.092153
18.85, -0.091445
18.853333, -0.090769
18.856667, -0.08979
18.86, -0.088607
18.863333, -0.087862
18.866667, -0.088219
18.87, -0.089741
18.873333, -0.091867
18.876667, -0.093881
18.88, -0.095268
18.883333, -0.0958
18.886667, -0.095359
18.89, -0.093862
18.893333, -0.091642
18.896667, -0.08945
18.9, -0.08782
18.903333, -0.086863
18.906667, -0.086522
18.91, -0.086619
18.913333, -0.086935
18.916667, -0.087454
18.92, -0.088322
18.923333, -0.089578
18.926667, -0.090999
18.93, -0.092157
18.933333, -0.09274
18.936667, -0.092865
18.94, -0.092854
18.943333, -0.092552
18.946667, -0.09127
18.95, -0.088834
18.953333, -0.086249
18.956667, -0.084785
18.96, -0.08477
18.963333, -0.085709
18.966667, -0.086911
18.97, -0.087825
18.973333, -0.088357
18.976667, -0.088866
18.98, -0.089807
18.983333, -0.091423
18.986667, -0.093513
18.99, -0.095501
18.993333, -0.096761
18.996667, -0.096872
19.0, -0.096034
19.003333, -0.095273
19.006667, -0.095538
19.01, -0.096745
19.013333, -0.098125
19.016667, -0.099231
19.02, -0.100309
19.023333, -0.101863
19.026667, -0.104063
19.03, -0.106528
19.033333, -0.10841
19.036667, -0.108832
19.04, -0.107593
19.043333, -0.105478
19.046667, -0.103676
19.05, -0.102944
19.053333, -0.103492
19.056667, -0.105309
19.06, -0.108063
19.063333, -0.111073
19.066667, -0.113771
19.07, -0.115996
19.073333, -0.117744
19.076667, -0.118835
19.08, -0.119175
19.083333, -0.119185
19.086667, -0.119513
19.09, -0.120421
19.093333, -0.121594
19.096667, -0.122472
19.1, -0.122751
19.103333, -0.122492
19.106667, -0.121914
19.11, -0.121341
19.113333, -0.121096
19.116667, -0.121291
19.12, -0.121913
19.123333, -0.123014
19.126667, -0.124681
19.13, -0.126766
19.133333, -0.128738
19.136667, -0.129967
19.14, -0.130142
19.143333, -0.129398
19.146667, -0.128218
19.15, -0.12717
19.153333, -0.126494
19.156667, -0.125996
19.16, -0.125492
19.163333, -0.125157
19.166667, -0.125391
19.17, -0.12647
19.173333, -0.128055
19.176667, -0.12924
19.18, -0.129479
19.183333, -0.12901
19.186667, -0.128299
19.19, -0.127643
19.193333, -0.127301
19.196667, -0.127508
19.2, -0.128335
19.203333, -0.129555
19.206667, -0.130606
19.21, -0.130986
19.213333, -0.130709
19.216667, -0.130107
19.22, -0.129434
19.223333, -0.128839
19.226667, -0.128455
19.23, -0.128377
19.233333, -0.128729
19.236667, -0.1297
19.24, -0.131332
19.243333, -0.133349
19.246667, -0.13518
19.25, -0.136112
19.253333, -0.135738
19.256667, -0.13418
19.26, -0.131866
19.263333, -0.129541
19.266667, -0.128045
19.27, -0.127532
19.273333, -0.12727
19.276667, -0.126525
19.28, -0.125415
19.283333, -0.124473
19.286667, -0.123655
19.29, -0.122554
19.293333, -0.121246
19.296667, -0.120248
19.3, -0.119952
19.303333, -0.12027
19.306667, -0.120768
19.31, -0.121184
19.313333, -0.121583
19.316667, -0.122028
19.32, -0.122377
19.323333, -0.122468
19.326667, -0.122315
19.33, -0.122085
19.333333, -0.121881
19.336667, -0.121613
19.34, -0.121158
19.343333, -0.120407
19.346667, -0.119296
19.35, -0.118085
19.353333, -0.117241
19.356667, -0.116821
19.36, -0.116466
19.363333, -0.115937
19.366667, -0.115151
19.37, -0.113979
19.373333, -0.112398
19.376667, -0.110625
19.38, -0.109036
19.383333, -0.10819
19.386667, -0.108633
19.39, -0.110152
19.393333, -0.111566
19.396667, -0.111737
19.4, -0.110499
19.403333, -0.108511
19.406667, -0.106742
19.41, -0.106085
19.413333, -0.106971
19.416667, -0.109268
19.42, -0.112364
19.423333, -0.115237
19.426667, -0.116908
19.43, -0.117031
19.433333, -0.115949
19.436667, -0.114133
19.44, -0.111724
19.443333, -0.108862
19.446667, -0.106167
19.45, -0.104533
19.453333, -0.104547
19.456667, -0.106093
19.46, -0.108342
19.463333, -0.110155
19.466667, -0.110757
19.47, -0.110294
19.473333, -0.109605
19.476667, -0.109416
19.48, -0.109964
19.483333, -0.111161
19.486667, -0.112675
19.49, -0.113919
19.493333, -0.114252
19.496667, -0.113382
19.5, -0.111634
19.503333, -0.109777
19.506667, -0.108429
19.51, -0.107648
19.513333, -0.107246
19.516667, -0.107192
19.52, -0.107584
19.523333, -0.108424
19.526667, -0.109415
19.53, -0.110236
19.533333, -0.111068
19.536667, -0.112488
19.54, -0.11486
19.543333, -0.117916
19.546667, -0.120859
19.55, -0.122838
19.553333, -0.123472
19.556667, -0.123223
19.56, -0.123102
19.563333, -0.123753
19.566667, -0.124925
19.57, -0.125783
19.573333, -0.125688
19.576667, -0.124632
19.58, -0.122862
19.583333, -0.120597
19.586667, -0.118429
19.59, -0.117191
19.593333, -0.117025
19.596667, -0.117242
19.6, -0.11716
19.603333, -0.116549
19.606667, -0.115538
19.61, -0.114516
19.613333, -0.11389
19.616667, -0.113756
19.62, -0.113825
19.623333, -0.113781
19.626667, -0.11374
19.63, -0.114039
19.633333, -0.114534
19.636667, -0.114716
19.64, -0.114269
19.643333, -0.113182
19.646667, -0.111964
19.65, -0.111558
19.653333, -0.112431
19.656667, -0.114185
19.66, -0.116212
19.663333, -0.118081
19.666667, -0.119337
19.67, -0.119585
19.673333, -0.118819
19.676667, -0.117338
19.68, -0.115515
19.683333, -0.113679
19.686667, -0.112069
19.69, -0.11087
19.693333, -0.110187
19.696667, -0.110024
19.7, -0.110484
19.703333, -0.111667
19.706667, -0.113393
19.71, -0.115378
19.713333, -0.117391
19.716667, -0.119096
19.72, -0.120156
19.723333, -0.120516
19.726667, -0.120355
19.73, -0.119769
19.733333, -0.118655
19.736667, -0.116904
19.74, -0.114637
19.743333, -0.112271
19.746667, -0.110312
19.75, -0.109054
19.753333, -0.108459
19.756667, -0.10834
19.76, -0.108516
19.763333, -0.108784
19.766667, -0.108962
19.77, -0.109024
19.773333, -0.109027
19.776667, -0.108936
19.78, -0.108573
19.783333, -0.10774
19.786667, -0.106537
19.79, -0.105432
19.793333, -0.104842
19.796667, -0.104869
19.8, -0.105379
19.803333, -0.106033
19.806667, -0.106332
19.81, -0.105886
19.813333, -0.104753
19.816667, -0.103416
19.82, -0.102414
19.823333, -0.102158
19.826667, -0.102917
19.83, -0.104702
19.833333, -0.107228
19.836667, -0.110046
19.84, -0.112589
19.843333, -0.114203
19.846667, -0.114557
19.85, -0.113884
19.853333, -0.112589
19.856667, -0.110952
19.86, -0.109416
19.863333, -0.108636
19.866667, -0.108928
19.87, -0.110064
19.873333, -0.111619
19.876667, -0.113204
19.88, -0.11445
19.883333, -0.115061
19.886667, -0.115073
19.89, -0.114901
19.893333, -0.115009
19.896667, -0.115641
19.9, -0.116792
19.903333, -0.118232
19.906667, -0.119558
19.91, -0.120498
19.913333, -0.121303
19.916667, -0.12268
19.92, -0.125096
19.923333, -0.128304
19.926667, -0.131539
19.93, -0.134007
19.933333, -0.135379
19.936667, -0.135949
19.94, -0.136233
19.943333, -0.136496
19.946667, -0.136821
19.95, -0.137358
19.953333, -0.138069
19.956667, -0.138481
19.96, -0.138041
19.963333, -0.136645
19.966667, -0.134879
19.97, -0.133718
19.973333, -0.133755
19.976667, -0.13476
19.98, -0.136128
19.983333, -0.137612
19.986667, -0.139575
19.99, -0.142386
19.993333, -0.145656
19.996667, -0.148477
20.0, -0.15028
$$ === CHEMSPECTRA INTEGRALS AND MULTIPLETS ===
##$OBSERVEDINTEGRALS= (X Y Z)
(9.394213430867943, 10.304964562918867, 1.0, 22120.716864999988)
##$OBSERVEDMULTIPLETS=
##$OBSERVEDMULTIPLETSPEAKS=
$$ === CHEMSPECTRA SIMULATION ===
##$CSSIMULATIONPEAKS=
##END=


$$ === CHEMSPECTRA PEAK TABLE EDIT ===
##TITLE=multi_hplc.2_bagit
##JCAMP-DX=5.00
##DATA TYPE=HPLC UVVISPEAKTABLE
##DATA CLASS=PEAKTABLE
##$CSCATEGORY=EDIT_PEAK
##$CSTHRESHOLD=0.05
##MAXX=20.0
##MAXY=409.809016
##MINX=0.0
##MINY=-3.282643
##$CSSOLVENTNAME=- - -
##$CSSOLVENTVALUE=0
##$CSSOLVENTX=0
##NPOINTS=2
##PEAKTABLE= (XY..XY)
7.61, 85.238486
9.703333, 409.809016
##END=


$$ === CHEMSPECTRA PEAK TABLE AUTO ===
##TITLE=multi_hplc.2_bagit
##JCAMP-DX=5.00
##DATA TYPE=HPLC UVVISPEAKTABLE
##DATA CLASS=PEAKTABLE
##$CSCATEGORY=AUTO_PEAK
##$CSTHRESHOLD=0.05
##MAXX=20.0
##MAXY=409.809016
##MINX=0.0
##MINY=-3.282643
##NPOINTS=2
##PEAKTABLE= (XY..XY)
9.703333, 409.809016
7.61, 85.238486
##END=


$$ === CHEMSPECTRA ORIGINAL METADATA ===
###TITLE= multi_hplc.2_bagit, multi_hplc.2_bagit, multi_hplc.2_bagit, multi_hplc.2_bagit
###JCAMPDX= 5.0, 5.00, 5.00, 5.00
###BLOCKS= 1
###$CSCATEGORY= SPECTRUM, EDIT_PEAK, AUTO_PEAK
###XUNITS= MINUTES
###YUNITS= TRANSMITTANCE
###LASTX= 20.0
###MAXX= 20.0, 20.0, 20.0
###MAXY= 409.809016, 409.809016, 409.809016
###MINX= 0.0, 0.0, 0.0
###MINY= -3.282643, -3.282643, -3.282643
###NPOINTS= 6001, 2, 2
###$OBSERVEDINTEGRALS= (X Y Z)
(7.413329086489642, 7.823167765266425, 1.0, 3413.1955639406297)
(9.439751061843141, 10.054507964418537, 6.386339534981634, 21987.83036068991)
###$CSTHRESHOLD= 0.05, 0.05
###$CSSOLVENTNAME= - - -
###$CSSOLVENTVALUE= 0
###$CSSOLVENTX= 0
###TITLE= multi_hplc.2_bagit, multi_hplc.2_bagit, multi_hplc.2_bagit, multi_hplc.2_bagit, Spectrum
###JCAMPDX= 5.0, 5.00, 5.00, 5.00, 5.0, 5.00, 5.00, 5.00, 5.00
###BLOCKS= 1, 1
###$CSCATEGORY= SPECTRUM, EDIT_PEAK, AUTO_PEAK, SPECTRUM, EDIT_PEAK, AUTO_PEAK
###XUNITS= MINUTES, MINUTES, MINUTES
###YUNITS= TRANSMITTANCE, TRANSMITTANCE, MILLI-ABSORBANCE UNITS
###LASTX= 20.0, 20.0, 20.000000
###MAXX= 20.0, 20.0, 20.0, 20.0, 20.0, 20.0, 20.0
###MAXY= 409.809016, 409.809016, 409.809016, 409.809016, 409.809016, 409.809016, 409.809016
###MINX= 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0
###MINY= -3.282643, -3.282643, -3.282643, -3.282643, -3.282643, -3.282643, -3.282643
###NPOINTS= 6001, 0, 2, 6001, 0, 2, 6001
###$OBSERVEDINTEGRALS= (X Y Z), (X Y Z)
###$CSTHRESHOLD= 0.05, 0.05, 0.05, 0.05
###$CSSOLVENTVALUE= 0, 0
###$CSSOLVENTX= 0, 0
###XYPOINTS= (XY..XY)
0.000000, 0.000000
0.003333, -0.000047
0.006667, -0.000337
0.010000, -0.001167
0.013333, -0.002606
0.016667, -0.004291
0.020000, -0.005884
0.023333, -0.007674
0.026667, -0.010137
0.030000, -0.013055
0.033333, -0.015608
0.036667, -0.017150
0.040000, -0.017719
0.043333, -0.017879
0.046667, -0.018030
0.050000, -0.018088
0.053333, -0.017823
0.056667, -0.017177
0.060000, -0.016317
0.063333, -0.015450
0.066667, -0.014682
0.070000, -0.014011
0.073333, -0.013292
0.076667, -0.012453
0.080000, -0.011732
0.083333, -0.011392
0.086667, -0.011424
0.090000, -0.011604
0.093333, -0.011664
0.096667, -0.011479
0.100000, -0.011220
0.103333, -0.011158
0.106667, -0.011293
0.110000, -0.011440
0.113333, -0.011403
0.116667, -0.010901
0.120000, -0.009867
0.123333, -0.008805
0.126667, -0.008393
0.130000, -0.008823
0.133333, -0.009607
0.136667, -0.010055
0.140000, -0.009924
0.143333, -0.009401
0.146667, -0.008730
0.150000, -0.008050
0.153333, -0.007429
0.156667, -0.006984
0.160000, -0.006911
0.163333, -0.007222
0.166667, -0.007551
0.170000, -0.007556
0.173333, -0.007477
0.176667, -0.007877
0.180000, -0.008931
0.183333, -0.010221
0.186667, -0.011096
0.190000, -0.011153
0.193333, -0.010489
0.196667, -0.009573
0.200000, -0.008957
0.203333, -0.008942
0.206667, -0.009358
0.210000, -0.009768
0.213333, -0.009954
0.216667, -0.009950
0.220000, -0.009772
0.223333, -0.009480
0.226667, -0.009257
0.230000, -0.009255
0.233333, -0.009407
0.236667, -0.009437
0.240000, -0.009238
0.243333, -0.009097
0.246667, -0.009276
0.250000, -0.009693
0.253333, -0.010294
0.256667, -0.011237
0.260000, -0.012430
0.263333, -0.013367
0.266667, -0.013602
0.270000, -0.013127
0.273333, -0.012242
0.276667, -0.011319
0.280000, -0.010635
0.283333, -0.010137
0.286667, -0.009598
0.290000, -0.008979
0.293333, -0.008350
0.296667, -0.007821
0.300000, -0.007793
0.303333, -0.008756
0.306667, -0.010720
0.310000, -0.013129
0.313333, -0.015162
0.316667, -0.016129
0.320000, -0.015951
0.323333, -0.015157
0.326667, -0.014459
0.330000, -0.014363
0.333333, -0.014846
0.336667, -0.015487
0.340000, -0.015964
0.343333, -0.016227
0.346667, -0.016408
0.350000, -0.016595
0.353333, -0.016637
0.356667, -0.016417
0.360000, -0.016137
0.363333, -0.016101
0.366667, -0.016437
0.370000, -0.017055
0.373333, -0.017734
0.376667, -0.018206
0.380000, -0.018144
0.383333, -0.017350
0.386667, -0.016136
0.390000, -0.015179
0.393333, -0.014852
0.396667, -0.015186
0.400000, -0.016217
0.403333, -0.017777
0.406667, -0.019463
0.410000, -0.020969
0.413333, -0.021958
0.416667, -0.022053
0.420000, -0.021305
0.423333, -0.020130
0.426667, -0.018826
0.430000, -0.017709
0.433333, -0.017400
0.436667, -0.018332
0.440000, -0.020184
0.443333, -0.022186
0.446667, -0.023634
0.450000, -0.024141
0.453333, -0.023792
0.456667, -0.023006
0.460000, -0.022220
0.463333, -0.021817
0.466667, -0.022001
0.470000, -0.022551
0.473333, -0.022954
0.476667, -0.022793
0.480000, -0.021946
0.483333, -0.020709
0.486667, -0.019701
0.490000, -0.019308
0.493333, -0.019324
0.496667, -0.019402
0.500000, -0.019536
0.503333, -0.019853
0.506667, -0.020275
0.510000, -0.020627
0.513333, -0.020930
0.516667, -0.021267
0.520000, -0.021498
0.523333, -0.021447
0.526667, -0.021089
0.530000, -0.020400
0.533333, -0.019363
0.536667, -0.018142
0.540000, -0.016975
0.543333, -0.015917
0.546667, -0.014981
0.550000, -0.014507
0.553333, -0.014972
0.556667, -0.016292
0.560000, -0.017596
0.563333, -0.017811
0.566667, -0.016497
0.570000, -0.014229
0.573333, -0.012099
0.576667, -0.010748
0.580000, -0.010075
0.583333, -0.009780
0.586667, -0.009681
0.590000, -0.009710
0.593333, -0.009927
0.596667, -0.010391
0.600000, -0.011027
0.603333, -0.011587
0.606667, -0.011715
0.610000, -0.011265
0.613333, -0.010492
0.616667, -0.009880
0.620000, -0.009816
0.623333, -0.010302
0.626667, -0.011047
0.630000, -0.011873
0.633333, -0.012763
0.636667, -0.013645
0.640000, -0.014415
0.643333, -0.015042
0.646667, -0.015507
0.650000, -0.015729
0.653333, -0.015585
0.656667, -0.015080
0.660000, -0.014359
0.663333, -0.013330
0.666667, -0.011609
0.670000, -0.009200
0.673333, -0.006788
0.676667, -0.005045
0.680000, -0.004105
0.683333, -0.003969
0.686667, -0.004731
0.690000, -0.006255
0.693333, -0.008079
0.696667, -0.009672
0.700000, -0.010688
0.703333, -0.011031
0.706667, -0.010728
0.710000, -0.009840
0.713333, -0.008470
0.716667, -0.006849
0.720000, -0.005283
0.723333, -0.003825
0.726667, -0.002220
0.730000, -0.000458
0.733333, 0.000989
0.736667, 0.001728
0.740000, 0.001766
0.743333, 0.001364
0.746667, 0.000969
0.750000, 0.001040
0.753333, 0.001716
0.756667, 0.002674
0.760000, 0.003489
0.763333, 0.004146
0.766667, 0.004889
0.770000, 0.005719
0.773333, 0.006289
0.776667, 0.006256
0.780000, 0.005667
0.783333, 0.004868
0.786667, 0.004102
0.790000, 0.003411
0.793333, 0.002760
0.796667, 0.002120
0.800000, 0.001649
0.803333, 0.001656
0.806667, 0.002188
0.810000, 0.002879
0.813333, 0.003334
0.816667, 0.003513
0.820000, 0.003649
0.823333, 0.003924
0.826667, 0.004299
0.830000, 0.004446
0.833333, 0.003981
0.836667, 0.003051
0.840000, 0.002306
0.843333, 0.002201
0.846667, 0.002713
0.850000, 0.003461
0.853333, 0.003886
0.856667, 0.003650
0.860000, 0.002850
0.863333, 0.001655
0.866667, 0.000112
0.870000, -0.001634
0.873333, -0.003279
0.876667, -0.004498
0.880000, -0.005082
0.883333, -0.005024
0.886667, -0.004468
0.890000, -0.003589
0.893333, -0.002547
0.896667, -0.001547
0.900000, -0.000867
0.903333, -0.000729
0.906667, -0.001269
0.910000, -0.002585
0.913333, -0.004582
0.916667, -0.006724
0.920000, -0.008258
0.923333, -0.008873
0.926667, -0.009006
0.930000, -0.009206
0.933333, -0.009453
0.936667, -0.009422
0.940000, -0.009028
0.943333, -0.008466
0.946667, -0.008039
0.950000, -0.008109
0.953333, -0.009006
0.956667, -0.010743
0.960000, -0.012830
0.963333, -0.014560
0.966667, -0.015361
0.970000, -0.015047
0.973333, -0.014144
0.976667, -0.013540
0.980000, -0.013628
0.983333, -0.014259
0.986667, -0.015260
0.990000, -0.016541
0.993333, -0.017978
0.996667, -0.019393
1.000000, -0.020635
1.003333, -0.021683
1.006667, -0.022552
1.010000, -0.023125
1.013333, -0.023263
1.016667, -0.023005
1.020000, -0.022521
1.023333, -0.021932
1.026667, -0.021279
1.030000, -0.020621
1.033333, -0.020171
1.036667, -0.020294
1.040000, -0.021205
1.043333, -0.022630
1.046667, -0.023921
1.050000, -0.024633
1.053333, -0.024794
1.056667, -0.024577
1.060000, -0.024165
1.063333, -0.023927
1.066667, -0.024185
1.070000, -0.024741
1.073333, -0.024986
1.076667, -0.024542
1.080000, -0.023661
1.083333, -0.022889
1.086667, -0.022520
1.090000, -0.022509
1.093333, -0.022679
1.096667, -0.022894
1.100000, -0.023028
1.103333, -0.022890
1.106667, -0.022489
1.110000, -0.022192
1.113333, -0.022298
1.116667, -0.022683
1.120000, -0.022942
1.123333, -0.022734
1.126667, -0.022075
1.130000, -0.021345
1.133333, -0.020887
1.136667, -0.020625
1.140000, -0.020199
1.143333, -0.019246
1.146667, -0.017556
1.150000, -0.015306
1.153333, -0.013064
1.156667, -0.011310
1.160000, -0.010056
1.163333, -0.009065
1.166667, -0.008305
1.170000, -0.007815
1.173333, -0.007336
1.176667, -0.006570
1.180000, -0.005570
1.183333, -0.004684
1.186667, -0.004320
1.190000, -0.004655
1.193333, -0.005458
1.196667, -0.006296
1.200000, -0.006751
1.203333, -0.006484
1.206667, -0.005406
1.210000, -0.003877
1.213333, -0.002513
1.216667, -0.001647
1.220000, -0.001056
1.223333, -0.000339
1.226667, 0.000545
1.230000, 0.001277
1.233333, 0.001579
1.236667, 0.001502
1.240000, 0.001434
1.243333, 0.001690
1.246667, 0.002096
1.250000, 0.002249
1.253333, 0.001949
1.256667, 0.001253
1.260000, 0.000388
1.263333, -0.000461
1.266667, -0.001350
1.270000, -0.002417
1.273333, -0.003576
1.276667, -0.004404
1.280000, -0.004531
1.283333, -0.004211
1.286667, -0.004173
1.290000, -0.004896
1.293333, -0.006415
1.296667, -0.008551
1.300000, -0.010927
1.303333, -0.012989
1.306667, -0.014279
1.310000, -0.014762
1.313333, -0.014785
1.316667, -0.014671
1.320000, -0.014435
1.323333, -0.013850
1.326667, -0.012748
1.330000, -0.011344
1.333333, -0.010110
1.336667, -0.009356
1.340000, -0.009195
1.343333, -0.009589
1.346667, -0.010231
1.350000, -0.010806
1.353333, -0.011392
1.356667, -0.012363
1.360000, -0.013853
1.363333, -0.015470
1.366667, -0.016865
1.370000, -0.018284
1.373333, -0.020128
1.376667, -0.022405
1.380000, -0.024862
1.383333, -0.027265
1.386667, -0.029411
1.390000, -0.031080
1.393333, -0.032223
1.396667, -0.033180
1.400000, -0.034309
1.403333, -0.035509
1.406667, -0.036515
1.410000, -0.037268
1.413333, -0.037758
1.416667, -0.037987
1.420000, -0.038088
1.423333, -0.038201
1.426667, -0.038386
1.430000, -0.038585
1.433333, -0.038532
1.436667, -0.038068
1.440000, -0.037647
1.443333, -0.038019
1.446667, -0.039494
1.450000, -0.041768
1.453333, -0.044216
1.456667, -0.046165
1.460000, -0.047116
1.463333, -0.046892
1.466667, -0.045665
1.470000, -0.043993
1.473333, -0.042675
1.476667, -0.042132
1.480000, -0.042154
1.483333, -0.042463
1.486667, -0.042948
1.490000, -0.043349
1.493333, -0.043204
1.496667, -0.042300
1.500000, -0.041022
1.503333, -0.039969
1.506667, -0.039322
1.510000, -0.038870
1.513333, -0.038521
1.516667, -0.038474
1.520000, -0.038928
1.523333, -0.039774
1.526667, -0.040574
1.530000, -0.040898
1.533333, -0.040678
1.536667, -0.040169
1.540000, -0.039729
1.543333, -0.039610
1.546667, -0.039707
1.550000, -0.039666
1.553333, -0.039273
1.556667, -0.038478
1.560000, -0.037248
1.563333, -0.035749
1.566667, -0.034427
1.570000, -0.033607
1.573333, -0.033164
1.576667, -0.032760
1.580000, -0.032277
1.583333, -0.031675
1.586667, -0.030718
1.590000, -0.029357
1.593333, -0.028061
1.596667, -0.027223
1.600000, -0.026537
1.603333, -0.025307
1.606667, -0.023163
1.610000, -0.020410
1.613333, -0.017764
1.616667, -0.015861
1.620000, -0.015027
1.623333, -0.015154
1.626667, -0.015670
1.630000, -0.015950
1.633333, -0.015872
1.636667, -0.015824
1.640000, -0.016031
1.643333, -0.016218
1.646667, -0.016236
1.650000, -0.016378
1.653333, -0.016752
1.656667, -0.016991
1.660000, -0.016752
1.663333, -0.016169
1.666667, -0.015700
1.670000, -0.015645
1.673333, -0.015897
1.676667, -0.016077
1.680000, -0.015812
1.683333, -0.014988
1.686667, -0.013781
1.690000, -0.012514
1.693333, -0.011402
1.696667, -0.010447
1.700000, -0.009873
1.703333, -0.010312
1.706667, -0.011954
1.710000, -0.014002
1.713333, -0.015510
1.716667, -0.016221
1.720000, -0.016432
1.723333, -0.016555
1.726667, -0.016755
1.730000, -0.016949
1.733333, -0.017231
1.736667, -0.017777
1.740000, -0.018326
1.743333, -0.018439
1.746667, -0.018033
1.750000, -0.017226
1.753333, -0.016156
1.756667, -0.015153
1.760000, -0.014597
1.763333, -0.014689
1.766667, -0.015529
1.770000, -0.017126
1.773333, -0.019307
1.776667, -0.021796
1.780000, -0.024267
1.783333, -0.026297
1.786667, -0.027572
1.790000, -0.028291
1.793333, -0.029052
1.796667, -0.030161
1.800000, -0.031235
1.803333, -0.031567
1.806667, -0.030792
1.810000, -0.029261
1.813333, -0.027746
1.816667, -0.026830
1.820000, -0.026740
1.823333, -0.027526
1.826667, -0.028902
1.830000, -0.030198
1.833333, -0.030861
1.836667, -0.030954
1.840000, -0.031141
1.843333, -0.032085
1.846667, -0.033691
1.850000, -0.035214
1.853333, -0.036067
1.856667, -0.036192
1.860000, -0.035807
1.863333, -0.035136
1.866667, -0.034484
1.870000, -0.034340
1.873333, -0.034948
1.876667, -0.035935
1.880000, -0.036718
1.883333, -0.037023
1.886667, -0.036934
1.890000, -0.036744
1.893333, -0.036733
1.896667, -0.036897
1.900000, -0.036947
1.903333, -0.036548
1.906667, -0.035597
1.910000, -0.034361
1.913333, -0.033242
1.916667, -0.032545
1.920000, -0.032465
1.923333, -0.033021
1.926667, -0.033898
1.930000, -0.034499
1.933333, -0.034388
1.936667, -0.033674
1.940000, -0.032714
1.943333, -0.031640
1.946667, -0.030313
1.950000, -0.028608
1.953333, -0.026764
1.956667, -0.025546
1.960000, -0.025862
1.963333, -0.027798
1.966667, -0.030129
1.970000, -0.031381
1.973333, -0.031209
1.976667, -0.030457
1.980000, -0.030190
1.983333, -0.030820
1.986667, -0.032063
1.990000, -0.033452
1.993333, -0.034616
1.996667, -0.035349
2.000000, -0.035624
2.003333, -0.035413
2.006667, -0.034684
2.010000, -0.033680
2.013333, -0.032949
2.016667, -0.032955
2.020000, -0.033586
2.023333, -0.034201
2.026667, -0.034416
2.030000, -0.034448
2.033333, -0.034520
2.036667, -0.034576
2.040000, -0.034546
2.043333, -0.034487
2.046667, -0.034670
2.050000, -0.035518
2.053333, -0.037267
2.056667, -0.039726
2.060000, -0.042287
2.063333, -0.044311
2.066667, -0.045613
2.070000, -0.046472
2.073333, -0.047277
2.076667, -0.048280
2.080000, -0.049583
2.083333, -0.051177
2.086667, -0.052913
2.090000, -0.054620
2.093333, -0.056269
2.096667, -0.057795
2.100000, -0.058992
2.103333, -0.059837
2.106667, -0.060552
2.110000, -0.061288
2.113333, -0.062188
2.116667, -0.063489
2.120000, -0.065219
2.123333, -0.067218
2.126667, -0.069464
2.130000, -0.071932
2.133333, -0.074340
2.136667, -0.076305
2.140000, -0.077712
2.143333, -0.078791
2.146667, -0.079674
2.150000, -0.080128
2.153333, -0.079970
2.156667, -0.079382
2.160000, -0.078741
2.163333, -0.078510
2.166667, -0.079170
2.170000, -0.081049
2.173333, -0.084095
2.176667, -0.087632
2.180000, -0.090510
2.183333, -0.091864
2.186667, -0.091708
2.190000, -0.090673
2.193333, -0.089415
2.196667, -0.088230
2.200000, -0.087068
2.203333, -0.086131
2.206667, -0.086003
2.210000, -0.086753
2.213333, -0.087472
2.216667, -0.087077
2.220000, -0.085235
2.223333, -0.082400
2.226667, -0.079324
2.230000, -0.076642
2.233333, -0.074670
2.236667, -0.073506
2.240000, -0.073080
2.243333, -0.072969
2.246667, -0.072543
2.250000, -0.071455
2.253333, -0.069828
2.256667, -0.067967
2.260000, -0.066057
2.263333, -0.064207
2.266667, -0.062664
2.270000, -0.061697
2.273333, -0.061288
2.276667, -0.061118
2.280000, -0.060870
2.283333, -0.060452
2.286667, -0.059762
2.290000, -0.058528
2.293333, -0.056631
2.296667, -0.054269
2.300000, -0.051712
2.303333, -0.049156
2.306667, -0.046844
2.310000, -0.045087
2.313333, -0.044039
2.316667, -0.043450
2.320000, -0.042701
2.323333, -0.041363
2.326667, -0.039538
2.330000, -0.037486
2.333333, -0.035367
2.336667, -0.033410
2.340000, -0.032008
2.343333, -0.031364
2.346667, -0.031055
2.350000, -0.030360
2.353333, -0.028971
2.356667, -0.027038
2.360000, -0.024857
2.363333, -0.022797
2.366667, -0.021219
2.370000, -0.020276
2.373333, -0.019815
2.376667, -0.019462
2.380000, -0.018860
2.383333, -0.017927
2.386667, -0.016991
2.390000, -0.016658
2.393333, -0.017252
2.396667, -0.018360
2.400000, -0.019176
2.403333, -0.019407
2.406667, -0.019351
2.410000, -0.019109
2.413333, -0.018597
2.416667, -0.018095
2.420000, -0.017961
2.423333, -0.018172
2.426667, -0.018427
2.430000, -0.018429
2.433333, -0.017955
2.436667, -0.016959
2.440000, -0.015824
2.443333, -0.015245
2.446667, -0.015693
2.450000, -0.016935
2.453333, -0.018192
2.456667, -0.018964
2.460000, -0.019303
2.463333, -0.019156
2.466667, -0.018123
2.470000, -0.016050
2.473333, -0.013476
2.476667, -0.011406
2.480000, -0.010660
2.483333, -0.011413
2.486667, -0.013250
2.490000, -0.015468
2.493333, -0.017303
2.496667, -0.018172
2.500000, -0.017923
2.503333, -0.016887
2.506667, -0.015583
2.510000, -0.014421
2.513333, -0.013659
2.516667, -0.013424
2.520000, -0.013664
2.523333, -0.014097
2.526667, -0.014508
2.530000, -0.015165
2.533333, -0.016345
2.536667, -0.017610
2.540000, -0.018306
2.543333, -0.018391
2.546667, -0.018315
2.550000, -0.018398
2.553333, -0.018404
2.556667, -0.017958
2.560000, -0.017282
2.563333, -0.017066
2.566667, -0.017718
2.570000, -0.019066
2.573333, -0.020626
2.576667, -0.021913
2.580000, -0.022666
2.583333, -0.022983
2.586667, -0.023052
2.590000, -0.022744
2.593333, -0.021837
2.596667, -0.020544
2.600000, -0.019432
2.603333, -0.018951
2.606667, -0.019160
2.610000, -0.019696
2.613333, -0.019986
2.616667, -0.019697
2.620000, -0.019020
2.623333, -0.018407
2.626667, -0.018280
2.630000, -0.018961
2.633333, -0.020544
2.636667, -0.022917
2.640000, -0.026070
2.643333, -0.030191
2.646667, -0.035472
2.650000, -0.042025
2.653333, -0.049884
2.656667, -0.058814
2.660000, -0.067976
2.663333, -0.075944
2.666667, -0.081376
2.670000, -0.083664
2.673333, -0.082855
2.676667, -0.079286
2.680000, -0.073494
2.683333, -0.066104
2.686667, -0.057610
2.690000, -0.048441
2.693333, -0.039177
2.696667, -0.030488
2.700000, -0.022802
2.703333, -0.016197
2.706667, -0.010625
2.710000, -0.006004
2.713333, -0.002363
2.716667, -0.000072
2.720000, 0.000575
2.723333, -0.000230
2.726667, -0.002368
2.730000, -0.006138
2.733333, -0.011599
2.736667, -0.018084
2.740000, -0.024916
2.743333, -0.032458
2.746667, -0.041972
2.750000, -0.054426
2.753333, -0.069602
2.756667, -0.086313
2.760000, -0.103288
2.763333, -0.119723
2.766667, -0.135066
2.770000, -0.148736
2.773333, -0.160341
2.776667, -0.170276
2.780000, -0.180117
2.783333, -0.192616
2.786667, -0.211405
2.790000, -0.240496
2.793333, -0.283856
2.796667, -0.345122
2.800000, -0.427313
2.803333, -0.532427
2.806667, -0.660896
2.810000, -0.811439
2.813333, -0.981464
2.816667, -1.167274
2.820000, -1.364133
2.823333, -1.567089
2.826667, -1.772170
2.830000, -1.976713
2.833333, -2.178966
2.836667, -2.377869
2.840000, -2.573035
2.843333, -2.763904
2.846667, -2.947123
2.850000, -3.112237
2.853333, -3.236566
2.856667, -3.282643
2.860000, -3.203967
2.863333, -2.961862
2.866667, -2.547328
2.870000, -1.993923
2.873333, -1.371125
2.876667, -0.761492
2.880000, -0.234692
2.883333, 0.169439
2.886667, 0.443620
2.890000, 0.604514
2.893333, 0.680120
2.896667, 0.699208
2.900000, 0.685225
2.903333, 0.654505
2.906667, 0.617030
2.910000, 0.577870
2.913333, 0.538689
2.916667, 0.499457
2.920000, 0.459632
2.923333, 0.418614
2.926667, 0.376198
2.930000, 0.332871
2.933333, 0.289538
2.936667, 0.247247
2.940000, 0.207087
2.943333, 0.169910
2.946667, 0.136049
2.950000, 0.105630
2.953333, 0.079121
2.956667, 0.057213
2.960000, 0.040245
2.963333, 0.028012
2.966667, 0.019992
2.970000, 0.015470
2.973333, 0.013834
2.976667, 0.015147
2.980000, 0.019990
2.983333, 0.028542
2.986667, 0.040205
2.990000, 0.054082
2.993333, 0.069385
2.996667, 0.085367
3.000000, 0.101120
3.003333, 0.115512
3.006667, 0.127254
3.010000, 0.134873
3.013333, 0.136936
3.016667, 0.132693
3.020000, 0.122394
3.023333, 0.107195
3.026667, 0.088930
3.030000, 0.069601
3.033333, 0.050919
3.036667, 0.034220
3.040000, 0.020436
3.043333, 0.009747
3.046667, 0.001445
3.050000, -0.005261
3.053333, -0.010507
3.056667, -0.014097
3.060000, -0.016118
3.063333, -0.017062
3.066667, -0.017415
3.070000, -0.017237
3.073333, -0.016308
3.076667, -0.014548
3.080000, -0.012167
3.083333, -0.009578
3.086667, -0.007190
3.090000, -0.005123
3.093333, -0.003274
3.096667, -0.001879
3.100000, -0.001681
3.103333, -0.003261
3.106667, -0.006512
3.110000, -0.010868
3.113333, -0.015760
3.116667, -0.020735
3.120000, -0.025294
3.123333, -0.028813
3.126667, -0.030861
3.130000, -0.031567
3.133333, -0.031468
3.136667, -0.031097
3.140000, -0.030737
3.143333, -0.030362
3.146667, -0.029826
3.150000, -0.029240
3.153333, -0.028957
3.156667, -0.029060
3.160000, -0.029262
3.163333, -0.029312
3.166667, -0.029118
3.170000, -0.028483
3.173333, -0.027083
3.176667, -0.024921
3.180000, -0.022398
3.183333, -0.019540
3.186667, -0.015593
3.190000, -0.009537
3.193333, -0.000530
3.196667, 0.012101
3.200000, 0.028787
3.203333, 0.049385
3.206667, 0.073175
3.210000, 0.099550
3.213333, 0.128234
3.216667, 0.158385
3.220000, 0.187843
3.223333, 0.213691
3.226667, 0.233500
3.230000, 0.245945
3.233333, 0.250556
3.236667, 0.247320
3.240000, 0.236705
3.243333, 0.220076
3.246667, 0.199672
3.250000, 0.177745
3.253333, 0.155824
3.256667, 0.134718
3.260000, 0.114861
3.263333, 0.096536
3.266667, 0.079963
3.270000, 0.065362
3.273333, 0.052934
3.276667, 0.042773
3.280000, 0.034631
3.283333, 0.027747
3.286667, 0.021397
3.290000, 0.015543
3.293333, 0.010514
3.296667, 0.006455
3.300000, 0.003358
3.303333, 0.001421
3.306667, 0.001052
3.310000, 0.002381
3.313333, 0.005242
3.316667, 0.009539
3.320000, 0.015021
3.323333, 0.021216
3.326667, 0.027878
3.330000, 0.034990
3.333333, 0.042472
3.336667, 0.050399
3.340000, 0.059330
3.343333, 0.070018
3.346667, 0.082830
3.350000, 0.097558
3.353333, 0.113536
3.356667, 0.130058
3.360000, 0.146703
3.363333, 0.163116
3.366667, 0.178686
3.370000, 0.192382
3.373333, 0.202776
3.376667, 0.208649
3.380000, 0.209598
3.383333, 0.205887
3.386667, 0.198162
3.390000, 0.187360
3.393333, 0.174534
3.396667, 0.160778
3.400000, 0.147370
3.403333, 0.135863
3.406667, 0.127926
3.410000, 0.124910
3.413333, 0.127372
3.416667, 0.134913
3.420000, 0.146307
3.423333, 0.159874
3.426667, 0.173811
3.430000, 0.186336
3.433333, 0.196043
3.436667, 0.202159
3.440000, 0.204261
3.443333, 0.202043
3.446667, 0.195434
3.450000, 0.184793
3.453333, 0.170881
3.456667, 0.154673
3.460000, 0.137286
3.463333, 0.119884
3.466667, 0.103493
3.470000, 0.088931
3.473333, 0.076810
3.476667, 0.067483
3.480000, 0.060980
3.483333, 0.057107
3.486667, 0.055496
3.490000, 0.055640
3.493333, 0.057200
3.496667, 0.059958
3.500000, 0.063255
3.503333, 0.066035
3.506667, 0.067726
3.510000, 0.068670
3.513333, 0.069635
3.516667, 0.071198
3.520000, 0.073355
3.523333, 0.075538
3.526667, 0.076985
3.530000, 0.077168
3.533333, 0.076265
3.536667, 0.075158
3.540000, 0.074632
3.543333, 0.074935
3.546667, 0.076209
3.550000, 0.078792
3.553333, 0.083166
3.556667, 0.090073
3.560000, 0.100592
3.563333, 0.116073
3.566667, 0.138193
3.570000, 0.169050
3.573333, 0.211249
3.576667, 0.268051
3.580000, 0.343528
3.583333, 0.442174
3.586667, 0.568063
3.590000, 0.724555
3.593333, 0.914434
3.596667, 1.139480
3.600000, 1.399745
3.603333, 1.693436
3.606667, 2.017997
3.610000, 2.372116
3.613333, 2.757512
3.616667, 3.179733
3.620000, 3.648376
3.623333, 4.177021
3.626667, 4.782246
3.630000, 5.481228
3.633333, 6.287857
3.636667, 7.208037
3.640000, 8.235508
3.643333, 9.348911
3.646667, 10.510082
3.650000, 11.664360
3.653333, 12.744077
3.656667, 13.674968
3.660000, 14.384122
3.663333, 14.808502
3.666667, 14.903191
3.670000, 14.647971
3.673333, 14.050798
3.676667, 13.147105
3.680000, 11.995059
3.683333, 10.668258
3.686667, 9.247418
3.690000, 7.811807
3.693333, 6.431371
3.696667, 5.161138
3.700000, 4.038639
3.703333, 3.083769
3.706667, 2.300449
3.710000, 1.679669
3.713333, 1.203397
3.716667, 0.848820
3.720000, 0.592112
3.723333, 0.411099
3.726667, 0.286668
3.730000, 0.203135
3.733333, 0.148134
3.736667, 0.112345
3.740000, 0.088952
3.743333, 0.073192
3.746667, 0.062151
3.750000, 0.054193
3.753333, 0.048283
3.756667, 0.043655
3.760000, 0.039834
3.763333, 0.036829
3.766667, 0.034794
3.770000, 0.033399
3.773333, 0.032086
3.776667, 0.030763
3.780000, 0.029774
3.783333, 0.029468
3.786667, 0.030160
3.790000, 0.032226
3.793333, 0.035941
3.796667, 0.041459
3.800000, 0.049137
3.803333, 0.059861
3.806667, 0.074910
3.810000, 0.095237
3.813333, 0.120937
3.816667, 0.151524
3.820000, 0.186468
3.823333, 0.225578
3.826667, 0.269078
3.830000, 0.316865
3.833333, 0.367658
3.836667, 0.419085
3.840000, 0.468163
3.843333, 0.511753
3.846667, 0.547274
3.850000, 0.573112
3.853333, 0.588274
3.856667, 0.591912
3.860000, 0.583438
3.863333, 0.563112
3.866667, 0.532307
3.870000, 0.493234
3.873333, 0.448492
3.876667, 0.400633
3.880000, 0.351914
3.883333, 0.304386
3.886667, 0.259975
3.890000, 0.220476
3.893333, 0.187407
3.896667, 0.161543
3.900000, 0.142522
3.903333, 0.129160
3.906667, 0.120170
3.910000, 0.114618
3.913333, 0.111894
3.916667, 0.111346
3.920000, 0.111947
3.923333, 0.112596
3.926667, 0.112802
3.930000, 0.112795
3.933333, 0.112861
3.936667, 0.112858
3.940000, 0.112500
3.943333, 0.111631
3.946667, 0.109977
3.950000, 0.107136
3.953333, 0.103030
3.956667, 0.098158
3.960000, 0.093295
3.963333, 0.088907
3.966667, 0.084989
3.970000, 0.081425
3.973333, 0.078171
3.976667, 0.074941
3.980000, 0.071146
3.983333, 0.066511
3.986667, 0.061424
3.990000, 0.056421
3.993333, 0.051715
3.996667, 0.047225
4.000000, 0.042683
4.003333, 0.037811
4.006667, 0.032499
4.010000, 0.026795
4.013333, 0.020975
4.016667, 0.015566
4.020000, 0.010941
4.023333, 0.006992
4.026667, 0.003377
4.030000, -0.000203
4.033333, -0.003961
4.036667, -0.007816
4.040000, -0.011284
4.043333, -0.013770
4.046667, -0.014950
4.050000, -0.015039
4.053333, -0.014623
4.056667, -0.013870
4.060000, -0.012090
4.063333, -0.008400
4.066667, -0.002727
4.070000, 0.004027
4.073333, 0.010775
4.076667, 0.016883
4.080000, 0.022123
4.083333, 0.026671
4.086667, 0.031157
4.090000, 0.036255
4.093333, 0.042158
4.096667, 0.048467
4.100000, 0.054544
4.103333, 0.059963
4.106667, 0.064532
4.110000, 0.068069
4.113333, 0.070428
4.116667, 0.071508
4.120000, 0.071152
4.123333, 0.069384
4.126667, 0.066500
4.130000, 0.062588
4.133333, 0.057439
4.136667, 0.051115
4.140000, 0.044283
4.143333, 0.037874
4.146667, 0.032355
4.150000, 0.027541
4.153333, 0.023052
4.156667, 0.018576
4.160000, 0.013938
4.163333, 0.009249
4.166667, 0.004779
4.170000, 0.000682
4.173333, -0.002953
4.176667, -0.005876
4.180000, -0.007796
4.183333, -0.008709
4.186667, -0.008937
4.190000, -0.009011
4.193333, -0.009330
4.196667, -0.009700
4.200000, -0.009510
4.203333, -0.008279
4.206667, -0.005978
4.210000, -0.003164
4.213333, -0.000658
4.216667, 0.001177
4.220000, 0.002651
4.223333, 0.004325
4.226667, 0.006620
4.230000, 0.009607
4.233333, 0.013000
4.236667, 0.016344
4.240000, 0.019303
4.243333, 0.021929
4.246667, 0.024511
4.250000, 0.027172
4.253333, 0.029944
4.256667, 0.033050
4.260000, 0.036769
4.263333, 0.041161
4.266667, 0.046129
4.270000, 0.051587
4.273333, 0.057402
4.276667, 0.063259
4.280000, 0.068631
4.283333, 0.072955
4.286667, 0.076045
4.290000, 0.078229
4.293333, 0.079946
4.296667, 0.081421
4.300000, 0.082721
4.303333, 0.083854
4.306667, 0.084769
4.310000, 0.085159
4.313333, 0.084439
4.316667, 0.082401
4.320000, 0.079674
4.323333, 0.077218
4.326667, 0.075671
4.330000, 0.075158
4.333333, 0.075225
4.336667, 0.075043
4.340000, 0.074002
4.343333, 0.072129
4.346667, 0.069849
4.350000, 0.067624
4.353333, 0.066080
4.356667, 0.065947
4.360000, 0.067444
4.363333, 0.070009
4.366667, 0.072785
4.370000, 0.075178
4.373333, 0.077079
4.376667, 0.078707
4.380000, 0.080333
4.383333, 0.082397
4.386667, 0.085637
4.390000, 0.090730
4.393333, 0.098270
4.396667, 0.109324
4.400000, 0.125652
4.403333, 0.149268
4.406667, 0.181826
4.410000, 0.224478
4.413333, 0.278268
4.416667, 0.344539
4.420000, 0.424875
4.423333, 0.520550
4.426667, 0.632288
4.430000, 0.760670
4.433333, 0.906233
4.436667, 1.068955
4.440000, 1.247659
4.443333, 1.439504
4.446667, 1.639714
4.450000, 1.842096
4.453333, 2.040274
4.456667, 2.228454
4.460000, 2.401081
4.463333, 2.552193
4.466667, 2.675588
4.470000, 2.765894
4.473333, 2.819419
4.476667, 2.834219
4.480000, 2.809945
4.483333, 2.747848
4.486667, 2.650571
4.490000, 2.521699
4.493333, 2.365600
4.496667, 2.187661
4.500000, 1.994383
4.503333, 1.792815
4.506667, 1.589656
4.510000, 1.390786
4.513333, 1.201027
4.516667, 1.024134
4.520000, 0.863040
4.523333, 0.719623
4.526667, 0.594366
4.530000, 0.486874
4.533333, 0.396649
4.536667, 0.322963
4.540000, 0.264338
4.543333, 0.219047
4.546667, 0.185713
4.550000, 0.162699
4.553333, 0.147876
4.556667, 0.139497
4.560000, 0.136442
4.563333, 0.137781
4.566667, 0.142502
4.570000, 0.149251
4.573333, 0.156385
4.576667, 0.162633
4.580000, 0.167671
4.583333, 0.172251
4.586667, 0.178091
4.590000, 0.187684
4.593333, 0.204450
4.596667, 0.233418
4.600000, 0.281665
4.603333, 0.357259
4.606667, 0.466497
4.610000, 0.610335
4.613333, 0.781144
4.616667, 0.961288
4.620000, 1.124973
4.623333, 1.243909
4.626667, 1.295166
4.630000, 1.267652
4.633333, 1.164770
4.636667, 1.002820
4.640000, 0.805893
4.643333, 0.599317
4.646667, 0.404201
4.650000, 0.234341
4.653333, 0.095400
4.656667, -0.013538
4.660000, -0.096593
4.663333, -0.158441
4.666667, -0.203671
4.670000, -0.236525
4.673333, -0.260285
4.676667, -0.277153
4.680000, -0.288670
4.683333, -0.296116
4.686667, -0.300586
4.690000, -0.302821
4.693333, -0.303144
4.696667, -0.301689
4.700000, -0.298669
4.703333, -0.294357
4.706667, -0.288826
4.710000, -0.281902
4.713333, -0.273439
4.716667, -0.263486
4.720000, -0.252249
4.723333, -0.240150
4.726667, -0.227735
4.730000, -0.215351
4.733333, -0.202964
4.736667, -0.190154
4.740000, -0.176344
4.743333, -0.161237
4.746667, -0.144998
4.750000, -0.128250
4.753333, -0.111981
4.756667, -0.097053
4.760000, -0.083665
4.763333, -0.071575
4.766667, -0.060712
4.770000, -0.051068
4.773333, -0.042326
4.776667, -0.034329
4.780000, -0.027347
4.783333, -0.021341
4.786667, -0.015658
4.790000, -0.009770
4.793333, -0.003768
4.796667, 0.002069
4.800000, 0.007773
4.803333, 0.013491
4.806667, 0.019034
4.810000, 0.023986
4.813333, 0.028208
4.816667, 0.031909
4.820000, 0.035288
4.823333, 0.038355
4.826667, 0.041091
4.830000, 0.043497
4.833333, 0.045443
4.836667, 0.046764
4.840000, 0.047524
4.843333, 0.048116
4.846667, 0.049150
4.850000, 0.051121
4.853333, 0.054016
4.856667, 0.057280
4.860000, 0.060133
4.863333, 0.061909
4.866667, 0.062359
4.870000, 0.061802
4.873333, 0.060996
4.876667, 0.060581
4.880000, 0.060330
4.883333, 0.059251
4.886667, 0.056809
4.890000, 0.053545
4.893333, 0.050379
4.896667, 0.047974
4.900000, 0.046596
4.903333, 0.046139
4.906667, 0.046183
4.910000, 0.046036
4.913333, 0.045209
4.916667, 0.043959
4.920000, 0.042881
4.923333, 0.042091
4.926667, 0.041291
4.930000, 0.040416
4.933333, 0.039717
4.936667, 0.039331
4.940000, 0.039214
4.943333, 0.039434
4.946667, 0.040107
4.950000, 0.040999
4.953333, 0.041521
4.956667, 0.041209
4.960000, 0.040044
4.963333, 0.038463
4.966667, 0.037097
4.970000, 0.036132
4.973333, 0.035021
4.976667, 0.033232
4.980000, 0.030963
4.983333, 0.028813
4.986667, 0.027302
4.990000, 0.026738
4.993333, 0.026843
4.996667, 0.026741
5.000000, 0.025788
5.003333, 0.024189
5.006667, 0.022731
5.010000, 0.022041
5.013333, 0.021991
5.016667, 0.021896
5.020000, 0.021320
5.023333, 0.020387
5.026667, 0.019370
5.030000, 0.018359
5.033333, 0.017443
5.036667, 0.016709
5.040000, 0.015974
5.043333, 0.014985
5.046667, 0.013660
5.050000, 0.011915
5.053333, 0.009797
5.056667, 0.007833
5.060000, 0.006724
5.063333, 0.006671
5.066667, 0.007278
5.070000, 0.007950
5.073333, 0.008307
5.076667, 0.008387
5.080000, 0.008696
5.083333, 0.010012
5.086667, 0.012912
5.090000, 0.017426
5.093333, 0.023195
5.096667, 0.029892
5.100000, 0.037404
5.103333, 0.045673
5.106667, 0.054658
5.110000, 0.064459
5.113333, 0.075289
5.116667, 0.087399
5.120000, 0.101047
5.123333, 0.116403
5.126667, 0.133384
5.130000, 0.151598
5.133333, 0.170752
5.136667, 0.191035
5.140000, 0.212838
5.143333, 0.236393
5.146667, 0.261743
5.150000, 0.288573
5.153333, 0.316037
5.156667, 0.343402
5.160000, 0.370966
5.163333, 0.400013
5.166667, 0.432047
5.170000, 0.468195
5.173333, 0.509129
5.176667, 0.555276
5.180000, 0.606955
5.183333, 0.664380
5.186667, 0.727665
5.190000, 0.796862
5.193333, 0.872068
5.196667, 0.953491
5.200000, 1.041324
5.203333, 1.135581
5.206667, 1.235968
5.210000, 1.341685
5.213333, 1.451338
5.216667, 1.562968
5.220000, 1.674103
5.223333, 1.782013
5.226667, 1.884158
5.230000, 1.978380
5.233333, 2.062759
5.236667, 2.135508
5.240000, 2.195133
5.243333, 2.240463
5.246667, 2.270234
5.250000, 2.282930
5.253333, 2.277356
5.256667, 2.253298
5.260000, 2.211509
5.263333, 2.153217
5.266667, 2.079886
5.270000, 1.993348
5.273333, 1.895717
5.276667, 1.789002
5.280000, 1.674999
5.283333, 1.555629
5.286667, 1.433146
5.290000, 1.309863
5.293333, 1.187821
5.296667, 1.068747
5.300000, 0.954245
5.303333, 0.845771
5.306667, 0.744374
5.310000, 0.650679
5.313333, 0.565132
5.316667, 0.487883
5.320000, 0.418423
5.323333, 0.355870
5.326667, 0.299709
5.330000, 0.250075
5.333333, 0.207325
5.336667, 0.171286
5.340000, 0.140983
5.343333, 0.115127
5.346667, 0.092746
5.350000, 0.073407
5.353333, 0.056933
5.356667, 0.042952
5.360000, 0.030917
5.363333, 0.020541
5.366667, 0.011956
5.370000, 0.005250
5.373333, 0.000037
5.376667, -0.004393
5.380000, -0.008779
5.383333, -0.013599
5.386667, -0.018787
5.390000, -0.023931
5.393333, -0.028673
5.396667, -0.032609
5.400000, -0.035331
5.403333, -0.036982
5.406667, -0.038300
5.410000, -0.039998
5.413333, -0.042399
5.416667, -0.045364
5.420000, -0.048326
5.423333, -0.050643
5.426667, -0.051979
5.430000, -0.052366
5.433333, -0.052056
5.436667, -0.051330
5.440000, -0.050437
5.443333, -0.049746
5.446667, -0.049719
5.450000, -0.050487
5.453333, -0.051613
5.456667, -0.052510
5.460000, -0.052953
5.463333, -0.052969
5.466667, -0.052493
5.470000, -0.051367
5.473333, -0.049344
5.476667, -0.046020
5.480000, -0.041203
5.483333, -0.035167
5.486667, -0.028360
5.490000, -0.021169
5.493333, -0.013903
5.496667, -0.006745
5.500000, 0.000248
5.503333, 0.007029
5.506667, 0.013400
5.510000, 0.019207
5.513333, 0.024627
5.516667, 0.029912
5.520000, 0.035005
5.523333, 0.039715
5.526667, 0.044109
5.530000, 0.048223
5.533333, 0.051644
5.536667, 0.053926
5.540000, 0.055113
5.543333, 0.055503
5.546667, 0.055292
5.550000, 0.054587
5.553333, 0.053630
5.556667, 0.052905
5.560000, 0.052731
5.563333, 0.052661
5.566667, 0.051713
5.570000, 0.049490
5.573333, 0.046631
5.576667, 0.044054
5.580000, 0.042253
5.583333, 0.041217
5.586667, 0.040559
5.590000, 0.039875
5.593333, 0.039109
5.596667, 0.038502
5.600000, 0.038262
5.603333, 0.038350
5.606667, 0.038509
5.610000, 0.038526
5.613333, 0.038445
5.616667, 0.038579
5.620000, 0.039355
5.623333, 0.041090
5.626667, 0.043814
5.630000, 0.047188
5.633333, 0.050582
5.636667, 0.053356
5.640000, 0.055231
5.643333, 0.056417
5.646667, 0.057331
5.650000, 0.058245
5.653333, 0.059331
5.656667, 0.060854
5.660000, 0.063059
5.663333, 0.065799
5.666667, 0.068460
5.670000, 0.070315
5.673333, 0.070974
5.676667, 0.070618
5.680000, 0.069708
5.683333, 0.068442
5.686667, 0.066799
5.690000, 0.064956
5.693333, 0.063193
5.696667, 0.061572
5.700000, 0.059907
5.703333, 0.057991
5.706667, 0.055785
5.710000, 0.053313
5.713333, 0.050592
5.716667, 0.047912
5.720000, 0.045909
5.723333, 0.045033
5.726667, 0.045121
5.730000, 0.045695
5.733333, 0.046456
5.736667, 0.047289
5.740000, 0.048207
5.743333, 0.049401
5.746667, 0.051004
5.750000, 0.052619
5.753333, 0.053353
5.756667, 0.052629
5.760000, 0.050747
5.763333, 0.048395
5.766667, 0.045968
5.770000, 0.043541
5.773333, 0.041278
5.776667, 0.039693
5.780000, 0.039253
5.783333, 0.039743
5.786667, 0.040388
5.790000, 0.040565
5.793333, 0.040304
5.796667, 0.040311
5.800000, 0.041572
5.803333, 0.044876
5.806667, 0.050841
5.810000, 0.060100
5.813333, 0.073202
5.816667, 0.090756
5.820000, 0.113896
5.823333, 0.144449
5.826667, 0.184887
5.830000, 0.238465
5.833333, 0.309214
5.836667, 0.401427
5.840000, 0.519374
5.843333, 0.667641
5.846667, 0.851339
5.850000, 1.076169
5.853333, 1.348583
5.856667, 1.675388
5.860000, 2.062783
5.863333, 2.515950
5.866667, 3.039368
5.870000, 3.636863
5.873333, 4.311169
5.876667, 5.063531
5.880000, 5.893261
5.883333, 6.797130
5.886667, 7.768961
5.890000, 8.799784
5.893333, 9.878470
5.896667, 10.991896
5.900000, 12.124446
5.903333, 13.258048
5.906667, 14.372711
5.910000, 15.446853
5.913333, 16.457994
5.916667, 17.383735
5.920000, 18.202298
5.923333, 18.893278
5.926667, 19.438805
5.930000, 19.824045
5.933333, 20.037349
5.936667, 20.071082
5.940000, 19.922621
5.943333, 19.594503
5.946667, 19.094076
5.950000, 18.433397
5.953333, 17.628915
5.956667, 16.700533
5.960000, 15.670538
5.963333, 14.562957
5.966667, 13.403004
5.970000, 12.216064
5.973333, 11.026578
5.976667, 9.857338
5.980000, 8.728811
5.983333, 7.658125
5.986667, 6.658163
5.990000, 5.737589
5.993333, 4.901555
5.996667, 4.152299
6.000000, 3.489528
6.003333, 2.910790
6.006667, 2.411834
6.010000, 1.986902
6.013333, 1.629019
6.016667, 1.330611
6.020000, 1.084231
6.023333, 0.882999
6.026667, 0.720688
6.030000, 0.591540
6.033333, 0.489995
6.036667, 0.410767
6.040000, 0.349312
6.043333, 0.302007
6.046667, 0.265739
6.050000, 0.237755
6.053333, 0.216084
6.056667, 0.199619
6.060000, 0.187570
6.063333, 0.179052
6.066667, 0.173298
6.070000, 0.169841
6.073333, 0.168116
6.076667, 0.167267
6.080000, 0.166613
6.083333, 0.166003
6.086667, 0.165651
6.090000, 0.165762
6.093333, 0.166360
6.096667, 0.167471
6.100000, 0.169264
6.103333, 0.171673
6.106667, 0.174098
6.110000, 0.175900
6.113333, 0.176971
6.116667, 0.177485
6.120000, 0.177433
6.123333, 0.176596
6.126667, 0.174636
6.130000, 0.171274
6.133333, 0.166672
6.136667, 0.161566
6.140000, 0.156909
6.143333, 0.153294
6.146667, 0.150506
6.150000, 0.147651
6.153333, 0.143802
6.156667, 0.138588
6.160000, 0.132405
6.163333, 0.125982
6.166667, 0.119593
6.170000, 0.112851
6.173333, 0.105279
6.176667, 0.096920
6.180000, 0.088386
6.183333, 0.080493
6.186667, 0.073794
6.190000, 0.068346
6.193333, 0.063850
6.196667, 0.059788
6.200000, 0.055302
6.203333, 0.049430
6.206667, 0.042127
6.210000, 0.034753
6.213333, 0.028987
6.216667, 0.025599
6.220000, 0.024186
6.223333, 0.023551
6.226667, 0.022535
6.230000, 0.020729
6.233333, 0.018319
6.236667, 0.015554
6.240000, 0.012494
6.243333, 0.009171
6.246667, 0.005876
6.250000, 0.003185
6.253333, 0.001707
6.256667, 0.001828
6.260000, 0.003509
6.263333, 0.006179
6.266667, 0.008962
6.270000, 0.011262
6.273333, 0.013027
6.276667, 0.014436
6.280000, 0.015668
6.283333, 0.017054
6.286667, 0.019109
6.290000, 0.022135
6.293333, 0.025901
6.296667, 0.029839
6.300000, 0.033385
6.303333, 0.036103
6.306667, 0.037694
6.310000, 0.038129
6.313333, 0.037808
6.316667, 0.037350
6.320000, 0.037042
6.323333, 0.036650
6.326667, 0.035877
6.330000, 0.034737
6.333333, 0.033329
6.336667, 0.031600
6.340000, 0.029514
6.343333, 0.027175
6.346667, 0.024686
6.350000, 0.022015
6.353333, 0.018973
6.356667, 0.015354
6.360000, 0.011141
6.363333, 0.006496
6.366667, 0.001626
6.370000, -0.003252
6.373333, -0.008001
6.376667, -0.012482
6.380000, -0.016175
6.383333, -0.018238
6.386667, -0.018285
6.390000, -0.016901
6.393333, -0.015357
6.396667, -0.014829
6.400000, -0.015670
6.403333, -0.017341
6.406667, -0.019130
6.410000, -0.020670
6.413333, -0.021632
6.416667, -0.021568
6.420000, -0.020268
6.423333, -0.017922
6.426667, -0.014922
6.430000, -0.011571
6.433333, -0.007880
6.436667, -0.003635
6.440000, 0.001303
6.443333, 0.006862
6.446667, 0.012898
6.450000, 0.019365
6.453333, 0.026389
6.456667, 0.034093
6.460000, 0.042357
6.463333, 0.050801
6.466667, 0.059059
6.470000, 0.067098
6.473333, 0.075104
6.476667, 0.083068
6.480000, 0.090812
6.483333, 0.098269
6.486667, 0.105479
6.490000, 0.112491
6.493333, 0.119392
6.496667, 0.126365
6.500000, 0.133622
6.503333, 0.141246
6.506667, 0.149066
6.510000, 0.156749
6.513333, 0.163961
6.516667, 0.170522
6.520000, 0.176515
6.523333, 0.182198
6.526667, 0.187857
6.530000, 0.193824
6.533333, 0.200391
6.536667, 0.207637
6.540000, 0.215315
6.543333, 0.222805
6.546667, 0.229487
6.550000, 0.235232
6.553333, 0.240326
6.556667, 0.245028
6.560000, 0.249317
6.563333, 0.253093
6.566667, 0.256468
6.570000, 0.259631
6.573333, 0.262627
6.576667, 0.265554
6.580000, 0.268843
6.583333, 0.272986
6.586667, 0.277987
6.590000, 0.283365
6.593333, 0.288618
6.596667, 0.293385
6.600000, 0.297331
6.603333, 0.300304
6.606667, 0.302595
6.610000, 0.304696
6.613333, 0.306800
6.616667, 0.308675
6.620000, 0.309885
6.623333, 0.310033
6.626667, 0.309007
6.630000, 0.307117
6.633333, 0.304853
6.636667, 0.302401
6.640000, 0.299323
6.643333, 0.294999
6.646667, 0.289466
6.650000, 0.283298
6.653333, 0.276711
6.656667, 0.269429
6.660000, 0.261330
6.663333, 0.252692
6.666667, 0.243831
6.670000, 0.234999
6.673333, 0.226543
6.676667, 0.218613
6.680000, 0.210768
6.683333, 0.202285
6.686667, 0.192681
6.690000, 0.181916
6.693333, 0.170432
6.696667, 0.159007
6.700000, 0.148461
6.703333, 0.139315
6.706667, 0.131400
6.710000, 0.123898
6.713333, 0.116045
6.716667, 0.107624
6.720000, 0.098882
6.723333, 0.090283
6.726667, 0.082293
6.730000, 0.075161
6.733333, 0.068735
6.736667, 0.062568
6.740000, 0.056287
6.743333, 0.049899
6.746667, 0.043753
6.750000, 0.038206
6.753333, 0.033439
6.756667, 0.029506
6.760000, 0.026430
6.763333, 0.024237
6.766667, 0.022781
6.770000, 0.021681
6.773333, 0.020677
6.776667, 0.019830
6.780000, 0.019111
6.783333, 0.018042
6.786667, 0.016199
6.790000, 0.013801
6.793333, 0.011436
6.796667, 0.009599
6.800000, 0.008440
6.803333, 0.007651
6.806667, 0.006643
6.810000, 0.005103
6.813333, 0.003553
6.816667, 0.002966
6.820000, 0.003672
6.823333, 0.005054
6.826667, 0.006301
6.830000, 0.007056
6.833333, 0.007490
6.836667, 0.008124
6.840000, 0.009405
6.843333, 0.011340
6.846667, 0.013658
6.850000, 0.016037
6.853333, 0.018176
6.856667, 0.019888
6.860000, 0.021162
6.863333, 0.022200
6.866667, 0.023273
6.870000, 0.024380
6.873333, 0.025436
6.876667, 0.026799
6.880000, 0.029027
6.883333, 0.032171
6.886667, 0.035603
6.890000, 0.038513
6.893333, 0.040758
6.896667, 0.043178
6.900000, 0.046803
6.903333, 0.051862
6.906667, 0.057566
6.910000, 0.062724
6.913333, 0.066676
6.916667, 0.069561
6.920000, 0.071817
6.923333, 0.073749
6.926667, 0.075558
6.930000, 0.077424
6.933333, 0.079475
6.936667, 0.081570
6.940000, 0.083335
6.943333, 0.084777
6.946667, 0.086514
6.950000, 0.089023
6.953333, 0.092048
6.956667, 0.094869
6.960000, 0.096844
6.963333, 0.097761
6.966667, 0.097893
6.970000, 0.097726
6.973333, 0.097683
6.976667, 0.098002
6.980000, 0.098544
6.983333, 0.098877
6.986667, 0.098767
6.990000, 0.098331
6.993333, 0.097565
6.996667, 0.096215
7.000000, 0.094209
7.003333, 0.091643
7.006667, 0.088410
7.010000, 0.084294
7.013333, 0.079514
7.016667, 0.074959
7.020000, 0.071447
7.023333, 0.068985
7.026667, 0.067075
7.030000, 0.065271
7.033333, 0.063339
7.036667, 0.061137
7.040000, 0.058354
7.043333, 0.054694
7.046667, 0.050517
7.050000, 0.046845
7.053333, 0.044454
7.056667, 0.043255
7.060000, 0.042719
7.063333, 0.042465
7.066667, 0.042125
7.070000, 0.041117
7.073333, 0.038880
7.076667, 0.035348
7.080000, 0.031170
7.083333, 0.027227
7.086667, 0.024043
7.090000, 0.021816
7.093333, 0.020677
7.096667, 0.020483
7.100000, 0.020435
7.103333, 0.019588
7.106667, 0.017926
7.110000, 0.016315
7.113333, 0.015426
7.116667, 0.015248
7.120000, 0.015425
7.123333, 0.015664
7.126667, 0.015752
7.130000, 0.015431
7.133333, 0.014697
7.136667, 0.014130
7.140000, 0.014446
7.143333, 0.015764
7.146667, 0.017322
7.150000, 0.017974
7.153333, 0.017278
7.156667, 0.016065
7.160000, 0.015676
7.163333, 0.016875
7.166667, 0.019612
7.170000, 0.023292
7.173333, 0.027169
7.176667, 0.030772
7.180000, 0.033860
7.183333, 0.036076
7.186667, 0.037081
7.190000, 0.036908
7.193333, 0.035853
7.196667, 0.034215
7.200000, 0.032446
7.203333, 0.031394
7.206667, 0.031795
7.210000, 0.033449
7.213333, 0.035375
7.216667, 0.036869
7.220000, 0.038030
7.223333, 0.039311
7.226667, 0.041008
7.230000, 0.043203
7.233333, 0.045771
7.236667, 0.048376
7.240000, 0.050768
7.243333, 0.053020
7.246667, 0.055229
7.250000, 0.057466
7.253333, 0.060138
7.256667, 0.063783
7.260000, 0.068486
7.263333, 0.073834
7.266667, 0.079328
7.270000, 0.084790
7.273333, 0.090409
7.276667, 0.096340
7.280000, 0.102383
7.283333, 0.108258
7.286667, 0.114157
7.290000, 0.120651
7.293333, 0.127991
7.296667, 0.135867
7.300000, 0.143905
7.303333, 0.152062
7.306667, 0.160577
7.310000, 0.169737
7.313333, 0.179651
7.316667, 0.190148
7.320000, 0.200717
7.323333, 0.210643
7.326667, 0.219648
7.330000, 0.228359
7.333333, 0.237799
7.336667, 0.248393
7.340000, 0.259672
7.343333, 0.270939
7.346667, 0.281726
7.350000, 0.291601
7.353333, 0.300063
7.356667, 0.306815
7.360000, 0.312166
7.363333, 0.316974
7.366667, 0.321843
7.370000, 0.326673
7.373333, 0.331081
7.376667, 0.334636
7.380000, 0.336882
7.383333, 0.337872
7.386667, 0.338326
7.390000, 0.338942
7.393333, 0.340044
7.396667, 0.342042
7.400000, 0.345640
7.403333, 0.351463
7.406667, 0.359934
7.410000, 0.371622
7.413333, 0.387411
7.416667, 0.408256
7.420000, 0.434892
7.423333, 0.468218
7.426667, 0.510005
7.430000, 0.562727
7.433333, 0.628750
7.436667, 0.710296
7.440000, 0.809980
7.443333, 0.930783
7.446667, 1.075829
7.450000, 1.248683
7.453333, 1.453456
7.456667, 1.694549
7.460000, 1.976722
7.463333, 2.305252
7.466667, 2.685727
7.470000, 3.123888
7.473333, 3.625815
7.476667, 4.198127
7.480000, 4.847805
7.483333, 5.582000
7.486667, 6.408251
7.490000, 7.334419
7.493333, 8.368077
7.496667, 9.516253
7.500000, 10.785554
7.503333, 12.182091
7.506667, 13.711322
7.510000, 15.378022
7.513333, 17.186212
7.516667, 19.138725
7.520000, 21.236523
7.523333, 23.478477
7.526667, 25.861623
7.530000, 28.381171
7.533333, 31.030455
7.536667, 33.801138
7.540000, 36.682868
7.543333, 39.662375
7.546667, 42.723388
7.550000, 45.847479
7.553333, 49.014741
7.556667, 52.203701
7.560000, 55.390829
7.563333, 58.550776
7.566667, 61.657306
7.570000, 64.683481
7.573333, 67.601256
7.576667, 70.381803
7.580000, 72.996606
7.583333, 75.418732
7.586667, 77.623343
7.590000, 79.587124
7.593333, 81.287889
7.596667, 82.705179
7.600000, 83.821178
7.603333, 84.621511
7.606667, 85.095917
7.610000, 85.238486
7.613333, 85.047433
7.616667, 84.524969
7.620000, 83.677326
7.623333, 82.514610
7.626667, 81.050534
7.630000, 79.302014
7.633333, 77.288701
7.636667, 75.032922
7.640000, 72.559691
7.643333, 69.896042
7.646667, 67.069958
7.650000, 64.109744
7.653333, 61.043970
7.656667, 57.901500
7.660000, 54.711145
7.663333, 51.500815
7.666667, 48.296769
7.670000, 45.123262
7.673333, 42.002172
7.676667, 38.953066
7.680000, 35.993863
7.683333, 33.140814
7.686667, 30.407660
7.690000, 27.805030
7.693333, 25.340354
7.696667, 23.018468
7.700000, 20.842445
7.703333, 18.813797
7.706667, 16.932311
7.710000, 15.195985
7.713333, 13.601170
7.716667, 12.143008
7.720000, 10.815903
7.723333, 9.613648
7.726667, 8.529232
7.730000, 7.554953
7.733333, 6.682848
7.736667, 5.904813
7.740000, 5.212566
7.743333, 4.598001
7.746667, 4.053706
7.750000, 3.573192
7.753333, 3.150791
7.756667, 2.781220
7.760000, 2.459116
7.763333, 2.178998
7.766667, 1.935407
7.770000, 1.723150
7.773333, 1.537957
7.776667, 1.376772
7.780000, 1.236969
7.783333, 1.115453
7.786667, 1.009067
7.790000, 0.915528
7.793333, 0.833314
7.796667, 0.761072
7.800000, 0.697609
7.803333, 0.641948
7.806667, 0.593099
7.810000, 0.550045
7.813333, 0.511934
7.816667, 0.478143
7.820000, 0.448101
7.823333, 0.421196
7.826667, 0.396924
7.830000, 0.374924
7.833333, 0.354728
7.836667, 0.335730
7.840000, 0.317573
7.843333, 0.300341
7.846667, 0.284283
7.850000, 0.269595
7.853333, 0.256351
7.856667, 0.244410
7.860000, 0.233494
7.863333, 0.223362
7.866667, 0.213762
7.870000, 0.204438
7.873333, 0.195373
7.876667, 0.186794
7.880000, 0.178782
7.883333, 0.171129
7.886667, 0.163595
7.890000, 0.156148
7.893333, 0.149021
7.896667, 0.142487
7.900000, 0.136463
7.903333, 0.130628
7.906667, 0.125058
7.910000, 0.120283
7.913333, 0.116606
7.916667, 0.113715
7.920000, 0.110918
7.923333, 0.107594
7.926667, 0.103551
7.930000, 0.099034
7.933333, 0.094475
7.936667, 0.090273
7.940000, 0.086735
7.943333, 0.084052
7.946667, 0.082141
7.950000, 0.080659
7.953333, 0.079288
7.956667, 0.077891
7.960000, 0.076390
7.963333, 0.074616
7.966667, 0.072336
7.970000, 0.069375
7.973333, 0.065734
7.976667, 0.061852
7.980000, 0.058545
7.983333, 0.056284
7.986667, 0.054739
7.990000, 0.053272
7.993333, 0.051599
7.996667, 0.049930
8.000000, 0.048642
8.003333, 0.047916
8.006667, 0.047644
8.010000, 0.047487
8.013333, 0.046912
8.016667, 0.045362
8.020000, 0.042746
8.023333, 0.039751
8.026667, 0.037269
8.030000, 0.035617
8.033333, 0.034664
8.036667, 0.034255
8.040000, 0.034302
8.043333, 0.034693
8.046667, 0.035201
8.050000, 0.035593
8.053333, 0.035767
8.056667, 0.035677
8.060000, 0.035342
8.063333, 0.034911
8.066667, 0.034501
8.070000, 0.033991
8.073333, 0.033202
8.076667, 0.032258
8.080000, 0.031502
8.083333, 0.031222
8.086667, 0.031484
8.090000, 0.032054
8.093333, 0.032612
8.096667, 0.032815
8.100000, 0.032216
8.103333, 0.030697
8.106667, 0.028670
8.110000, 0.026669
8.113333, 0.025058
8.116667, 0.023912
8.120000, 0.022966
8.123333, 0.021703
8.126667, 0.019627
8.130000, 0.016738
8.133333, 0.013629
8.136667, 0.010898
8.140000, 0.008702
8.143333, 0.006849
8.146667, 0.004942
8.150000, 0.002591
8.153333, -0.000081
8.156667, -0.002340
8.160000, -0.003436
8.163333, -0.003293
8.166667, -0.002600
8.170000, -0.002231
8.173333, -0.002694
8.176667, -0.004098
8.180000, -0.006255
8.183333, -0.008788
8.186667, -0.011413
8.190000, -0.014115
8.193333, -0.016992
8.196667, -0.020001
8.200000, -0.022870
8.203333, -0.025223
8.206667, -0.026899
8.210000, -0.028050
8.213333, -0.028760
8.216667, -0.028968
8.220000, -0.028703
8.223333, -0.028107
8.226667, -0.027450
8.230000, -0.027073
8.233333, -0.027148
8.236667, -0.027650
8.240000, -0.028474
8.243333, -0.029389
8.246667, -0.029873
8.250000, -0.029122
8.253333, -0.026542
8.256667, -0.022355
8.260000, -0.017403
8.263333, -0.012274
8.266667, -0.006842
8.270000, -0.000606
8.273333, 0.006766
8.276667, 0.015215
8.280000, 0.024552
8.283333, 0.035021
8.286667, 0.047452
8.290000, 0.062649
8.293333, 0.080889
8.296667, 0.102240
8.300000, 0.127025
8.303333, 0.155815
8.306667, 0.189264
8.310000, 0.227784
8.313333, 0.271323
8.316667, 0.319862
8.320000, 0.374075
8.323333, 0.435225
8.326667, 0.504563
8.330000, 0.582863
8.333333, 0.670438
8.336667, 0.767638
8.340000, 0.875220
8.343333, 0.994215
8.346667, 1.125702
8.350000, 1.270617
8.353333, 1.429649
8.356667, 1.603211
8.360000, 1.791429
8.363333, 1.994596
8.366667, 2.213608
8.370000, 2.449410
8.373333, 2.702377
8.376667, 2.972605
8.380000, 3.260142
8.383333, 3.564624
8.386667, 3.885265
8.390000, 4.221358
8.393333, 4.572413
8.396667, 4.937966
8.400000, 5.317267
8.403333, 5.708778
8.406667, 6.110357
8.410000, 6.520195
8.413333, 6.937127
8.416667, 7.360016
8.420000, 7.787225
8.423333, 8.216698
8.426667, 8.646018
8.430000, 9.071985
8.433333, 9.490786
8.436667, 9.898970
8.440000, 10.293904
8.443333, 10.673298
8.446667, 11.034678
8.450000, 11.375486
8.453333, 11.693411
8.456667, 11.986277
8.460000, 12.251743
8.463333, 12.487378
8.466667, 12.690907
8.470000, 12.860200
8.473333, 12.993426
8.476667, 13.089604
8.480000, 13.148705
8.483333, 13.171065
8.486667, 13.156942
8.490000, 13.106401
8.493333, 13.019321
8.496667, 12.895669
8.500000, 12.735987
8.503333, 12.541707
8.506667, 12.314975
8.510000, 12.058131
8.513333, 11.773547
8.516667, 11.463816
8.520000, 11.131573
8.523333, 10.779322
8.526667, 10.409676
8.530000, 10.025311
8.533333, 9.628761
8.536667, 9.222684
8.540000, 8.810191
8.543333, 8.394560
8.546667, 7.978496
8.550000, 7.563980
8.553333, 7.152895
8.556667, 6.747329
8.560000, 6.349330
8.563333, 5.960666
8.566667, 5.582678
8.570000, 5.216424
8.573333, 4.863053
8.576667, 4.523911
8.580000, 4.200378
8.583333, 3.893481
8.586667, 3.603479
8.590000, 3.329985
8.593333, 3.072514
8.596667, 2.830821
8.600000, 2.604741
8.603333, 2.393933
8.606667, 2.198057
8.610000, 2.017005
8.613333, 1.850713
8.616667, 1.698723
8.620000, 1.560117
8.623333, 1.433895
8.626667, 1.319197
8.630000, 1.215421
8.633333, 1.122424
8.636667, 1.040188
8.640000, 0.968219
8.643333, 0.905630
8.646667, 0.851594
8.650000, 0.805344
8.653333, 0.766056
8.656667, 0.732969
8.660000, 0.705444
8.663333, 0.683055
8.666667, 0.665593
8.670000, 0.652773
8.673333, 0.644089
8.676667, 0.638892
8.680000, 0.636598
8.683333, 0.637006
8.686667, 0.640361
8.690000, 0.646937
8.693333, 0.656464
8.696667, 0.668012
8.700000, 0.680461
8.703333, 0.692949
8.706667, 0.705052
8.710000, 0.716777
8.713333, 0.728350
8.716667, 0.739940
8.720000, 0.751643
8.723333, 0.763537
8.726667, 0.775373
8.730000, 0.786278
8.733333, 0.795266
8.736667, 0.801871
8.740000, 0.806011
8.743333, 0.807742
8.746667, 0.807213
8.750000, 0.804477
8.753333, 0.799482
8.756667, 0.792240
8.760000, 0.782890
8.763333, 0.771721
8.766667, 0.759180
8.770000, 0.745688
8.773333, 0.731097
8.776667, 0.714520
8.780000, 0.695099
8.783333, 0.672712
8.786667, 0.647849
8.790000, 0.621292
8.793333, 0.594052
8.796667, 0.567206
8.800000, 0.541342
8.803333, 0.516171
8.806667, 0.491073
8.810000, 0.465856
8.813333, 0.440617
8.816667, 0.415220
8.820000, 0.389415
8.823333, 0.363291
8.826667, 0.337285
8.830000, 0.311857
8.833333, 0.287344
8.836667, 0.263978
8.840000, 0.241892
8.843333, 0.221168
8.846667, 0.201964
8.850000, 0.184466
8.853333, 0.168634
8.856667, 0.154239
8.860000, 0.141198
8.863333, 0.129451
8.866667, 0.118826
8.870000, 0.109369
8.873333, 0.101191
8.876667, 0.093958
8.880000, 0.087063
8.883333, 0.080082
8.886667, 0.072790
8.890000, 0.065188
8.893333, 0.057843
8.896667, 0.051685
8.900000, 0.047177
8.903333, 0.044057
8.906667, 0.041824
8.910000, 0.040109
8.913333, 0.038701
8.916667, 0.037412
8.920000, 0.036091
8.923333, 0.034743
8.926667, 0.033377
8.930000, 0.031762
8.933333, 0.029608
8.936667, 0.027144
8.940000, 0.025199
8.943333, 0.024459
8.946667, 0.025001
8.950000, 0.026423
8.953333, 0.028022
8.956667, 0.029105
8.960000, 0.029496
8.963333, 0.029741
8.966667, 0.030629
8.970000, 0.032550
8.973333, 0.035388
8.976667, 0.038753
8.980000, 0.042261
8.983333, 0.045785
8.986667, 0.049400
8.990000, 0.053295
8.993333, 0.057884
8.996667, 0.063539
9.000000, 0.070070
9.003333, 0.076883
9.006667, 0.083656
9.010000, 0.090505
9.013333, 0.097654
9.016667, 0.105250
9.020000, 0.113279
9.023333, 0.121661
9.026667, 0.130584
9.030000, 0.140447
9.033333, 0.151591
9.036667, 0.164169
9.040000, 0.177887
9.043333, 0.192010
9.046667, 0.205943
9.050000, 0.219598
9.053333, 0.233115
9.056667, 0.246469
9.060000, 0.259686
9.063333, 0.273341
9.066667, 0.288214
9.070000, 0.304327
9.073333, 0.320659
9.076667, 0.335994
9.080000, 0.349866
9.083333, 0.362478
9.086667, 0.374040
9.090000, 0.384553
9.093333, 0.393990
9.096667, 0.402492
9.100000, 0.410444
9.103333, 0.418184
9.106667, 0.425672
9.110000, 0.432605
9.113333, 0.438692
9.116667, 0.443552
9.120000, 0.446552
9.123333, 0.447245
9.126667, 0.445861
9.130000, 0.443053
9.133333, 0.439240
9.136667, 0.434357
9.140000, 0.428273
9.143333, 0.421059
9.146667, 0.412740
9.150000, 0.403291
9.153333, 0.392864
9.156667, 0.381665
9.160000, 0.369737
9.163333, 0.357033
9.166667, 0.343483
9.170000, 0.328882
9.173333, 0.313102
9.176667, 0.296424
9.180000, 0.279379
9.183333, 0.262381
9.186667, 0.245632
9.190000, 0.229108
9.193333, 0.212701
9.196667, 0.196492
9.200000, 0.180746
9.203333, 0.165737
9.206667, 0.151499
9.210000, 0.137705
9.213333, 0.123960
9.216667, 0.110175
9.220000, 0.096574
9.223333, 0.083490
9.226667, 0.071166
9.230000, 0.059750
9.233333, 0.049391
9.236667, 0.040187
9.240000, 0.032134
9.243333, 0.025204
9.246667, 0.019273
9.250000, 0.013950
9.253333, 0.008756
9.256667, 0.003497
9.260000, -0.001787
9.263333, -0.007019
9.266667, -0.012128
9.270000, -0.017104
9.273333, -0.021765
9.276667, -0.025434
9.280000, -0.027303
9.283333, -0.027313
9.286667, -0.026482
9.290000, -0.026140
9.293333, -0.026859
9.296667, -0.028247
9.300000, -0.029572
9.303333, -0.030306
9.306667, -0.030151
9.310000, -0.029088
9.313333, -0.027550
9.316667, -0.026101
9.320000, -0.024967
9.323333, -0.024105
9.326667, -0.023451
9.330000, -0.022817
9.333333, -0.021816
9.336667, -0.020168
9.340000, -0.017909
9.343333, -0.015226
9.346667, -0.012148
9.350000, -0.008584
9.353333, -0.004710
9.356667, -0.000932
9.360000, 0.002647
9.363333, 0.006386
9.366667, 0.010732
9.370000, 0.015946
9.373333, 0.022231
9.376667, 0.029713
9.380000, 0.038175
9.383333, 0.047142
9.386667, 0.056234
9.390000, 0.065485
9.393333, 0.075506
9.396667, 0.087082
9.400000, 0.100461
9.403333, 0.115379
9.406667, 0.131676
9.410000, 0.149621
9.413333, 0.169822
9.416667, 0.192926
9.420000, 0.219310
9.423333, 0.249200
9.426667, 0.283265
9.430000, 0.322834
9.433333, 0.369307
9.436667, 0.423624
9.440000, 0.486562
9.443333, 0.559318
9.446667, 0.643447
9.450000, 0.740506
9.453333, 0.852225
9.456667, 0.980917
9.460000, 1.129530
9.463333, 1.301550
9.466667, 1.500811
9.470000, 1.731220
9.473333, 1.996857
9.476667, 2.302378
9.480000, 2.653051
9.483333, 3.054529
9.486667, 3.513050
9.490000, 4.035553
9.493333, 4.629324
9.496667, 5.302145
9.500000, 6.062999
9.503333, 6.922065
9.506667, 7.890016
9.510000, 8.977894
9.513333, 10.197657
9.516667, 11.562224
9.520000, 13.085066
9.523333, 14.780116
9.526667, 16.662004
9.530000, 18.746301
9.533333, 21.049374
9.536667, 23.587692
9.540000, 26.377378
9.543333, 29.434566
9.546667, 32.775877
9.550000, 36.418249
9.553333, 40.377963
9.556667, 44.669910
9.560000, 49.308151
9.563333, 54.306774
9.566667, 59.679485
9.570000, 65.438481
9.573333, 71.593974
9.576667, 78.154299
9.580000, 85.125780
9.583333, 92.512350
9.586667, 100.315283
9.590000, 108.532883
9.593333, 117.160128
9.596667, 126.188477
9.600000, 135.605852
9.603333, 145.396736
9.606667, 155.542295
9.610000, 166.020283
9.613333, 176.804601
9.616667, 187.864816
9.620000, 199.165965
9.623333, 210.668928
9.626667, 222.330779
9.630000, 234.104437
9.633333, 245.938797
9.636667, 257.780223
9.640000, 269.573749
9.643333, 281.262808
9.646667, 292.788702
9.650000, 304.091489
9.653333, 315.111487
9.656667, 325.789565
9.660000, 336.066599
9.663333, 345.883450
9.666667, 355.182021
9.670000, 363.906440
9.673333, 372.003380
9.676667, 379.422269
9.680000, 386.116108
9.683333, 392.042746
9.686667, 397.165759
9.690000, 401.454089
9.693333, 404.881254
9.696667, 407.425544
9.700000, 409.071141
9.703333, 409.809016
9.706667, 409.637010
9.710000, 408.559524
9.713333, 406.587127
9.716667, 403.736254
9.720000, 400.029118
9.723333, 395.493573
9.726667, 390.162484
9.730000, 384.072577
9.733333, 377.263853
9.736667, 369.780286
9.740000, 361.670408
9.743333, 352.986290
9.746667, 343.781643
9.750000, 334.110936
9.753333, 324.029654
9.756667, 313.594315
9.760000, 302.862108
9.763333, 291.890447
9.766667, 280.736103
9.770000, 269.454362
9.773333, 258.098999
9.776667, 246.722372
9.780000, 235.374886
9.783333, 224.104180
9.786667, 212.954141
9.790000, 201.964547
9.793333, 191.172035
9.796667, 180.610648
9.800000, 170.310953
9.803333, 160.299509
9.806667, 150.599124
9.810000, 141.228778
9.813333, 132.203589
9.816667, 123.535343
9.820000, 115.232884
9.823333, 107.302311
9.826667, 99.747423
9.830000, 92.570223
9.833333, 85.771037
9.836667, 79.348102
9.840000, 73.296777
9.843333, 67.609141
9.846667, 62.274877
9.850000, 57.282913
9.853333, 52.622273
9.856667, 48.281731
9.860000, 44.249269
9.863333, 40.511821
9.866667, 37.055257
9.870000, 33.864758
9.873333, 30.925622
9.876667, 28.223817
9.880000, 25.745475
9.883333, 23.476053
9.886667, 21.400622
9.890000, 19.504994
9.893333, 17.776062
9.896667, 16.201325
9.900000, 14.768864
9.903333, 13.467552
9.906667, 12.286909
9.910000, 11.217183
9.913333, 10.249488
9.916667, 9.375368
9.920000, 8.586423
9.923333, 7.874505
9.926667, 7.231993
9.930000, 6.651882
9.933333, 6.127886
9.936667, 5.654501
9.940000, 5.226952
9.943333, 4.840953
9.946667, 4.492394
9.950000, 4.177368
9.953333, 3.892384
9.956667, 3.634429
9.960000, 3.400834
9.963333, 3.189041
9.966667, 2.996615
9.970000, 2.821506
9.973333, 2.662119
9.976667, 2.517156
9.980000, 2.385181
9.983333, 2.264392
9.986667, 2.153037
9.990000, 2.049790
9.993333, 1.953733
9.996667, 1.864240
10.000000, 1.780885
10.003333, 1.703447
10.006667, 1.631910
10.010000, 1.566128
10.013333, 1.505371
10.016667, 1.448452
10.020000, 1.394333
10.023333, 1.342426
10.026667, 1.292525
10.030000, 1.244644
10.033333, 1.198942
10.036667, 1.155848
10.040000, 1.116072
10.043333, 1.080034
10.046667, 1.047098
10.050000, 1.015880
10.053333, 0.985475
10.056667, 0.955915
10.060000, 0.927454
10.063333, 0.900029
10.066667, 0.873389
10.070000, 0.847402
10.073333, 0.822213
10.076667, 0.798123
10.080000, 0.775258
10.083333, 0.753404
10.086667, 0.732134
10.090000, 0.711072
10.093333, 0.690193
10.096667, 0.670056
10.100000, 0.651475
10.103333, 0.634748
10.106667, 0.619442
10.110000, 0.604902
10.113333, 0.590709
10.116667, 0.576649
10.120000, 0.562492
10.123333, 0.547996
10.126667, 0.533133
10.130000, 0.518312
10.133333, 0.504357
10.136667, 0.492036
10.140000, 0.481591
10.143333, 0.472628
10.146667, 0.464167
10.150000, 0.455030
10.153333, 0.444522
10.156667, 0.432752
10.160000, 0.420562
10.163333, 0.409140
10.166667, 0.399357
10.170000, 0.391250
10.173333, 0.384031
10.176667, 0.376681
10.180000, 0.368749
10.183333, 0.360568
10.186667, 0.352720
10.190000, 0.345502
10.193333, 0.338768
10.196667, 0.332097
10.200000, 0.325309
10.203333, 0.318705
10.206667, 0.312655
10.210000, 0.307164
10.213333, 0.302002
10.216667, 0.297054
10.220000, 0.292403
10.223333, 0.287999
10.226667, 0.283341
10.230000, 0.277960
10.233333, 0.272229
10.236667, 0.266945
10.240000, 0.262286
10.243333, 0.257851
10.246667, 0.253301
10.250000, 0.248592
10.253333, 0.243959
10.256667, 0.239650
10.260000, 0.235596
10.263333, 0.231623
10.266667, 0.227841
10.270000, 0.224447
10.273333, 0.221301
10.276667, 0.217925
10.280000, 0.213998
10.283333, 0.209819
10.286667, 0.206048
10.290000, 0.203133
10.293333, 0.201115
10.296667, 0.199708
10.300000, 0.198303
10.303333, 0.196074
10.306667, 0.192562
10.310000, 0.188155
10.313333, 0.183581
10.316667, 0.179157
10.320000, 0.174894
10.323333, 0.170844
10.326667, 0.166984
10.330000, 0.163160
10.333333, 0.159422
10.336667, 0.156012
10.340000, 0.153016
10.343333, 0.150417
10.346667, 0.148281
10.350000, 0.146706
10.353333, 0.145610
10.356667, 0.144518
10.360000, 0.142876
10.363333, 0.140712
10.366667, 0.138530
10.370000, 0.136474
10.373333, 0.134128
10.376667, 0.131286
10.380000, 0.128334
10.383333, 0.125656
10.386667, 0.123155
10.390000, 0.120583
10.393333, 0.117985
10.396667, 0.115677
10.400000, 0.113901
10.403333, 0.112533
10.406667, 0.111213
10.410000, 0.109745
10.413333, 0.108140
10.416667, 0.106434
10.420000, 0.104637
10.423333, 0.102590
10.426667, 0.099984
10.430000, 0.096799
10.433333, 0.093373
10.436667, 0.089960
10.440000, 0.086537
10.443333, 0.083020
10.446667, 0.079461
10.450000, 0.076002
10.453333, 0.072781
10.456667, 0.070030
10.460000, 0.068035
10.463333, 0.066904
10.466667, 0.066625
10.470000, 0.067077
10.473333, 0.067751
10.476667, 0.067900
10.480000, 0.067115
10.483333, 0.065412
10.486667, 0.063068
10.490000, 0.060731
10.493333, 0.059119
10.496667, 0.058374
10.500000, 0.058044
10.503333, 0.057562
10.506667, 0.056578
10.510000, 0.055089
10.513333, 0.053410
10.516667, 0.051867
10.520000, 0.050448
10.523333, 0.048881
10.526667, 0.046965
10.530000, 0.044619
10.533333, 0.041891
10.536667, 0.039167
10.540000, 0.037123
10.543333, 0.036115
10.546667, 0.035843
10.550000, 0.035846
10.553333, 0.035949
10.556667, 0.036222
10.560000, 0.036792
10.563333, 0.037657
10.566667, 0.038602
10.570000, 0.039128
10.573333, 0.038707
10.576667, 0.037381
10.580000, 0.035844
10.583333, 0.034767
10.586667, 0.034162
10.590000, 0.033653
10.593333, 0.033135
10.596667, 0.032614
10.600000, 0.031993
10.603333, 0.031370
10.606667, 0.030951
10.610000, 0.030757
10.613333, 0.030513
10.616667, 0.029731
10.620000, 0.028244
10.623333, 0.026603
10.626667, 0.025594
10.630000, 0.025520
10.633333, 0.026022
10.636667, 0.026467
10.640000, 0.026451
10.643333, 0.025895
10.646667, 0.024806
10.650000, 0.023298
10.653333, 0.021707
10.656667, 0.020313
10.660000, 0.019224
10.663333, 0.018703
10.666667, 0.019050
10.670000, 0.020111
10.673333, 0.021274
10.676667, 0.021816
10.680000, 0.021310
10.683333, 0.020153
10.686667, 0.019396
10.690000, 0.019615
10.693333, 0.020299
10.696667, 0.020637
10.700000, 0.020428
10.703333, 0.020014
10.706667, 0.019603
10.710000, 0.018990
10.713333, 0.017967
10.716667, 0.016683
10.720000, 0.015452
10.723333, 0.014627
10.726667, 0.014589
10.730000, 0.015357
10.733333, 0.016375
10.736667, 0.016982
10.740000, 0.017008
10.743333, 0.016869
10.746667, 0.017068
10.750000, 0.017698
10.753333, 0.018474
10.756667, 0.019025
10.760000, 0.019128
10.763333, 0.018793
10.766667, 0.018226
10.770000, 0.017934
10.773333, 0.018508
10.776667, 0.019872
10.780000, 0.021237
10.783333, 0.021890
10.786667, 0.021710
10.790000, 0.020967
10.793333, 0.019831
10.796667, 0.018277
10.800000, 0.016408
10.803333, 0.014710
10.806667, 0.013899
10.810000, 0.014313
10.813333, 0.015609
10.816667, 0.017065
10.820000, 0.018079
10.823333, 0.018397
10.826667, 0.017917
10.830000, 0.016615
10.833333, 0.014895
10.836667, 0.013564
10.840000, 0.013167
10.843333, 0.013538
10.846667, 0.014014
10.850000, 0.014011
10.853333, 0.013516
10.856667, 0.012919
10.860000, 0.012412
10.863333, 0.011846
10.866667, 0.011216
10.870000, 0.010832
10.873333, 0.010763
10.876667, 0.010557
10.880000, 0.009780
10.883333, 0.008459
10.886667, 0.006923
10.890000, 0.005560
10.893333, 0.004621
10.896667, 0.003954
10.900000, 0.003064
10.903333, 0.001494
10.906667, -0.000804
10.910000, -0.003284
10.913333, -0.005181
10.916667, -0.006208
10.920000, -0.006527
10.923333, -0.006171
10.926667, -0.005012
10.930000, -0.003227
10.933333, -0.001512
10.936667, -0.000714
10.940000, -0.001139
10.943333, -0.002310
10.946667, -0.003424
10.950000, -0.004069
10.953333, -0.004513
10.956667, -0.005287
10.960000, -0.006541
10.963333, -0.008030
10.966667, -0.009655
10.970000, -0.011553
10.973333, -0.013754
10.976667, -0.016109
10.980000, -0.018249
10.983333, -0.019628
10.986667, -0.019956
10.990000, -0.019360
10.993333, -0.018232
10.996667, -0.017124
11.000000, -0.016411
11.003333, -0.016056
11.006667, -0.015890
11.010000, -0.015838
11.013333, -0.015803
11.016667, -0.015619
11.020000, -0.015414
11.023333, -0.015793
11.026667, -0.017235
11.030000, -0.019486
11.033333, -0.021665
11.036667, -0.022951
11.040000, -0.023268
11.043333, -0.023097
11.046667, -0.022821
11.050000, -0.022696
11.053333, -0.023087
11.056667, -0.024190
11.060000, -0.025644
11.063333, -0.026666
11.066667, -0.026598
11.070000, -0.025492
11.073333, -0.024198
11.076667, -0.023641
11.080000, -0.024077
11.083333, -0.025050
11.086667, -0.025689
11.090000, -0.025237
11.093333, -0.023624
11.096667, -0.021483
11.100000, -0.019773
11.103333, -0.019376
11.106667, -0.020575
11.110000, -0.022821
11.113333, -0.025174
11.116667, -0.026851
11.120000, -0.027468
11.123333, -0.027124
11.126667, -0.026285
11.130000, -0.025550
11.133333, -0.025397
11.136667, -0.025915
11.140000, -0.026781
11.143333, -0.027470
11.146667, -0.027387
11.150000, -0.026114
11.153333, -0.023896
11.156667, -0.021571
11.160000, -0.019746
11.163333, -0.018380
11.166667, -0.017185
11.170000, -0.016091
11.173333, -0.015319
11.176667, -0.015050
11.180000, -0.014987
11.183333, -0.014481
11.186667, -0.013286
11.190000, -0.011897
11.193333, -0.010932
11.196667, -0.010533
11.200000, -0.010488
11.203333, -0.010469
11.206667, -0.010276
11.210000, -0.010050
11.213333, -0.010081
11.216667, -0.010442
11.220000, -0.010798
11.223333, -0.010564
11.226667, -0.009462
11.230000, -0.007857
11.233333, -0.006311
11.236667, -0.004939
11.240000, -0.003581
11.243333, -0.002449
11.246667, -0.002055
11.250000, -0.002480
11.253333, -0.003152
11.256667, -0.003403
11.260000, -0.002958
11.263333, -0.001963
11.266667, -0.000767
11.270000, 0.000301
11.273333, 0.001148
11.276667, 0.001984
11.280000, 0.003017
11.283333, 0.004001
11.286667, 0.004299
11.290000, 0.003551
11.293333, 0.002163
11.296667, 0.000889
11.300000, -0.000007
11.303333, -0.000889
11.306667, -0.002137
11.310000, -0.003702
11.313333, -0.005256
11.316667, -0.006573
11.320000, -0.007721
11.323333, -0.008880
11.326667, -0.009921
11.330000, -0.010427
11.333333, -0.010395
11.336667, -0.010456
11.340000, -0.011054
11.343333, -0.012021
11.346667, -0.013002
11.350000, -0.013695
11.353333, -0.013837
11.356667, -0.013413
11.360000, -0.012811
11.363333, -0.012643
11.366667, -0.013339
11.370000, -0.014776
11.373333, -0.016379
11.376667, -0.017544
11.380000, -0.017900
11.383333, -0.017425
11.386667, -0.016550
11.390000, -0.015933
11.393333, -0.015954
11.396667, -0.016559
11.400000, -0.017528
11.403333, -0.018627
11.406667, -0.019613
11.410000, -0.020415
11.413333, -0.021483
11.416667, -0.023562
11.420000, -0.026751
11.423333, -0.030095
11.426667, -0.032409
11.430000, -0.033259
11.433333, -0.032963
11.436667, -0.032065
11.440000, -0.031006
11.443333, -0.030030
11.446667, -0.029331
11.450000, -0.029005
11.453333, -0.028922
11.456667, -0.028958
11.460000, -0.029045
11.463333, -0.029047
11.466667, -0.028933
11.470000, -0.028776
11.473333, -0.028614
11.476667, -0.028511
11.480000, -0.028610
11.483333, -0.029131
11.486667, -0.030423
11.490000, -0.032645
11.493333, -0.035166
11.496667, -0.036898
11.500000, -0.037493
11.503333, -0.037624
11.506667, -0.038061
11.510000, -0.038957
11.513333, -0.040050
11.516667, -0.041194
11.520000, -0.042446
11.523333, -0.043880
11.526667, -0.045467
11.530000, -0.046970
11.533333, -0.048029
11.536667, -0.048537
11.540000, -0.048769
11.543333, -0.048911
11.546667, -0.048699
11.550000, -0.047900
11.553333, -0.046752
11.556667, -0.045680
11.560000, -0.044907
11.563333, -0.044336
11.566667, -0.043878
11.570000, -0.043799
11.573333, -0.044288
11.576667, -0.044954
11.580000, -0.045362
11.583333, -0.045736
11.586667, -0.046653
11.590000, -0.048249
11.593333, -0.049996
11.596667, -0.051094
11.600000, -0.051210
11.603333, -0.050946
11.606667, -0.051136
11.610000, -0.051820
11.613333, -0.052428
11.616667, -0.052505
11.620000, -0.051918
11.623333, -0.050829
11.626667, -0.049588
11.630000, -0.048390
11.633333, -0.047018
11.636667, -0.045210
11.640000, -0.043165
11.643333, -0.041295
11.646667, -0.039846
11.650000, -0.039003
11.653333, -0.038859
11.656667, -0.039276
11.660000, -0.039895
11.663333, -0.040232
11.666667, -0.040074
11.670000, -0.039807
11.673333, -0.039944
11.676667, -0.040473
11.680000, -0.040957
11.683333, -0.041149
11.686667, -0.041162
11.690000, -0.041143
11.693333, -0.041066
11.696667, -0.040793
11.700000, -0.040264
11.703333, -0.039709
11.706667, -0.039510
11.710000, -0.039654
11.713333, -0.039462
11.716667, -0.038237
11.720000, -0.036031
11.723333, -0.033494
11.726667, -0.031213
11.730000, -0.029614
11.733333, -0.029199
11.736667, -0.030139
11.740000, -0.031771
11.743333, -0.033002
11.746667, -0.033046
11.750000, -0.031609
11.753333, -0.028823
11.756667, -0.025381
11.760000, -0.022302
11.763333, -0.020222
11.766667, -0.019164
11.770000, -0.019085
11.773333, -0.019960
11.776667, -0.021149
11.780000, -0.021508
11.783333, -0.020305
11.786667, -0.017629
11.790000, -0.014074
11.793333, -0.010455
11.796667, -0.007639
11.800000, -0.006165
11.803333, -0.005989
11.806667, -0.006632
11.810000, -0.007499
11.813333, -0.008107
11.816667, -0.008168
11.820000, -0.007664
11.823333, -0.006838
11.826667, -0.005956
11.830000, -0.005037
11.833333, -0.004007
11.836667, -0.003088
11.840000, -0.002658
11.843333, -0.002743
11.846667, -0.002965
11.850000, -0.003014
11.853333, -0.002931
11.856667, -0.002852
11.860000, -0.002660
11.863333, -0.002145
11.866667, -0.001488
11.870000, -0.001203
11.873333, -0.001620
11.876667, -0.002735
11.880000, -0.004359
11.883333, -0.006108
11.886667, -0.007532
11.890000, -0.008506
11.893333, -0.009359
11.896667, -0.010431
11.900000, -0.011789
11.903333, -0.013404
11.906667, -0.015223
11.910000, -0.017047
11.913333, -0.018637
11.916667, -0.020063
11.920000, -0.021618
11.923333, -0.023251
11.926667, -0.024629
11.930000, -0.025708
11.933333, -0.026689
11.936667, -0.027575
11.940000, -0.028182
11.943333, -0.028475
11.946667, -0.028677
11.950000, -0.029070
11.953333, -0.029839
11.956667, -0.031127
11.960000, -0.033127
11.963333, -0.035960
11.966667, -0.039378
11.970000, -0.042732
11.973333, -0.045415
11.976667, -0.047278
11.980000, -0.048739
11.983333, -0.050463
11.986667, -0.052588
11.990000, -0.054429
11.993333, -0.055379
11.996667, -0.055736
12.000000, -0.056145
12.003333, -0.056760
12.006667, -0.057432
12.010000, -0.058163
12.013333, -0.059050
12.016667, -0.060139
12.020000, -0.061392
12.023333, -0.062696
12.026667, -0.063826
12.030000, -0.064394
12.033333, -0.064159
12.036667, -0.063541
12.040000, -0.063453
12.043333, -0.064381
12.046667, -0.065970
12.050000, -0.067565
12.053333, -0.068716
12.056667, -0.069176
12.060000, -0.068993
12.063333, -0.068722
12.066667, -0.068916
12.070000, -0.069516
12.073333, -0.070244
12.076667, -0.071010
12.080000, -0.071702
12.083333, -0.072275
12.086667, -0.073121
12.090000, -0.074725
12.093333, -0.076936
12.096667, -0.079066
12.100000, -0.080540
12.103333, -0.081173
12.106667, -0.081095
12.110000, -0.080734
12.113333, -0.080796
12.116667, -0.081866
12.120000, -0.083774
12.123333, -0.085726
12.126667, -0.087127
12.130000, -0.087856
12.133333, -0.087884
12.136667, -0.087258
12.140000, -0.086343
12.143333, -0.085703
12.146667, -0.085725
12.150000, -0.086502
12.153333, -0.087948
12.156667, -0.089819
12.160000, -0.091950
12.163333, -0.094514
12.166667, -0.097588
12.170000, -0.100816
12.173333, -0.103795
12.176667, -0.106311
12.180000, -0.108230
12.183333, -0.109544
12.186667, -0.110433
12.190000, -0.111182
12.193333, -0.112010
12.196667, -0.112868
12.200000, -0.113524
12.203333, -0.114016
12.206667, -0.114769
12.210000, -0.116008
12.213333, -0.117403
12.216667, -0.118450
12.220000, -0.118992
12.223333, -0.119385
12.226667, -0.120156
12.230000, -0.121554
12.233333, -0.123483
12.236667, -0.125601
12.240000, -0.127283
12.243333, -0.127926
12.246667, -0.127629
12.250000, -0.127126
12.253333, -0.126907
12.256667, -0.127019
12.260000, -0.127401
12.263333, -0.127773
12.266667, -0.127603
12.270000, -0.126563
12.273333, -0.124885
12.276667, -0.123185
12.280000, -0.121993
12.283333, -0.121529
12.286667, -0.121770
12.290000, -0.122485
12.293333, -0.123303
12.296667, -0.123907
12.300000, -0.124061
12.303333, -0.123646
12.306667, -0.122812
12.310000, -0.121899
12.313333, -0.121199
12.316667, -0.120816
12.320000, -0.120552
12.323333, -0.119890
12.326667, -0.118385
12.330000, -0.116082
12.333333, -0.113549
12.336667, -0.111647
12.340000, -0.111047
12.343333, -0.111634
12.346667, -0.112521
12.350000, -0.112753
12.353333, -0.111985
12.356667, -0.110636
12.360000, -0.109483
12.363333, -0.109001
12.366667, -0.109137
12.370000, -0.109768
12.373333, -0.110911
12.376667, -0.112211
12.380000, -0.112755
12.383333, -0.111690
12.386667, -0.108976
12.390000, -0.105527
12.393333, -0.102507
12.396667, -0.100649
12.400000, -0.100198
12.403333, -0.100934
12.406667, -0.102090
12.410000, -0.102669
12.413333, -0.102235
12.416667, -0.101184
12.420000, -0.100186
12.423333, -0.099630
12.426667, -0.099498
12.430000, -0.099601
12.433333, -0.099808
12.436667, -0.100013
12.440000, -0.100203
12.443333, -0.100594
12.446667, -0.101405
12.450000, -0.102416
12.453333, -0.102866
12.456667, -0.102088
12.460000, -0.100245
12.463333, -0.098022
12.466667, -0.095826
12.470000, -0.093814
12.473333, -0.092406
12.476667, -0.092161
12.480000, -0.093201
12.483333, -0.094996
12.486667, -0.096678
12.490000, -0.097553
12.493333, -0.097502
12.496667, -0.096970
12.500000, -0.096441
12.503333, -0.095842
12.506667, -0.094732
12.510000, -0.093140
12.513333, -0.091713
12.516667, -0.090921
12.520000, -0.090617
12.523333, -0.090371
12.526667, -0.089848
12.530000, -0.088943
12.533333, -0.087817
12.536667, -0.086809
12.540000, -0.086085
12.543333, -0.085393
12.546667, -0.084447
12.550000, -0.083381
12.553333, -0.082504
12.556667, -0.081778
12.560000, -0.080985
12.563333, -0.080321
12.566667, -0.080308
12.570000, -0.081077
12.573333, -0.082248
12.576667, -0.083272
12.580000, -0.083534
12.583333, -0.082637
12.586667, -0.080722
12.590000, -0.078192
12.593333, -0.075518
12.596667, -0.073293
12.600000, -0.071906
12.603333, -0.071351
12.606667, -0.071450
12.610000, -0.071927
12.613333, -0.072363
12.616667, -0.072236
12.620000, -0.071175
12.623333, -0.069419
12.626667, -0.067747
12.630000, -0.066715
12.633333, -0.066259
12.636667, -0.066158
12.640000, -0.066466
12.643333, -0.067174
12.646667, -0.067856
12.650000, -0.068085
12.653333, -0.067869
12.656667, -0.067481
12.660000, -0.067207
12.663333, -0.067186
12.666667, -0.067163
12.670000, -0.066611
12.673333, -0.065296
12.676667, -0.063539
12.680000, -0.062004
12.683333, -0.061300
12.686667, -0.061495
12.690000, -0.062015
12.693333, -0.062267
12.696667, -0.062264
12.700000, -0.062339
12.703333, -0.062551
12.706667, -0.062653
12.710000, -0.062334
12.713333, -0.061431
12.716667, -0.060189
12.720000, -0.059190
12.723333, -0.058791
12.726667, -0.058799
12.730000, -0.058846
12.733333, -0.058688
12.736667, -0.058147
12.740000, -0.057265
12.743333, -0.056471
12.746667, -0.056240
12.750000, -0.056682
12.753333, -0.057540
12.756667, -0.058509
12.760000, -0.059459
12.763333, -0.060379
12.766667, -0.061324
12.770000, -0.062392
12.773333, -0.063476
12.776667, -0.064074
12.780000, -0.063561
12.783333, -0.061802
12.786667, -0.059484
12.790000, -0.057599
12.793333, -0.056463
12.796667, -0.055574
12.800000, -0.054459
12.803333, -0.053116
12.806667, -0.051616
12.810000, -0.049906
12.813333, -0.047972
12.816667, -0.045892
12.820000, -0.043804
12.823333, -0.041887
12.826667, -0.040469
12.830000, -0.039982
12.833333, -0.040433
12.836667, -0.041135
12.840000, -0.041258
12.843333, -0.040523
12.846667, -0.039365
12.850000, -0.038508
12.853333, -0.038234
12.856667, -0.038099
12.860000, -0.037454
12.863333, -0.036047
12.866667, -0.034157
12.870000, -0.032275
12.873333, -0.030666
12.876667, -0.029237
12.880000, -0.027790
12.883333, -0.026362
12.886667, -0.025090
12.890000, -0.023936
12.893333, -0.022899
12.896667, -0.022272
12.900000, -0.022433
12.903333, -0.023461
12.906667, -0.024984
12.910000, -0.026492
12.913333, -0.027675
12.916667, -0.028406
12.920000, -0.028647
12.923333, -0.028482
12.926667, -0.028196
12.930000, -0.028149
12.933333, -0.028432
12.936667, -0.028830
12.940000, -0.029154
12.943333, -0.029350
12.946667, -0.029285
12.950000, -0.028702
12.953333, -0.027654
12.956667, -0.026799
12.960000, -0.026969
12.963333, -0.028453
12.966667, -0.030792
12.970000, -0.033236
12.973333, -0.035150
12.976667, -0.036151
12.980000, -0.036350
12.983333, -0.036407
12.986667, -0.037027
12.990000, -0.038407
12.993333, -0.040167
12.996667, -0.041741
13.000000, -0.042817
13.003333, -0.043505
13.006667, -0.044134
13.010000, -0.044975
13.013333, -0.046158
13.016667, -0.047630
13.020000, -0.049156
13.023333, -0.050391
13.026667, -0.050948
13.030000, -0.050554
13.033333, -0.049319
13.036667, -0.047739
13.040000, -0.046372
13.043333, -0.045584
13.046667, -0.045508
13.050000, -0.046058
13.053333, -0.046889
13.056667, -0.047476
13.060000, -0.047411
13.063333, -0.046641
13.066667, -0.045505
13.070000, -0.044485
13.073333, -0.043793
13.076667, -0.043262
13.080000, -0.042671
13.083333, -0.042063
13.086667, -0.041601
13.090000, -0.041268
13.093333, -0.041045
13.096667, -0.041076
13.100000, -0.041362
13.103333, -0.041604
13.106667, -0.041435
13.110000, -0.040603
13.113333, -0.039200
13.116667, -0.037940
13.120000, -0.037583
13.123333, -0.037974
13.126667, -0.038209
13.130000, -0.037472
13.133333, -0.035511
13.136667, -0.032814
13.140000, -0.030445
13.143333, -0.029393
13.146667, -0.029715
13.150000, -0.030659
13.153333, -0.031809
13.156667, -0.033325
13.160000, -0.035168
13.163333, -0.036935
13.166667, -0.038265
13.170000, -0.038939
13.173333, -0.038812
13.176667, -0.037882
13.180000, -0.036420
13.183333, -0.034978
13.186667, -0.034208
13.190000, -0.034441
13.193333, -0.035357
13.196667, -0.036283
13.200000, -0.036832
13.203333, -0.037138
13.206667, -0.037455
13.210000, -0.037680
13.213333, -0.037566
13.216667, -0.037234
13.220000, -0.037107
13.223333, -0.037394
13.226667, -0.037849
13.230000, -0.038111
13.233333, -0.038038
13.236667, -0.037755
13.240000, -0.037747
13.243333, -0.038605
13.246667, -0.040245
13.250000, -0.041705
13.253333, -0.042019
13.256667, -0.041166
13.260000, -0.039924
13.263333, -0.039103
13.266667, -0.039143
13.270000, -0.040030
13.273333, -0.041533
13.276667, -0.043651
13.280000, -0.046387
13.283333, -0.049224
13.286667, -0.051478
13.290000, -0.052897
13.293333, -0.053568
13.296667, -0.053746
13.300000, -0.053900
13.303333, -0.054393
13.306667, -0.054927
13.310000, -0.054656
13.313333, -0.053026
13.316667, -0.050366
13.320000, -0.047689
13.323333, -0.046074
13.326667, -0.045954
13.330000, -0.046753
13.333333, -0.047359
13.336667, -0.047124
13.340000, -0.046477
13.343333, -0.046445
13.346667, -0.047680
13.350000, -0.050144
13.353333, -0.053342
13.356667, -0.056412
13.360000, -0.058332
13.363333, -0.058512
13.366667, -0.057361
13.370000, -0.056166
13.373333, -0.056156
13.376667, -0.057588
13.380000, -0.059713
13.383333, -0.061622
13.386667, -0.063040
13.390000, -0.064174
13.393333, -0.065056
13.396667, -0.065436
13.400000, -0.065287
13.403333, -0.064943
13.406667, -0.064672
13.410000, -0.064492
13.413333, -0.064406
13.416667, -0.064513
13.420000, -0.064949
13.423333, -0.065796
13.426667, -0.066903
13.430000, -0.067960
13.433333, -0.069007
13.436667, -0.070407
13.440000, -0.072190
13.443333, -0.074004
13.446667, -0.075700
13.450000, -0.077390
13.453333, -0.078959
13.456667, -0.079998
13.460000, -0.080333
13.463333, -0.080322
13.466667, -0.080486
13.470000, -0.081009
13.473333, -0.081768
13.476667, -0.082826
13.480000, -0.084446
13.483333, -0.086564
13.486667, -0.088628
13.490000, -0.090052
13.493333, -0.090687
13.496667, -0.090808
13.500000, -0.090874
13.503333, -0.091275
13.506667, -0.092085
13.510000, -0.093131
13.513333, -0.094132
13.516667, -0.094584
13.520000, -0.094026
13.523333, -0.092633
13.526667, -0.091165
13.530000, -0.090352
13.533333, -0.090483
13.536667, -0.091356
13.540000, -0.092499
13.543333, -0.093396
13.546667, -0.093621
13.550000, -0.093119
13.553333, -0.092412
13.556667, -0.092236
13.560000, -0.092961
13.563333, -0.094444
13.566667, -0.096299
13.570000, -0.098190
13.573333, -0.099905
13.576667, -0.101306
13.580000, -0.102265
13.583333, -0.102738
13.586667, -0.102871
13.590000, -0.102782
13.593333, -0.102401
13.596667, -0.101879
13.600000, -0.101746
13.603333, -0.102266
13.606667, -0.103005
13.610000, -0.103396
13.613333, -0.103420
13.616667, -0.103486
13.620000, -0.104034
13.623333, -0.105252
13.626667, -0.106894
13.630000, -0.108432
13.633333, -0.109469
13.636667, -0.109971
13.640000, -0.110057
13.643333, -0.109714
13.646667, -0.108913
13.650000, -0.107850
13.653333, -0.106932
13.656667, -0.106541
13.660000, -0.106767
13.663333, -0.107300
13.666667, -0.107928
13.670000, -0.109015
13.673333, -0.111000
13.676667, -0.113627
13.680000, -0.116070
13.683333, -0.117649
13.686667, -0.118207
13.690000, -0.117992
13.693333, -0.117415
13.696667, -0.116839
13.700000, -0.116432
13.703333, -0.116221
13.706667, -0.116231
13.710000, -0.116424
13.713333, -0.116640
13.716667, -0.116841
13.720000, -0.117248
13.723333, -0.118048
13.726667, -0.119087
13.730000, -0.119942
13.733333, -0.120305
13.736667, -0.120228
13.740000, -0.120050
13.743333, -0.120174
13.746667, -0.120887
13.750000, -0.122268
13.753333, -0.124100
13.756667, -0.125830
13.760000, -0.126799
13.763333, -0.126676
13.766667, -0.125610
13.770000, -0.124086
13.773333, -0.122621
13.776667, -0.121423
13.780000, -0.120381
13.783333, -0.119403
13.786667, -0.118631
13.790000, -0.118316
13.793333, -0.118534
13.796667, -0.119081
13.800000, -0.119502
13.803333, -0.119196
13.806667, -0.117881
13.810000, -0.115988
13.813333, -0.114136
13.816667, -0.112394
13.820000, -0.110435
13.823333, -0.108216
13.826667, -0.106135
13.830000, -0.104559
13.833333, -0.103559
13.836667, -0.103138
13.840000, -0.103375
13.843333, -0.104240
13.846667, -0.105337
13.850000, -0.106078
13.853333, -0.106178
13.856667, -0.105711
13.860000, -0.104806
13.863333, -0.103482
13.866667, -0.101607
13.870000, -0.099051
13.873333, -0.096004
13.876667, -0.092921
13.880000, -0.090168
13.883333, -0.088017
13.886667, -0.086714
13.890000, -0.086053
13.893333, -0.085269
13.896667, -0.083753
13.900000, -0.081502
13.903333, -0.078916
13.906667, -0.076563
13.910000, -0.074989
13.913333, -0.074383
13.916667, -0.074340
13.920000, -0.074186
13.923333, -0.073576
13.926667, -0.072612
13.930000, -0.071554
13.933333, -0.070633
13.936667, -0.069883
13.940000, -0.068984
13.943333, -0.067494
13.946667, -0.065311
13.950000, -0.062825
13.953333, -0.060475
13.956667, -0.058407
13.960000, -0.056691
13.963333, -0.055397
13.966667, -0.054402
13.970000, -0.053415
13.973333, -0.052325
13.976667, -0.051511
13.980000, -0.051486
13.983333, -0.052123
13.986667, -0.052775
13.990000, -0.053095
13.993333, -0.053206
13.996667, -0.053273
14.000000, -0.053349
14.003333, -0.053284
14.006667, -0.052680
14.010000, -0.051215
14.013333, -0.048958
14.016667, -0.046427
14.020000, -0.044448
14.023333, -0.043617
14.026667, -0.043760
14.030000, -0.044085
14.033333, -0.043799
14.036667, -0.042730
14.040000, -0.041439
14.043333, -0.040565
14.046667, -0.040183
14.050000, -0.039894
14.053333, -0.039403
14.056667, -0.038928
14.060000, -0.038850
14.063333, -0.039109
14.066667, -0.039416
14.070000, -0.039842
14.073333, -0.040682
14.076667, -0.041891
14.080000, -0.042935
14.083333, -0.043158
14.086667, -0.042123
14.090000, -0.039761
14.093333, -0.036553
14.096667, -0.033298
14.100000, -0.030763
14.103333, -0.029646
14.106667, -0.030131
14.110000, -0.031401
14.113333, -0.032280
14.116667, -0.032199
14.120000, -0.031309
14.123333, -0.030059
14.126667, -0.028825
14.130000, -0.027756
14.133333, -0.026772
14.136667, -0.025662
14.140000, -0.024348
14.143333, -0.023140
14.146667, -0.022486
14.150000, -0.022433
14.153333, -0.022575
14.156667, -0.022410
14.160000, -0.021683
14.163333, -0.020513
14.166667, -0.019228
14.170000, -0.018019
14.173333, -0.016743
14.176667, -0.015030
14.180000, -0.012712
14.183333, -0.010097
14.186667, -0.007678
14.190000, -0.005816
14.193333, -0.004814
14.196667, -0.004777
14.200000, -0.005345
14.203333, -0.006013
14.206667, -0.006506
14.210000, -0.006592
14.213333, -0.005961
14.216667, -0.004491
14.220000, -0.002429
14.223333, -0.000171
14.226667, 0.002018
14.230000, 0.004017
14.233333, 0.005763
14.236667, 0.007294
14.240000, 0.008765
14.243333, 0.010237
14.246667, 0.011588
14.250000, 0.012692
14.253333, 0.013413
14.256667, 0.013599
14.260000, 0.013494
14.263333, 0.013780
14.266667, 0.014885
14.270000, 0.016707
14.273333, 0.019025
14.276667, 0.021638
14.280000, 0.024271
14.283333, 0.026713
14.286667, 0.028912
14.290000, 0.030775
14.293333, 0.032108
14.296667, 0.032881
14.300000, 0.033361
14.303333, 0.033925
14.306667, 0.034742
14.310000, 0.035663
14.313333, 0.036507
14.316667, 0.037311
14.320000, 0.038209
14.323333, 0.039349
14.326667, 0.041025
14.330000, 0.043473
14.333333, 0.046375
14.336667, 0.049006
14.340000, 0.050970
14.343333, 0.052350
14.346667, 0.053394
14.350000, 0.054523
14.353333, 0.056163
14.356667, 0.058219
14.360000, 0.060169
14.363333, 0.061742
14.366667, 0.063107
14.370000, 0.064464
14.373333, 0.065844
14.376667, 0.067289
14.380000, 0.068801
14.383333, 0.070021
14.386667, 0.070393
14.390000, 0.069842
14.393333, 0.068927
14.396667, 0.068374
14.400000, 0.068598
14.403333, 0.069439
14.406667, 0.070323
14.410000, 0.070769
14.413333, 0.070712
14.416667, 0.070382
14.420000, 0.070113
14.423333, 0.070237
14.426667, 0.070827
14.430000, 0.071487
14.433333, 0.071558
14.436667, 0.070743
14.440000, 0.069528
14.443333, 0.068692
14.446667, 0.068606
14.450000, 0.069134
14.453333, 0.069813
14.456667, 0.070004
14.460000, 0.069263
14.463333, 0.067739
14.466667, 0.066081
14.470000, 0.064810
14.473333, 0.063908
14.476667, 0.063036
14.480000, 0.061858
14.483333, 0.060111
14.486667, 0.057724
14.490000, 0.054980
14.493333, 0.052227
14.496667, 0.049516
14.500000, 0.046832
14.503333, 0.044505
14.506667, 0.043111
14.510000, 0.042828
14.513333, 0.042982
14.516667, 0.042591
14.520000, 0.041332
14.523333, 0.039549
14.526667, 0.037560
14.530000, 0.035479
14.533333, 0.033448
14.536667, 0.031498
14.540000, 0.029322
14.543333, 0.026553
14.546667, 0.023155
14.550000, 0.019336
14.553333, 0.015317
14.556667, 0.011390
14.560000, 0.007889
14.563333, 0.004951
14.566667, 0.002470
14.570000, 0.000304
14.573333, -0.001467
14.576667, -0.002462
14.580000, -0.002396
14.583333, -0.001527
14.586667, -0.000581
14.590000, -0.000368
14.593333, -0.001490
14.596667, -0.004119
14.600000, -0.007733
14.603333, -0.011115
14.606667, -0.013207
14.610000, -0.014094
14.613333, -0.014860
14.616667, -0.016553
14.620000, -0.019341
14.623333, -0.022567
14.626667, -0.025535
14.630000, -0.028030
14.633333, -0.030158
14.636667, -0.032058
14.640000, -0.033745
14.643333, -0.035102
14.646667, -0.036011
14.650000, -0.036482
14.653333, -0.036665
14.656667, -0.036640
14.660000, -0.036391
14.663333, -0.036135
14.666667, -0.036239
14.670000, -0.036858
14.673333, -0.037951
14.676667, -0.039338
14.680000, -0.040821
14.683333, -0.042385
14.686667, -0.043945
14.690000, -0.045075
14.693333, -0.045248
14.696667, -0.044246
14.700000, -0.042406
14.703333, -0.040460
14.706667, -0.039047
14.710000, -0.038471
14.713333, -0.038671
14.716667, -0.039138
14.720000, -0.039169
14.723333, -0.038555
14.726667, -0.037673
14.730000, -0.036963
14.733333, -0.036771
14.736667, -0.037364
14.740000, -0.038663
14.743333, -0.040185
14.746667, -0.041609
14.750000, -0.043138
14.753333, -0.045075
14.756667, -0.047394
14.760000, -0.049755
14.763333, -0.051698
14.766667, -0.052875
14.770000, -0.053199
14.773333, -0.052776
14.776667, -0.051799
14.780000, -0.050721
14.783333, -0.050181
14.786667, -0.050276
14.790000, -0.050346
14.793333, -0.049753
14.796667, -0.048426
14.800000, -0.046787
14.803333, -0.045625
14.806667, -0.045701
14.810000, -0.047067
14.813333, -0.048902
14.816667, -0.050350
14.820000, -0.051324
14.823333, -0.052170
14.826667, -0.052975
14.830000, -0.053552
14.833333, -0.053874
14.836667, -0.054339
14.840000, -0.055339
14.843333, -0.056701
14.846667, -0.057887
14.850000, -0.058601
14.853333, -0.058989
14.856667, -0.059318
14.860000, -0.059680
14.863333, -0.060073
14.866667, -0.060471
14.870000, -0.060934
14.873333, -0.061628
14.876667, -0.062502
14.880000, -0.063421
14.883333, -0.064670
14.886667, -0.066627
14.890000, -0.068934
14.893333, -0.070501
14.896667, -0.070505
14.900000, -0.069310
14.903333, -0.068249
14.906667, -0.068346
14.910000, -0.069370
14.913333, -0.070296
14.916667, -0.070464
14.920000, -0.070216
14.923333, -0.070584
14.926667, -0.072344
14.930000, -0.075269
14.933333, -0.078280
14.936667, -0.080308
14.940000, -0.081110
14.943333, -0.081214
14.946667, -0.081078
14.950000, -0.080600
14.953333, -0.079554
14.956667, -0.078075
14.960000, -0.076518
14.963333, -0.075266
14.966667, -0.074526
14.970000, -0.074091
14.973333, -0.073626
14.976667, -0.073114
14.980000, -0.072717
14.983333, -0.072333
14.986667, -0.071683
14.990000, -0.070617
14.993333, -0.069102
14.996667, -0.067266
15.000000, -0.065538
15.003333, -0.064366
15.006667, -0.063689
15.010000, -0.062944
15.013333, -0.061661
15.016667, -0.059868
15.020000, -0.058088
15.023333, -0.057003
15.026667, -0.056774
15.030000, -0.056834
15.033333, -0.056509
15.036667, -0.055548
15.040000, -0.054094
15.043333, -0.052578
15.046667, -0.051523
15.050000, -0.051083
15.053333, -0.051008
15.056667, -0.051086
15.060000, -0.051345
15.063333, -0.051867
15.066667, -0.052562
15.070000, -0.053140
15.073333, -0.053391
15.076667, -0.053431
15.080000, -0.053400
15.083333, -0.053098
15.086667, -0.052214
15.090000, -0.050713
15.093333, -0.048744
15.096667, -0.046501
15.100000, -0.044330
15.103333, -0.042581
15.106667, -0.041327
15.110000, -0.040514
15.113333, -0.040117
15.116667, -0.039945
15.120000, -0.039657
15.123333, -0.039025
15.126667, -0.038116
15.130000, -0.037383
15.133333, -0.037443
15.136667, -0.038595
15.140000, -0.040538
15.143333, -0.042475
15.146667, -0.043718
15.150000, -0.044427
15.153333, -0.045390
15.156667, -0.046942
15.160000, -0.048520
15.163333, -0.049368
15.166667, -0.049224
15.170000, -0.048183
15.173333, -0.046449
15.176667, -0.044466
15.180000, -0.042816
15.183333, -0.041682
15.186667, -0.040674
15.190000, -0.039339
15.193333, -0.037608
15.196667, -0.035612
15.200000, -0.033417
15.203333, -0.031213
15.206667, -0.029643
15.210000, -0.029442
15.213333, -0.030585
15.216667, -0.032207
15.220000, -0.033367
15.223333, -0.033626
15.226667, -0.033156
15.230000, -0.032310
15.233333, -0.031110
15.236667, -0.029515
15.240000, -0.027809
15.243333, -0.026297
15.246667, -0.025034
15.250000, -0.023941
15.253333, -0.022887
15.256667, -0.021737
15.260000, -0.020416
15.263333, -0.018956
15.266667, -0.017646
15.270000, -0.017027
15.273333, -0.017419
15.276667, -0.018527
15.280000, -0.019663
15.283333, -0.020237
15.286667, -0.019952
15.290000, -0.018717
15.293333, -0.016635
15.296667, -0.014207
15.300000, -0.012233
15.303333, -0.011166
15.306667, -0.010828
15.310000, -0.010791
15.313333, -0.010707
15.316667, -0.010450
15.320000, -0.010169
15.323333, -0.010021
15.326667, -0.009929
15.330000, -0.009799
15.333333, -0.009707
15.336667, -0.009698
15.340000, -0.009596
15.343333, -0.009116
15.346667, -0.008230
15.350000, -0.007406
15.353333, -0.007376
15.356667, -0.008676
15.360000, -0.011223
15.363333, -0.014195
15.366667, -0.016624
15.370000, -0.018141
15.373333, -0.019013
15.376667, -0.019656
15.380000, -0.020190
15.383333, -0.020507
15.386667, -0.020762
15.390000, -0.021293
15.393333, -0.021957
15.396667, -0.022088
15.400000, -0.021240
15.403333, -0.019700
15.406667, -0.018244
15.410000, -0.017624
15.413333, -0.018268
15.416667, -0.020067
15.420000, -0.022273
15.423333, -0.024019
15.426667, -0.025067
15.430000, -0.025922
15.433333, -0.027126
15.436667, -0.028440
15.440000, -0.029084
15.443333, -0.028697
15.446667, -0.027717
15.450000, -0.027082
15.453333, -0.027434
15.456667, -0.028446
15.460000, -0.029318
15.463333, -0.029713
15.466667, -0.029860
15.470000, -0.030240
15.473333, -0.031409
15.476667, -0.033555
15.480000, -0.036187
15.483333, -0.038797
15.486667, -0.041385
15.490000, -0.043898
15.493333, -0.046015
15.496667, -0.047695
15.500000, -0.049132
15.503333, -0.050244
15.506667, -0.050860
15.510000, -0.051159
15.513333, -0.051446
15.516667, -0.051804
15.520000, -0.052312
15.523333, -0.053229
15.526667, -0.054767
15.530000, -0.056943
15.533333, -0.059524
15.536667, -0.061823
15.540000, -0.062926
15.543333, -0.062470
15.546667, -0.061004
15.550000, -0.059505
15.553333, -0.058650
15.556667, -0.058616
15.560000, -0.059280
15.563333, -0.060309
15.566667, -0.061232
15.570000, -0.061801
15.573333, -0.062079
15.576667, -0.062137
15.580000, -0.061995
15.583333, -0.061650
15.586667, -0.061121
15.590000, -0.060603
15.593333, -0.060187
15.596667, -0.059574
15.600000, -0.058668
15.603333, -0.058113
15.606667, -0.058750
15.610000, -0.060765
15.613333, -0.063457
15.616667, -0.065656
15.620000, -0.066507
15.623333, -0.066115
15.626667, -0.065358
15.630000, -0.065064
15.633333, -0.065506
15.636667, -0.066537
15.640000, -0.067706
15.643333, -0.068307
15.646667, -0.068030
15.650000, -0.067284
15.653333, -0.066386
15.656667, -0.065259
15.660000, -0.063981
15.663333, -0.062703
15.666667, -0.061296
15.670000, -0.059673
15.673333, -0.058189
15.676667, -0.057473
15.680000, -0.057854
15.683333, -0.059036
15.686667, -0.060394
15.690000, -0.061386
15.693333, -0.061617
15.696667, -0.060950
15.700000, -0.059646
15.703333, -0.058159
15.706667, -0.056820
15.710000, -0.055746
15.713333, -0.054967
15.716667, -0.054650
15.720000, -0.055038
15.723333, -0.056099
15.726667, -0.057453
15.730000, -0.058588
15.733333, -0.059057
15.736667, -0.058630
15.740000, -0.057445
15.743333, -0.056030
15.746667, -0.055060
15.750000, -0.055004
15.753333, -0.055896
15.756667, -0.057249
15.760000, -0.058099
15.763333, -0.057583
15.766667, -0.055793
15.770000, -0.053768
15.773333, -0.052465
15.776667, -0.051887
15.780000, -0.051290
15.783333, -0.050072
15.786667, -0.048376
15.790000, -0.047023
15.793333, -0.046915
15.796667, -0.048214
15.800000, -0.050023
15.803333, -0.051158
15.806667, -0.051224
15.810000, -0.050624
15.813333, -0.049908
15.816667, -0.049522
15.820000, -0.049703
15.823333, -0.050317
15.826667, -0.051016
15.830000, -0.051593
15.833333, -0.051927
15.836667, -0.051739
15.840000, -0.050816
15.843333, -0.049350
15.846667, -0.047859
15.850000, -0.046768
15.853333, -0.046044
15.856667, -0.045360
15.860000, -0.044715
15.863333, -0.044545
15.866667, -0.045106
15.870000, -0.046046
15.873333, -0.046848
15.876667, -0.047352
15.880000, -0.047511
15.883333, -0.047133
15.886667, -0.046250
15.890000, -0.045202
15.893333, -0.044338
15.896667, -0.043953
15.900000, -0.044104
15.903333, -0.044529
15.906667, -0.045078
15.910000, -0.045881
15.913333, -0.046885
15.916667, -0.047684
15.920000, -0.048000
15.923333, -0.047956
15.926667, -0.047852
15.930000, -0.047898
15.933333, -0.048086
15.936667, -0.048178
15.940000, -0.048056
15.943333, -0.047914
15.946667, -0.047754
15.950000, -0.047194
15.953333, -0.046025
15.956667, -0.044459
15.960000, -0.042697
15.963333, -0.040801
15.966667, -0.039032
15.970000, -0.037800
15.973333, -0.037283
15.976667, -0.037575
15.980000, -0.038864
15.983333, -0.041152
15.986667, -0.044100
15.990000, -0.047142
15.993333, -0.049698
15.996667, -0.051458
16.000000, -0.052442
16.003333, -0.052863
16.006667, -0.053030
16.010000, -0.053146
16.013333, -0.052955
16.016667, -0.051871
16.020000, -0.049820
16.023333, -0.047584
16.026667, -0.046027
16.030000, -0.045583
16.033333, -0.046383
16.036667, -0.048302
16.040000, -0.050968
16.043333, -0.053719
16.046667, -0.055758
16.050000, -0.056679
16.053333, -0.056669
16.056667, -0.056178
16.060000, -0.055580
16.063333, -0.055039
16.066667, -0.054529
16.070000, -0.054007
16.073333, -0.053593
16.076667, -0.053566
16.080000, -0.054233
16.083333, -0.055727
16.086667, -0.057884
16.090000, -0.060324
16.093333, -0.062527
16.096667, -0.063872
16.100000, -0.063975
16.103333, -0.063195
16.106667, -0.062560
16.110000, -0.062935
16.113333, -0.064436
16.116667, -0.066624
16.120000, -0.068880
16.123333, -0.070623
16.126667, -0.071535
16.130000, -0.071746
16.133333, -0.071728
16.136667, -0.071976
16.140000, -0.072711
16.143333, -0.073797
16.146667, -0.075044
16.150000, -0.076397
16.153333, -0.077641
16.156667, -0.078299
16.160000, -0.078000
16.163333, -0.076777
16.166667, -0.075078
16.170000, -0.073399
16.173333, -0.071846
16.176667, -0.070396
16.180000, -0.069418
16.183333, -0.069384
16.186667, -0.070310
16.190000, -0.071726
16.193333, -0.073037
16.196667, -0.073935
16.200000, -0.074528
16.203333, -0.075101
16.206667, -0.075898
16.210000, -0.077046
16.213333, -0.078433
16.216667, -0.079666
16.220000, -0.080418
16.223333, -0.080796
16.226667, -0.080995
16.230000, -0.080834
16.233333, -0.080098
16.236667, -0.078988
16.240000, -0.077946
16.243333, -0.077319
16.246667, -0.077247
16.250000, -0.077624
16.253333, -0.078163
16.256667, -0.078659
16.260000, -0.079137
16.263333, -0.079761
16.266667, -0.080630
16.270000, -0.081602
16.273333, -0.082420
16.276667, -0.082964
16.280000, -0.083288
16.283333, -0.083476
16.286667, -0.083535
16.290000, -0.083552
16.293333, -0.083904
16.296667, -0.084988
16.300000, -0.086750
16.303333, -0.088655
16.306667, -0.090066
16.310000, -0.090697
16.313333, -0.090737
16.316667, -0.090466
16.320000, -0.089970
16.323333, -0.089408
16.326667, -0.089133
16.330000, -0.089295
16.333333, -0.089693
16.336667, -0.090054
16.340000, -0.090180
16.343333, -0.089984
16.346667, -0.089627
16.350000, -0.089483
16.353333, -0.089986
16.356667, -0.091389
16.360000, -0.093334
16.363333, -0.095013
16.366667, -0.095983
16.370000, -0.096426
16.373333, -0.096751
16.376667, -0.097276
16.380000, -0.098124
16.383333, -0.099206
16.386667, -0.100228
16.390000, -0.100739
16.393333, -0.100544
16.396667, -0.100127
16.400000, -0.100275
16.403333, -0.101171
16.406667, -0.102130
16.410000, -0.102321
16.413333, -0.101612
16.416667, -0.100560
16.420000, -0.099798
16.423333, -0.099528
16.426667, -0.099469
16.430000, -0.099367
16.433333, -0.099211
16.436667, -0.098911
16.440000, -0.098382
16.443333, -0.097697
16.446667, -0.096808
16.450000, -0.095570
16.453333, -0.094144
16.456667, -0.093060
16.460000, -0.092921
16.463333, -0.093917
16.466667, -0.095609
16.470000, -0.097393
16.473333, -0.098932
16.476667, -0.100051
16.480000, -0.100547
16.483333, -0.100227
16.486667, -0.099069
16.490000, -0.097318
16.493333, -0.095343
16.496667, -0.093324
16.500000, -0.091286
16.503333, -0.089511
16.506667, -0.088475
16.510000, -0.088313
16.513333, -0.088777
16.516667, -0.089455
16.520000, -0.089729
16.523333, -0.088994
16.526667, -0.087252
16.530000, -0.085370
16.533333, -0.084353
16.536667, -0.084335
16.540000, -0.084741
16.543333, -0.085016
16.546667, -0.084843
16.550000, -0.084122
16.553333, -0.082979
16.556667, -0.081722
16.560000, -0.080656
16.563333, -0.079794
16.566667, -0.078917
16.570000, -0.077972
16.573333, -0.077074
16.576667, -0.076161
16.580000, -0.075009
16.583333, -0.073526
16.586667, -0.071928
16.590000, -0.070685
16.593333, -0.070136
16.596667, -0.070236
16.600000, -0.070833
16.603333, -0.071785
16.606667, -0.072748
16.610000, -0.073223
16.613333, -0.072818
16.616667, -0.071406
16.620000, -0.069279
16.623333, -0.067134
16.626667, -0.065634
16.630000, -0.064958
16.633333, -0.064853
16.636667, -0.064980
16.640000, -0.065182
16.643333, -0.065500
16.646667, -0.065909
16.650000, -0.066161
16.653333, -0.066090
16.656667, -0.065995
16.660000, -0.066373
16.663333, -0.067172
16.666667, -0.067704
16.670000, -0.067547
16.673333, -0.067073
16.676667, -0.066752
16.680000, -0.066515
16.683333, -0.066221
16.686667, -0.066047
16.690000, -0.066013
16.693333, -0.065852
16.696667, -0.065614
16.700000, -0.065755
16.703333, -0.066618
16.706667, -0.068170
16.710000, -0.070004
16.713333, -0.071528
16.716667, -0.072346
16.720000, -0.072349
16.723333, -0.071707
16.726667, -0.070787
16.730000, -0.069886
16.733333, -0.069251
16.736667, -0.069079
16.740000, -0.069276
16.743333, -0.069571
16.746667, -0.069835
16.750000, -0.070084
16.753333, -0.070464
16.756667, -0.071065
16.760000, -0.071443
16.763333, -0.070859
16.766667, -0.069168
16.770000, -0.067048
16.773333, -0.065299
16.776667, -0.064230
16.780000, -0.063859
16.783333, -0.064351
16.786667, -0.065895
16.790000, -0.068320
16.793333, -0.071149
16.796667, -0.073953
16.800000, -0.076435
16.803333, -0.078292
16.806667, -0.079266
16.810000, -0.079355
16.813333, -0.078758
16.816667, -0.077739
16.820000, -0.076731
16.823333, -0.076121
16.826667, -0.075901
16.830000, -0.075779
16.833333, -0.075498
16.836667, -0.075074
16.840000, -0.074786
16.843333, -0.074852
16.846667, -0.075299
16.850000, -0.076258
16.853333, -0.077965
16.856667, -0.080409
16.860000, -0.083265
16.863333, -0.085911
16.866667, -0.087613
16.870000, -0.088118
16.873333, -0.087866
16.876667, -0.087605
16.880000, -0.087889
16.883333, -0.088687
16.886667, -0.089485
16.890000, -0.089957
16.893333, -0.090330
16.896667, -0.090925
16.900000, -0.091636
16.903333, -0.092279
16.906667, -0.092965
16.910000, -0.093696
16.913333, -0.094223
16.916667, -0.094553
16.920000, -0.095038
16.923333, -0.095818
16.926667, -0.096524
16.930000, -0.096632
16.933333, -0.095924
16.936667, -0.094612
16.940000, -0.093284
16.943333, -0.092630
16.946667, -0.092876
16.950000, -0.093554
16.953333, -0.094079
16.956667, -0.094423
16.960000, -0.094957
16.963333, -0.095914
16.966667, -0.097126
16.970000, -0.098253
16.973333, -0.099186
16.976667, -0.100018
16.980000, -0.100931
16.983333, -0.102229
16.986667, -0.103900
16.990000, -0.105187
16.993333, -0.105199
16.996667, -0.103859
17.000000, -0.102001
17.003333, -0.100682
17.006667, -0.100408
17.010000, -0.100979
17.013333, -0.101904
17.016667, -0.102701
17.020000, -0.103086
17.023333, -0.103314
17.026667, -0.103946
17.030000, -0.105127
17.033333, -0.106544
17.036667, -0.107890
17.040000, -0.108985
17.043333, -0.109724
17.046667, -0.110092
17.050000, -0.110089
17.053333, -0.109586
17.056667, -0.108527
17.060000, -0.107392
17.063333, -0.106993
17.066667, -0.107597
17.070000, -0.108595
17.073333, -0.109030
17.076667, -0.108440
17.080000, -0.107243
17.083333, -0.106183
17.086667, -0.105577
17.090000, -0.105250
17.093333, -0.105075
17.096667, -0.105232
17.100000, -0.105822
17.103333, -0.106620
17.106667, -0.107318
17.110000, -0.107706
17.113333, -0.107651
17.116667, -0.107108
17.120000, -0.106175
17.123333, -0.105149
17.126667, -0.104416
17.130000, -0.104131
17.133333, -0.104249
17.136667, -0.104833
17.140000, -0.105905
17.143333, -0.107086
17.146667, -0.107867
17.150000, -0.108077
17.153333, -0.107751
17.156667, -0.106940
17.160000, -0.105907
17.163333, -0.105045
17.166667, -0.104598
17.170000, -0.104693
17.173333, -0.105118
17.176667, -0.105173
17.180000, -0.104293
17.183333, -0.102590
17.186667, -0.100568
17.190000, -0.098609
17.193333, -0.096988
17.196667, -0.096028
17.200000, -0.095903
17.203333, -0.096488
17.206667, -0.097340
17.210000, -0.097865
17.213333, -0.097814
17.216667, -0.097563
17.220000, -0.097756
17.223333, -0.098599
17.226667, -0.099554
17.230000, -0.099869
17.233333, -0.099364
17.236667, -0.098593
17.240000, -0.098278
17.243333, -0.098569
17.246667, -0.098921
17.250000, -0.098675
17.253333, -0.097688
17.256667, -0.096417
17.260000, -0.095350
17.263333, -0.094574
17.266667, -0.093941
17.270000, -0.093254
17.273333, -0.092313
17.276667, -0.091145
17.280000, -0.090043
17.283333, -0.089389
17.286667, -0.089651
17.290000, -0.091174
17.293333, -0.093890
17.296667, -0.097336
17.300000, -0.100696
17.303333, -0.103081
17.306667, -0.104077
17.310000, -0.103865
17.313333, -0.102853
17.316667, -0.101413
17.320000, -0.099832
17.323333, -0.098370
17.326667, -0.097300
17.330000, -0.096686
17.333333, -0.096315
17.336667, -0.096076
17.340000, -0.096014
17.343333, -0.095994
17.346667, -0.095705
17.350000, -0.095044
17.353333, -0.094268
17.356667, -0.093773
17.360000, -0.093718
17.363333, -0.093864
17.366667, -0.093877
17.370000, -0.093627
17.373333, -0.093134
17.376667, -0.092551
17.380000, -0.092176
17.383333, -0.092133
17.386667, -0.092178
17.390000, -0.092022
17.393333, -0.091600
17.396667, -0.090816
17.400000, -0.089461
17.403333, -0.087736
17.406667, -0.086443
17.410000, -0.086320
17.413333, -0.087328
17.416667, -0.088639
17.420000, -0.089190
17.423333, -0.088388
17.426667, -0.086417
17.430000, -0.083973
17.433333, -0.081762
17.436667, -0.080312
17.440000, -0.080124
17.443333, -0.081565
17.446667, -0.084368
17.450000, -0.087604
17.453333, -0.090335
17.456667, -0.092062
17.460000, -0.092538
17.463333, -0.091595
17.466667, -0.089663
17.470000, -0.087986
17.473333, -0.087538
17.476667, -0.088119
17.480000, -0.089054
17.483333, -0.090165
17.486667, -0.091697
17.490000, -0.093642
17.493333, -0.095441
17.496667, -0.096519
17.500000, -0.096966
17.503333, -0.097272
17.506667, -0.097560
17.510000, -0.097481
17.513333, -0.096688
17.516667, -0.095331
17.520000, -0.094231
17.523333, -0.094261
17.526667, -0.095371
17.530000, -0.096627
17.533333, -0.097247
17.536667, -0.097070
17.540000, -0.096116
17.543333, -0.094479
17.546667, -0.092653
17.550000, -0.091320
17.553333, -0.090932
17.556667, -0.091613
17.560000, -0.093147
17.563333, -0.095058
17.566667, -0.096838
17.570000, -0.098141
17.573333, -0.098733
17.576667, -0.098333
17.580000, -0.096808
17.583333, -0.094555
17.586667, -0.092302
17.590000, -0.090540
17.593333, -0.089430
17.596667, -0.088966
17.600000, -0.089005
17.603333, -0.089388
17.606667, -0.090116
17.610000, -0.091220
17.613333, -0.092504
17.616667, -0.093547
17.620000, -0.093951
17.623333, -0.093733
17.626667, -0.093520
17.630000, -0.094051
17.633333, -0.095381
17.636667, -0.096823
17.640000, -0.097585
17.643333, -0.097384
17.646667, -0.096578
17.650000, -0.095657
17.653333, -0.094824
17.656667, -0.094271
17.660000, -0.094487
17.663333, -0.095963
17.666667, -0.098572
17.670000, -0.101412
17.673333, -0.103530
17.676667, -0.104711
17.680000, -0.105311
17.683333, -0.105564
17.686667, -0.105319
17.690000, -0.104240
17.693333, -0.102176
17.696667, -0.099637
17.700000, -0.097686
17.703333, -0.097147
17.706667, -0.098055
17.710000, -0.099731
17.713333, -0.101276
17.716667, -0.102141
17.720000, -0.102340
17.723333, -0.102285
17.726667, -0.102509
17.730000, -0.103468
17.733333, -0.105212
17.736667, -0.107251
17.740000, -0.109140
17.743333, -0.110788
17.746667, -0.112091
17.750000, -0.112884
17.753333, -0.113143
17.756667, -0.112951
17.760000, -0.112480
17.763333, -0.111831
17.766667, -0.110828
17.770000, -0.109367
17.773333, -0.107919
17.776667, -0.107245
17.780000, -0.107690
17.783333, -0.109057
17.786667, -0.110937
17.790000, -0.112818
17.793333, -0.114120
17.796667, -0.114451
17.800000, -0.113865
17.803333, -0.112776
17.806667, -0.111668
17.810000, -0.110873
17.813333, -0.110387
17.816667, -0.109880
17.820000, -0.109003
17.823333, -0.107684
17.826667, -0.106246
17.830000, -0.105089
17.833333, -0.104324
17.836667, -0.104029
17.840000, -0.104485
17.843333, -0.105939
17.846667, -0.108475
17.850000, -0.111847
17.853333, -0.115071
17.856667, -0.116641
17.860000, -0.115639
17.863333, -0.112632
17.866667, -0.109272
17.870000, -0.106934
17.873333, -0.105880
17.876667, -0.105639
17.880000, -0.105749
17.883333, -0.105959
17.886667, -0.105982
17.890000, -0.105534
17.893333, -0.104643
17.896667, -0.103742
17.900000, -0.103463
17.903333, -0.104187
17.906667, -0.105757
17.910000, -0.107656
17.913333, -0.109469
17.916667, -0.111281
17.920000, -0.113456
17.923333, -0.115796
17.926667, -0.117300
17.930000, -0.117037
17.933333, -0.115037
17.936667, -0.112176
17.940000, -0.109537
17.943333, -0.107914
17.946667, -0.107437
17.950000, -0.107518
17.953333, -0.107388
17.956667, -0.106674
17.960000, -0.105441
17.963333, -0.104047
17.966667, -0.102927
17.970000, -0.102285
17.973333, -0.102196
17.976667, -0.102845
17.980000, -0.104259
17.983333, -0.106070
17.986667, -0.107727
17.990000, -0.108759
17.993333, -0.108847
17.996667, -0.108021
18.000000, -0.106775
18.003333, -0.105434
18.006667, -0.103650
18.010000, -0.101173
18.013333, -0.098640
18.016667, -0.097014
18.020000, -0.096607
18.023333, -0.097120
18.026667, -0.098300
18.030000, -0.099944
18.033333, -0.101555
18.036667, -0.102544
18.040000, -0.102656
18.043333, -0.102230
18.046667, -0.102010
18.050000, -0.102474
18.053333, -0.103421
18.056667, -0.104180
18.060000, -0.104106
18.063333, -0.102967
18.066667, -0.101039
18.070000, -0.098960
18.073333, -0.097510
18.076667, -0.097410
18.080000, -0.098955
18.083333, -0.101486
18.086667, -0.103651
18.090000, -0.104606
18.093333, -0.104521
18.096667, -0.103979
18.100000, -0.103578
18.103333, -0.103854
18.106667, -0.104864
18.110000, -0.105934
18.113333, -0.106193
18.116667, -0.105388
18.120000, -0.104066
18.123333, -0.102974
18.126667, -0.102462
18.130000, -0.102436
18.133333, -0.102546
18.136667, -0.102395
18.140000, -0.101783
18.143333, -0.100900
18.146667, -0.100274
18.150000, -0.100311
18.153333, -0.100875
18.156667, -0.101464
18.160000, -0.101609
18.163333, -0.101241
18.166667, -0.100746
18.170000, -0.100380
18.173333, -0.100027
18.176667, -0.099791
18.180000, -0.100100
18.183333, -0.101038
18.186667, -0.102135
18.190000, -0.102859
18.193333, -0.103013
18.196667, -0.102810
18.200000, -0.102661
18.203333, -0.102752
18.206667, -0.103068
18.210000, -0.103638
18.213333, -0.104361
18.216667, -0.104966
18.220000, -0.105310
18.223333, -0.105328
18.226667, -0.104972
18.230000, -0.104459
18.233333, -0.104203
18.236667, -0.104352
18.240000, -0.104672
18.243333, -0.104866
18.246667, -0.104763
18.250000, -0.104408
18.253333, -0.104119
18.256667, -0.104199
18.260000, -0.104569
18.263333, -0.104875
18.266667, -0.104838
18.270000, -0.104398
18.273333, -0.103718
18.276667, -0.103158
18.280000, -0.103054
18.283333, -0.103541
18.286667, -0.104475
18.290000, -0.105396
18.293333, -0.105843
18.296667, -0.105764
18.300000, -0.105489
18.303333, -0.105373
18.306667, -0.105590
18.310000, -0.106166
18.313333, -0.107079
18.316667, -0.108208
18.320000, -0.109197
18.323333, -0.109642
18.326667, -0.109329
18.330000, -0.108120
18.333333, -0.105971
18.336667, -0.103186
18.340000, -0.100465
18.343333, -0.098611
18.346667, -0.098127
18.350000, -0.099016
18.353333, -0.100698
18.356667, -0.102317
18.360000, -0.103440
18.363333, -0.104226
18.366667, -0.104929
18.370000, -0.105479
18.373333, -0.105536
18.376667, -0.105001
18.380000, -0.104365
18.383333, -0.104377
18.386667, -0.105338
18.390000, -0.106791
18.393333, -0.107884
18.396667, -0.107952
18.400000, -0.106830
18.403333, -0.104764
18.406667, -0.102221
18.410000, -0.099912
18.413333, -0.098620
18.416667, -0.098586
18.420000, -0.099378
18.423333, -0.100445
18.426667, -0.101396
18.430000, -0.102033
18.433333, -0.102514
18.436667, -0.103218
18.440000, -0.104273
18.443333, -0.105274
18.446667, -0.105591
18.450000, -0.104980
18.453333, -0.103788
18.456667, -0.102650
18.460000, -0.101936
18.463333, -0.101553
18.466667, -0.101339
18.470000, -0.101235
18.473333, -0.101129
18.476667, -0.101015
18.480000, -0.101040
18.483333, -0.101293
18.486667, -0.101799
18.490000, -0.102517
18.493333, -0.103219
18.496667, -0.103605
18.500000, -0.103554
18.503333, -0.103194
18.506667, -0.102775
18.510000, -0.102403
18.513333, -0.101929
18.516667, -0.101107
18.520000, -0.099860
18.523333, -0.098433
18.526667, -0.097269
18.530000, -0.096711
18.533333, -0.096950
18.536667, -0.097990
18.540000, -0.099692
18.543333, -0.102003
18.546667, -0.104648
18.550000, -0.106921
18.553333, -0.108311
18.556667, -0.108920
18.560000, -0.109168
18.563333, -0.109268
18.566667, -0.109018
18.570000, -0.108323
18.573333, -0.107575
18.576667, -0.107216
18.580000, -0.107271
18.583333, -0.107342
18.586667, -0.106913
18.590000, -0.105767
18.593333, -0.104215
18.596667, -0.102804
18.600000, -0.101836
18.603333, -0.101392
18.606667, -0.101553
18.610000, -0.102205
18.613333, -0.102853
18.616667, -0.102819
18.620000, -0.101744
18.623333, -0.099981
18.626667, -0.098350
18.630000, -0.097461
18.633333, -0.097416
18.636667, -0.098080
18.640000, -0.099173
18.643333, -0.100145
18.646667, -0.100550
18.650000, -0.100426
18.653333, -0.099960
18.656667, -0.099164
18.660000, -0.098034
18.663333, -0.096687
18.666667, -0.095290
18.670000, -0.094001
18.673333, -0.092876
18.676667, -0.091884
18.680000, -0.091133
18.683333, -0.090675
18.686667, -0.090183
18.690000, -0.089257
18.693333, -0.087894
18.696667, -0.086460
18.700000, -0.085335
18.703333, -0.084748
18.706667, -0.084877
18.710000, -0.085776
18.713333, -0.087146
18.716667, -0.088469
18.720000, -0.089556
18.723333, -0.090673
18.726667, -0.091938
18.730000, -0.092864
18.733333, -0.092816
18.736667, -0.091708
18.740000, -0.090033
18.743333, -0.088445
18.746667, -0.087411
18.750000, -0.087130
18.753333, -0.087523
18.756667, -0.088077
18.760000, -0.088167
18.763333, -0.087657
18.766667, -0.086810
18.770000, -0.085908
18.773333, -0.085180
18.776667, -0.084677
18.780000, -0.084317
18.783333, -0.084123
18.786667, -0.084202
18.790000, -0.084507
18.793333, -0.084828
18.796667, -0.085039
18.800000, -0.085129
18.803333, -0.085120
18.806667, -0.085242
18.810000, -0.085983
18.813333, -0.087626
18.816667, -0.089783
18.820000, -0.091677
18.823333, -0.092917
18.826667, -0.093829
18.830000, -0.094825
18.833333, -0.095611
18.836667, -0.095522
18.840000, -0.094509
18.843333, -0.093200
18.846667, -0.092153
18.850000, -0.091445
18.853333, -0.090769
18.856667, -0.089790
18.860000, -0.088607
18.863333, -0.087862
18.866667, -0.088219
18.870000, -0.089741
18.873333, -0.091867
18.876667, -0.093881
18.880000, -0.095268
18.883333, -0.095800
18.886667, -0.095359
18.890000, -0.093862
18.893333, -0.091642
18.896667, -0.089450
18.900000, -0.087820
18.903333, -0.086863
18.906667, -0.086522
18.910000, -0.086619
18.913333, -0.086935
18.916667, -0.087454
18.920000, -0.088322
18.923333, -0.089578
18.926667, -0.090999
18.930000, -0.092157
18.933333, -0.092740
18.936667, -0.092865
18.940000, -0.092854
18.943333, -0.092552
18.946667, -0.091270
18.950000, -0.088834
18.953333, -0.086249
18.956667, -0.084785
18.960000, -0.084770
18.963333, -0.085709
18.966667, -0.086911
18.970000, -0.087825
18.973333, -0.088357
18.976667, -0.088866
18.980000, -0.089807
18.983333, -0.091423
18.986667, -0.093513
18.990000, -0.095501
18.993333, -0.096761
18.996667, -0.096872
19.000000, -0.096034
19.003333, -0.095273
19.006667, -0.095538
19.010000, -0.096745
19.013333, -0.098125
19.016667, -0.099231
19.020000, -0.100309
19.023333, -0.101863
19.026667, -0.104063
19.030000, -0.106528
19.033333, -0.108410
19.036667, -0.108832
19.040000, -0.107593
19.043333, -0.105478
19.046667, -0.103676
19.050000, -0.102944
19.053333, -0.103492
19.056667, -0.105309
19.060000, -0.108063
19.063333, -0.111073
19.066667, -0.113771
19.070000, -0.115996
19.073333, -0.117744
19.076667, -0.118835
19.080000, -0.119175
19.083333, -0.119185
19.086667, -0.119513
19.090000, -0.120421
19.093333, -0.121594
19.096667, -0.122472
19.100000, -0.122751
19.103333, -0.122492
19.106667, -0.121914
19.110000, -0.121341
19.113333, -0.121096
19.116667, -0.121291
19.120000, -0.121913
19.123333, -0.123014
19.126667, -0.124681
19.130000, -0.126766
19.133333, -0.128738
19.136667, -0.129967
19.140000, -0.130142
19.143333, -0.129398
19.146667, -0.128218
19.150000, -0.127170
19.153333, -0.126494
19.156667, -0.125996
19.160000, -0.125492
19.163333, -0.125157
19.166667, -0.125391
19.170000, -0.126470
19.173333, -0.128055
19.176667, -0.129240
19.180000, -0.129479
19.183333, -0.129010
19.186667, -0.128299
19.190000, -0.127643
19.193333, -0.127301
19.196667, -0.127508
19.200000, -0.128335
19.203333, -0.129555
19.206667, -0.130606
19.210000, -0.130986
19.213333, -0.130709
19.216667, -0.130107
19.220000, -0.129434
19.223333, -0.128839
19.226667, -0.128455
19.230000, -0.128377
19.233333, -0.128729
19.236667, -0.129700
19.240000, -0.131332
19.243333, -0.133349
19.246667, -0.135180
19.250000, -0.136112
19.253333, -0.135738
19.256667, -0.134180
19.260000, -0.131866
19.263333, -0.129541
19.266667, -0.128045
19.270000, -0.127532
19.273333, -0.127270
19.276667, -0.126525
19.280000, -0.125415
19.283333, -0.124473
19.286667, -0.123655
19.290000, -0.122554
19.293333, -0.121246
19.296667, -0.120248
19.300000, -0.119952
19.303333, -0.120270
19.306667, -0.120768
19.310000, -0.121184
19.313333, -0.121583
19.316667, -0.122028
19.320000, -0.122377
19.323333, -0.122468
19.326667, -0.122315
19.330000, -0.122085
19.333333, -0.121881
19.336667, -0.121613
19.340000, -0.121158
19.343333, -0.120407
19.346667, -0.119296
19.350000, -0.118085
19.353333, -0.117241
19.356667, -0.116821
19.360000, -0.116466
19.363333, -0.115937
19.366667, -0.115151
19.370000, -0.113979
19.373333, -0.112398
19.376667, -0.110625
19.380000, -0.109036
19.383333, -0.108190
19.386667, -0.108633
19.390000, -0.110152
19.393333, -0.111566
19.396667, -0.111737
19.400000, -0.110499
19.403333, -0.108511
19.406667, -0.106742
19.410000, -0.106085
19.413333, -0.106971
19.416667, -0.109268
19.420000, -0.112364
19.423333, -0.115237
19.426667, -0.116908
19.430000, -0.117031
19.433333, -0.115949
19.436667, -0.114133
19.440000, -0.111724
19.443333, -0.108862
19.446667, -0.106167
19.450000, -0.104533
19.453333, -0.104547
19.456667, -0.106093
19.460000, -0.108342
19.463333, -0.110155
19.466667, -0.110757
19.470000, -0.110294
19.473333, -0.109605
19.476667, -0.109416
19.480000, -0.109964
19.483333, -0.111161
19.486667, -0.112675
19.490000, -0.113919
19.493333, -0.114252
19.496667, -0.113382
19.500000, -0.111634
19.503333, -0.109777
19.506667, -0.108429
19.510000, -0.107648
19.513333, -0.107246
19.516667, -0.107192
19.520000, -0.107584
19.523333, -0.108424
19.526667, -0.109415
19.530000, -0.110236
19.533333, -0.111068
19.536667, -0.112488
19.540000, -0.114860
19.543333, -0.117916
19.546667, -0.120859
19.550000, -0.122838
19.553333, -0.123472
19.556667, -0.123223
19.560000, -0.123102
19.563333, -0.123753
19.566667, -0.124925
19.570000, -0.125783
19.573333, -0.125688
19.576667, -0.124632
19.580000, -0.122862
19.583333, -0.120597
19.586667, -0.118429
19.590000, -0.117191
19.593333, -0.117025
19.596667, -0.117242
19.600000, -0.117160
19.603333, -0.116549
19.606667, -0.115538
19.610000, -0.114516
19.613333, -0.113890
19.616667, -0.113756
19.620000, -0.113825
19.623333, -0.113781
19.626667, -0.113740
19.630000, -0.114039
19.633333, -0.114534
19.636667, -0.114716
19.640000, -0.114269
19.643333, -0.113182
19.646667, -0.111964
19.650000, -0.111558
19.653333, -0.112431
19.656667, -0.114185
19.660000, -0.116212
19.663333, -0.118081
19.666667, -0.119337
19.670000, -0.119585
19.673333, -0.118819
19.676667, -0.117338
19.680000, -0.115515
19.683333, -0.113679
19.686667, -0.112069
19.690000, -0.110870
19.693333, -0.110187
19.696667, -0.110024
19.700000, -0.110484
19.703333, -0.111667
19.706667, -0.113393
19.710000, -0.115378
19.713333, -0.117391
19.716667, -0.119096
19.720000, -0.120156
19.723333, -0.120516
19.726667, -0.120355
19.730000, -0.119769
19.733333, -0.118655
19.736667, -0.116904
19.740000, -0.114637
19.743333, -0.112271
19.746667, -0.110312
19.750000, -0.109054
19.753333, -0.108459
19.756667, -0.108340
19.760000, -0.108516
19.763333, -0.108784
19.766667, -0.108962
19.770000, -0.109024
19.773333, -0.109027
19.776667, -0.108936
19.780000, -0.108573
19.783333, -0.107740
19.786667, -0.106537
19.790000, -0.105432
19.793333, -0.104842
19.796667, -0.104869
19.800000, -0.105379
19.803333, -0.106033
19.806667, -0.106332
19.810000, -0.105886
19.813333, -0.104753
19.816667, -0.103416
19.820000, -0.102414
19.823333, -0.102158
19.826667, -0.102917
19.830000, -0.104702
19.833333, -0.107228
19.836667, -0.110046
19.840000, -0.112589
19.843333, -0.114203
19.846667, -0.114557
19.850000, -0.113884
19.853333, -0.112589
19.856667, -0.110952
19.860000, -0.109416
19.863333, -0.108636
19.866667, -0.108928
19.870000, -0.110064
19.873333, -0.111619
19.876667, -0.113204
19.880000, -0.114450
19.883333, -0.115061
19.886667, -0.115073
19.890000, -0.114901
19.893333, -0.115009
19.896667, -0.115641
19.900000, -0.116792
19.903333, -0.118232
19.906667, -0.119558
19.910000, -0.120498
19.913333, -0.121303
19.916667, -0.122680
19.920000, -0.125096
19.923333, -0.128304
19.926667, -0.131539
19.930000, -0.134007
19.933333, -0.135379
19.936667, -0.135949
19.940000, -0.136233
19.943333, -0.136496
19.946667, -0.136821
19.950000, -0.137358
19.953333, -0.138069
19.956667, -0.138481
19.960000, -0.138041
19.963333, -0.136645
19.966667, -0.134879
19.970000, -0.133718
19.973333, -0.133755
19.976667, -0.134760
19.980000, -0.136128
19.983333, -0.137612
19.986667, -0.139575
19.990000, -0.142386
19.993333, -0.145656
19.996667, -0.148477
20.000000, -0.150280


##END=




##END=




`;

export default hplcUVVisJcamp2;
